/// <amd-module name="typeahead/core/ConfigurableFeature" />
define("typeahead/core/ConfigurableFeature", ["require", "exports", "typeahead/core/plugins/ExecutionHelper"], function (require, exports, ExecutionHelper) {
    "use strict";
    exports.__esModule = true;
    var ConfigurableFeature = (function () {
        function ConfigurableFeature() {
        }
        ConfigurableFeature.getFeatureOverrides = function ($input) {
            var featuresOverrides = {};
            var featureOverrideString = $input.data("feature-overrides");
            if (featureOverrideString) {
                var featureStrings = featureOverrideString.split("|");
                if (featureStrings) {
                    for (var _i = 0, featureStrings_1 = featureStrings; _i < featureStrings_1.length; _i++) {
                        var featureString = featureStrings_1[_i];
                        var splitIndex = featureString.indexOf(":");
                        if (splitIndex !== -1) {
                            var key = featureString.substring(0, splitIndex);
                            var val = featureString.substring(splitIndex + 1, featureString.length);
                            featuresOverrides[key] = val;
                        }
                    }
                }
            }
            return featuresOverrides;
        };
        ConfigurableFeature.prototype.shouldOverride = function (options) {
            var deferred = $.Deferred();
            var overrideValue = this.getOverrideValue(options);
            if (!overrideValue) {
                return deferred.reject().promise();
            }
            if (this.isOverrideToOn(overrideValue)) {
                return deferred.resolve(true).promise();
            }
            if (this.isOverrideToOff(overrideValue)) {
                return deferred.resolve(false).promise();
            }
            if (overrideValue.indexOf("=") !== -1) {
                var split = overrideValue.split("=");
                if (split.length === 2) {
                    var key = split[0];
                    var val = split[1];
                    switch (key) {
                        case "@experiment":
                            return this.checkExperiment(val, deferred);
                        default:
                            break;
                    }
                }
            }
            return deferred.reject().promise();
        };
        ConfigurableFeature.prototype.isOverrideToOn = function (overrideValue) {
            return overrideValue === "on";
        };
        ConfigurableFeature.prototype.isOverrideToOff = function (overrideValue) {
            return overrideValue === "off";
        };
        ConfigurableFeature.prototype.checkExperiment = function (experimentName, deferred) {
            var experiment = {
                id: 0,
                name: experimentName
            };
            ExecutionHelper.evaluateExperiment(experiment, deferred);
            return deferred.promise();
        };
        ConfigurableFeature.prototype.getOverrideValue = function (options) {
            return options && options.featureOverrides && this.featureName && options.featureOverrides[this.featureName];
        };
        return ConfigurableFeature;
    }());
    exports.ConfigurableFeature = ConfigurableFeature;
});



/// <amd-module name="typeahead/core/EmptyQueryDataProvider" />
/// <amd-dependency path="jquery" name="$"/>
define("typeahead/core/EmptyQueryDataProvider", ["require", "exports", "jquery", "typeahead/core/EmptyQueryRequestGenerator"], function (require, exports, $, EmptyQueryRequestGenerator_1) {
    "use strict";
    exports.__esModule = true;
    var EmptyQueryDataProvider = (function () {
        function EmptyQueryDataProvider() {
        }
        EmptyQueryDataProvider.prototype.fetchData = function (options) {
            var opts = options.options;
            var context = options.context;
            var urlOpts = { serviceUrl: context.serviceUrl };
            return new EmptyQueryRequestGenerator_1.EmptyQueryRequestGenerator(EmptyQueryRequestGenerator_1.EmptyQueryRequestGenerator.ESS_ABACUS_IDS, urlOpts)
                .makeRequest("", opts, context).then(this.onSuccess, this.onError);
        };
        EmptyQueryDataProvider.prototype.onSuccess = function (json) {
            return json.sr ? { results: json.sr } : (json.r ? { results: json.r } : { results: [] });
        };
        EmptyQueryDataProvider.prototype.onError = function () {
            return { results: [] };
        };
        return EmptyQueryDataProvider;
    }());
    exports.EmptyQueryDataProvider = EmptyQueryDataProvider;
});



/// <amd-module name="typeahead/core/EmptyQueryRequestGenerator" />
/// <amd-dependency path="jquery" name="$"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/EmptyQueryRequestGenerator", ["require", "exports", "jquery", "typeahead/core/RequestGenerator"], function (require, exports, $, RequestGenerator_1) {
    "use strict";
    exports.__esModule = true;
    function getQueryParams(options, context) {
        return {
            categories: "USERHISTORY|FLIGHTSBOOKING",
            client: context.clientId,
            expuserid: context.expuserid,
            format: "jsonp",
            guid: context.guid,
            locale: context.locale,
            maxresults: options.maxresults,
            siteid: context.siteid
        };
    }
    ;
    var EmptyQueryRequestGenerator = (function (_super) {
        __extends(EmptyQueryRequestGenerator, _super);
        function EmptyQueryRequestGenerator(essAbacusIds, suggestServiceUrlOptions) {
            return _super.call(this, essAbacusIds, undefined, suggestServiceUrlOptions, undefined, undefined) || this;
        }
        EmptyQueryRequestGenerator.prototype.makeRequest = function (srchText, options, context) {
            var url = this.constructEssUrl(srchText);
            var requestParameters = getQueryParams(options, context);
            if (!EmptyQueryRequestGenerator.responsePromiseCache ||
                !_.isEqual(EmptyQueryRequestGenerator.responsePromiseCache.requestParameters, requestParameters)) {
                EmptyQueryRequestGenerator.responsePromiseCache = {
                    requestParameters: requestParameters,
                    responsePromise: $.ajax({
                        data: getQueryParams(options, context),
                        dataType: "jsonp",
                        timeout: 1000,
                        url: url
                    })
                };
            }
            return EmptyQueryRequestGenerator.responsePromiseCache.responsePromise;
        };
        return EmptyQueryRequestGenerator;
    }(RequestGenerator_1.RequestGenerator));
    exports.EmptyQueryRequestGenerator = EmptyQueryRequestGenerator;
    /**
     * Function to allow the caller to provide the version of jQuery they want to use
     * and not rely on the page load time AMD module loader to provide one. This facilitates
     * unit testing so you can mock/stub/fake the jQuery functionality used in here.
     * @param jQuery
     */
    function overrideJQuery(jQuery) {
        $ = jQuery;
    }
    exports.overrideJQuery = overrideJQuery;
});



/// <amd-module name="typeahead/core/EssDataProvider" />
/// <amd-dependency path="jquery" name="$" />
/// <amd-dependency path="underscore" name="_" />
define("typeahead/core/EssDataProvider", ["require", "exports", "jquery", "underscore", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger"], function (require, exports, $, _, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1) {
    /// <reference path="../../typings/typeahead/browser.d.ts" />
    /// <reference path="../../typings/typeahead/modulizr.d.ts" />
    /// <reference path="../../typings/typeahead/plugins.d.ts" />
    "use strict";
    exports.__esModule = true;
    var GoogleRequestType;
    (function (GoogleRequestType) {
        GoogleRequestType[GoogleRequestType["GOOGLE_AUTOCOMPLETE"] = 0] = "GOOGLE_AUTOCOMPLETE";
        GoogleRequestType[GoogleRequestType["ADDRESS_AUTOCOMPLETE"] = 1] = "ADDRESS_AUTOCOMPLETE";
    })(GoogleRequestType = exports.GoogleRequestType || (exports.GoogleRequestType = {}));
    var EssDataProvider = (function () {
        function EssDataProvider() {
        }
        EssDataProvider.isReferralToGoogleMaps = function (responseCode) {
            return ([GoogleRequestType[GoogleRequestType.ADDRESS_AUTOCOMPLETE],
                GoogleRequestType[GoogleRequestType.GOOGLE_AUTOCOMPLETE]].indexOf(responseCode) > -1);
        };
        /**
         * Function that given a search query string, a flag for ignoring results (used as a seed call)
         * and a set of options, returns a Promise that when it resolves contains an object with two properties.
         *  1) a results list containing all the items returned from the call
         *  2) the original search query used to make the HTTP request(s)
         * @param srchText - search query string
         * @param ignoreResults - fire the request and ignore the response
         * @param options - object hash containing the list of options.
         * @param $ - reference to jQuery instance to use
         * NOTE: the required properties for the options hash are:
         *  {
         *    additionalDataSourceUrl: "",
         *    version: "v2",
         *    overrideServiceUrl: "",
         *    serviceUrl: "//suggest.expedia.com",
         *    mask: defaultMask,
         *    locale: "en_US",
         *    abtest: "",
         *    lob: LOB_ATTRIBUTE.FLIGHTS,
         *    dest: false,
         *    maxitems: 20,
         *    clientId: "",
         *    siteId: "",
         *    guid: "",
         *    features: ""
         *  }
         * @returns an instance of a Promise
         */
        EssDataProvider.prototype.fetchData = function (options) {
            var optionalServicePromise;
            var requestGenerator = options.requestGenerator;
            var isDualRequest = options.additionalDataSourceUrl ? true : false;
            var context = options.context;
            var essServicePromise = requestGenerator.makeRequest(options.srchText, options, context);
            if (options.overrideDataRequest && typeof options.overrideDataRequest === "function") {
                return options.overrideDataRequest(options.srchText)
                    .then(this.singleSourceResponseHandler);
            }
            if (options.ignoreResults) {
                return essServicePromise.then($.noop);
            }
            if (isDualRequest) {
                optionalServicePromise = requestGenerator.makeRequest(options.srchText, $.extend(options, { isSecondary: true }), context);
                // jQuery $.when() is akin to Promise.all() fetching results from two Ajax calls here
                return $.when(optionalServicePromise, essServicePromise)
                    .then(this.dualSourceResponseHandler, this.dualSourceErrorResponseHandler);
            }
            return essServicePromise.then(this.singleSourceResponseHandler);
        };
        EssDataProvider.prototype.dualSourceResponseHandler = function (jsonResponseData1, jsonResponseData2) {
            // jsonResponseData1 and jsonResponseData2 are arguments resolved for two ajax requests, respectively.
            // Each argument is an array with the following structure: [ data, statusText, jqXHR ]
            // so jsonResponseData1[0] and jsonResponseData2[0] are the data from each Promise/Deferred
            var combinedResults = [];
            var query = jsonResponseData1[0].q; // both searches use the same srchTerm
            if (jsonResponseData1[0] && jsonResponseData1[0].sr) {
                combinedResults = combinedResults.concat(jsonResponseData1[0].sr);
            }
            if (jsonResponseData2[0] && jsonResponseData2[0].sr) {
                combinedResults = combinedResults.concat(jsonResponseData2[0].sr);
            }
            else if (jsonResponseData2[0] && jsonResponseData2[0].r) {
                combinedResults = combinedResults.concat(jsonResponseData2[0].r);
            }
            var combinedResponseCode = jsonResponseData1[0].rc + "|" + jsonResponseData2[0].rc;
            var activeABTests = _.compact([jsonResponseData1[0].activeABTests,
                jsonResponseData2[0].activeABTests]).join("|");
            return {
                isReferralToGoogleMaps: EssDataProvider.isReferralToGoogleMaps(combinedResponseCode),
                query: query,
                responseCode: combinedResponseCode, activeABTests: activeABTests,
                results: (combinedResults || [])
            };
        };
        EssDataProvider.prototype.dualSourceErrorResponseHandler = function () {
            TypeaheadErrorLogger_1["default"].log(new Error("Dual HTTP request failure handler. Called with " + arguments.length +
                " inputs"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.ExpediaSuggestService);
        };
        EssDataProvider.prototype.singleSourceResponseHandler = function (jsonResponseData) {
            var results = jsonResponseData.sr ? jsonResponseData.sr : jsonResponseData.r;
            var query = jsonResponseData.q;
            return {
                activeABTests: jsonResponseData.activeABTests,
                isReferralToGoogleMaps: EssDataProvider.isReferralToGoogleMaps(jsonResponseData.rc),
                query: query,
                responseCode: jsonResponseData.rc,
                results: (results || [])
            };
        };
        return EssDataProvider;
    }());
    exports.EssDataProvider = EssDataProvider;
    /**
     * Function to allow the caller to provide the version of jQuery they want to use
     * and not rely on the page load time AMD module loader to provide one. This facilitates
     * unit testing so you can mock/stub/fake the jQuery functionality used in here.
     * @param jQuery
     */
    function overrideJQuery(jQuery) {
        $ = jQuery;
    }
    exports.overrideJQuery = overrideJQuery;
});



/// <amd-module name="typeahead/core/EssSuggestion"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/EssSuggestion", ["require", "exports", "typeahead/core/Suggestion", "typeahead/core/util/Optional"], function (require, exports, Suggestion_1, Optional_1) {
    "use strict";
    exports.__esModule = true;
    var EssSuggestion = (function (_super) {
        __extends(EssSuggestion, _super);
        function EssSuggestion() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EssSuggestion.prototype.getSourceName = function () {
            return Optional_1.Optional.ofNullable(this.getEssId().isPresent() ? this.getEssId().get().sourceName : undefined);
        };
        EssSuggestion.prototype.getSourceId = function () {
            return Optional_1.Optional.ofNullable(this.getEssId().isPresent() ? this.getEssId().get().sourceId : undefined);
        };
        EssSuggestion.prototype.getRegionId = function () {
            return Optional_1.Optional.ofNullable(this.data.gaiaId);
        };
        EssSuggestion.prototype.getTla = function () {
            return Optional_1.Optional.ofNullable(this.data.hierarchyInfo && this.data.hierarchyInfo.airport ?
                this.data.hierarchyInfo.airport.airportCode : undefined);
        };
        EssSuggestion.prototype.getSuggestionHierarchyType = function () {
            return Optional_1.Optional.of(this.data.hierarchyInfo ?
                (this.data.hierarchyInfo.isChild === "true" ? "child" : "parent") : "parent");
        };
        EssSuggestion.prototype.getRelationInfo = function () {
            return Optional_1.Optional.of(this.data.hierarchyInfo && this.data.hierarchyInfo.relation &&
                this.data.hierarchyInfo.relation.length > 0 ? this.data.hierarchyInfo.relation[0] : "-");
        };
        EssSuggestion.prototype.getHotelId = function () {
            return Optional_1.Optional.ofNullable(this.getEssId().isPresent() && this.getEssId().get().sourceName === "LCM" ?
                this.getEssId().get().sourceId : undefined);
        };
        EssSuggestion.prototype.getTypeId = function () {
            return Optional_1.Optional.of(this.data.essId && this.data.essId.sourceId ? this.data.essId.sourceId : "-");
        };
        EssSuggestion.prototype.getCity = function () {
            return Optional_1.Optional.ofNullable(this.data.hotelAddress ? this.data.hotelAddress.city : undefined);
        };
        EssSuggestion.prototype.getMultiCity = function () {
            return Optional_1.Optional.of(this.data.hierarchyInfo.airport ?
                this.data.hierarchyInfo.airport.multicity : this.data.hierarchyInfo.multicity);
        };
        EssSuggestion.prototype.getSubType = function () {
            return Optional_1.Optional.ofNullable(this.data.subtype);
        };
        EssSuggestion.prototype.getStationCode = function () {
            return Optional_1.Optional.ofNullable(this.data.hierarchyInfo && this.data.hierarchyInfo.rails ?
                this.data.hierarchyInfo.rails.stationCode : undefined);
        };
        EssSuggestion.prototype.getCountryName = function () {
            return Optional_1.Optional.ofNullable(this.data.hierarchyInfo && this.data.hierarchyInfo.country ?
                this.data.hierarchyInfo.country.name : undefined);
        };
        EssSuggestion.prototype.getCountryIsoCode2 = function () {
            return Optional_1.Optional.ofNullable(this.data.hierarchyInfo && this.data.hierarchyInfo.country ?
                this.data.hierarchyInfo.country.isoCode2 : undefined);
        };
        EssSuggestion.prototype.getCountryIsoCode3 = function () {
            return Optional_1.Optional.ofNullable(this.data.hierarchyInfo && this.data.hierarchyInfo.country ?
                this.data.hierarchyInfo.country.isoCode3 : undefined);
        };
        /* returns an Optional containing either:
         * -- "true" if the selected suggestion is a HEDS (Hotel Expedia Doesn't Sell)
         * -- empty for all other selected suggestions
         * if "true", HEDS=true will be sent to HSRP
         * if empty, no query parameter will be sent
         */
        EssSuggestion.prototype.getIsHeds = function () {
            return this.getEssId().isPresent() && this.getEssId().get().sourceName === "TREX" ?
                Optional_1.Optional.ofNullable("true") :
                Optional_1.Optional.empty();
        };
        EssSuggestion.prototype.shouldTriggerDomElementChangeOnSelection = function () {
            return true;
        };
        EssSuggestion.prototype.getEssId = function () {
            return Optional_1.Optional.ofNullable(this.data.essId);
        };
        return EssSuggestion;
    }(Suggestion_1.Suggestion));
    exports.EssSuggestion = EssSuggestion;
});



/// <amd-module name="typeahead/core/ExpediaSuggestServiceRequestGenerator" />
/// <amd-dependency path="jquery" name="$"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/ExpediaSuggestServiceRequestGenerator", ["require", "exports", "jquery", "typeahead/core/RequestGenerator"], function (require, exports, $, RequestGenerator_1) {
    /// <reference path="../../typings/typeahead/browser.d.ts" />
    /// <reference path="../../typings/typeahead/modulizr.d.ts" />
    /// <reference path="../../typings/typeahead/window.d.ts" />
    /// <reference path="../../typings/typeahead/plugins.d.ts" />
    /// <reference path="../../typings/typeahead/ExpediaSuggestServiceRequestGenerator.d.ts" />
    "use strict";
    exports.__esModule = true;
    function getOptionalServiceUrl(options, srchText) {
        return [
            options.additionalDataSourceUrl,
            encodeURIComponent(srchText),
        ].join("");
    }
    function getQueryParams(requestParams, context) {
        var urlParams = {};
        // I think it makes sense to split the list of parameters into 2 groups
        // - parameters come from the context
        // - parameters come from the request params object that may or may not have features/tests
        // parameters from the context
        urlParams.client = context.clientId;
        urlParams.siteid = context.siteid;
        urlParams.guid = context.guid;
        urlParams.lob = context.lob;
        urlParams.locale = context.locale;
        urlParams.expuserid = context.expuserid;
        // parameters from the request params object
        urlParams.regiontype = requestParams.mask;
        urlParams.ab = requestParams.ab;
        urlParams.dest = requestParams.dest;
        urlParams.maxresults = requestParams.maxresults;
        urlParams.features = requestParams.features.join("|");
        urlParams.rid = requestParams.rid;
        urlParams.sortcriteria = requestParams.sortcriteria;
        urlParams.categories = requestParams.categories;
        // others
        urlParams.format = "jsonp";
        urlParams.device = requestParams.device;
        urlParams.browser = requestParams.browser;
        return urlParams;
    }
    function constructRequestParams(options) {
        var requestParams = {};
        requestParams.mask = options.mask;
        requestParams.ab = options.abtest;
        requestParams.format = options.format;
        requestParams.dest = options.dest;
        requestParams.maxresults = options.maxresults;
        requestParams.features = options.features || [];
        requestParams.device = options.device;
        requestParams.browser = options.browser;
        requestParams.rid = options.filter_region_id;
        return requestParams;
    }
    function applyRequestParamModifiers(plugins, context, parameters, options) {
        var deferred = $.Deferred();
        if (plugins.length > 0) {
            var modifiedParameterPromises = plugins.map(function (plugin) {
                return plugin.modifyParameters(parameters, context, options);
            });
            $.when.apply($, modifiedParameterPromises).done(function () {
                // we can just resolve
                deferred.resolve(parameters);
            });
        }
        else {
            deferred.resolve(parameters);
        }
        return deferred.promise();
    }
    var ExpediaSuggestServiceRequestGenerator = (function (_super) {
        __extends(ExpediaSuggestServiceRequestGenerator, _super);
        function ExpediaSuggestServiceRequestGenerator(essAbacusIds, variantAssigner, suggestServiceUrlOptions, siteid, pluginAssembly) {
            return _super.call(this, essAbacusIds, variantAssigner, suggestServiceUrlOptions, siteid, pluginAssembly) || this;
        }
        ExpediaSuggestServiceRequestGenerator.prototype.makeRequest = function (srchText, options, context) {
            var url;
            if (options.isSecondary) {
                url = getOptionalServiceUrl(options, srchText);
            }
            else {
                url = this.constructEssUrl(srchText);
            }
            var requestParams = constructRequestParams(options);
            var inputOptions = $.extend({}, options);
            return applyRequestParamModifiers(this.requestParamModifiers, context, requestParams, inputOptions)
                .then(function (modifiedParams) {
                return $.getJSON(url, getQueryParams(modifiedParams, context));
            }); // this is a promise that can be chain
        };
        return ExpediaSuggestServiceRequestGenerator;
    }(RequestGenerator_1.RequestGenerator));
    exports.ExpediaSuggestServiceRequestGenerator = ExpediaSuggestServiceRequestGenerator;
    /**
     * Function to allow the caller to provide the version of jQuery they want to use
     * and not rely on the page load time AMD module loader to provide one. This facilitates
     * unit testing so you can mock/stub/fake the jQuery functionality used in here.
     * @param jQuery
     */
    function overrideJQuery(jQuery) {
        $ = jQuery;
    }
    exports.overrideJQuery = overrideJQuery;
});



define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});



define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});



define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});



define("typeahead/core/IListItem", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    /// <amd-module name="typeahead/core/IListItem"/>
    var ListItemType;
    (function (ListItemType) {
        ListItemType[ListItemType["Label"] = 0] = "Label";
        ListItemType[ListItemType["Suggestion"] = 1] = "Suggestion";
    })(ListItemType = exports.ListItemType || (exports.ListItemType = {}));
    var LabelTypeListItem = (function () {
        function LabelTypeListItem(html) {
            this.html = html;
            this.listItemType = ListItemType.Label;
        }
        return LabelTypeListItem;
    }());
    exports.LabelTypeListItem = LabelTypeListItem;
});



define("typeahead/core/IOverrideParams", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});



define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});



/// <amd-module name="typeahead/core/OnFocusSuggester" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/OnFocusSuggester", ["require", "exports", "typeahead/core/SuggestionsAggregator"], function (require, exports, SuggestionsAggregator_1) {
    "use strict";
    exports.__esModule = true;
    var OnFocusSuggester = (function (_super) {
        __extends(OnFocusSuggester, _super);
        function OnFocusSuggester() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        OnFocusSuggester.prototype.getRecentHistorySuggesterConfig = function () {
            return {
                isEnabled: true,
                rank: 3
            };
        };
        OnFocusSuggester.prototype.getFlightBookingSuggesterConfig = function () {
            return {
                isEnabled: true,
                rank: 2
            };
        };
        OnFocusSuggester.prototype.getCurrentLocationSuggesterConfig = function () {
            return {
                isEnabled: true,
                rank: 1
            };
        };
        OnFocusSuggester.prototype.getId = function () {
            return SuggestionsAggregator_1.SuggesterId.OnFocusSuggester;
        };
        return OnFocusSuggester;
    }(SuggestionsAggregator_1.SuggestionsAggregator));
    exports.OnFocusSuggester = OnFocusSuggester;
});



/// <amd-module name="typeahead/core/RequestGenerator" />
/// <amd-dependency path="jquery" name="$"/>
define("typeahead/core/RequestGenerator", ["require", "exports", "jquery", "typeahead/core/plugins/DefaultPluginAssembly"], function (require, exports, $, DefaultPluginAssembly_1) {
    "use strict";
    exports.__esModule = true;
    var RequestGenerator = (function () {
        function RequestGenerator(essAbacusIds, variantAssigner, suggestServiceUrlOptions, siteid, pluginAssembly) {
            this.requestParamModifiers = [];
            this.essAbacusIds = essAbacusIds;
            this.variantAssigner = variantAssigner;
            this.suggestServiceUrlOptions = suggestServiceUrlOptions;
            if (pluginAssembly) {
                this.requestParamModifiers = pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.requestParamModifierIdentifier);
            }
        }
        RequestGenerator.defaultVariantAssigner = function (abacusId) {
            if (abacusId === void 0) { abacusId = undefined; }
            // if(searchExperiments){
            //     return searchExperiments.getSearchExperimentVariantIfParticipating;
            // }
            return undefined;
        };
        RequestGenerator.prototype.getVariantAssignment = function (abacusId) {
            if (typeof this.variantAssigner !== "function") {
                return undefined;
            }
            var variant = this.variantAssigner(abacusId);
            return variant === undefined ? undefined : "".concat(abacusId, ".", variant);
        };
        RequestGenerator.prototype.generateAbacusParameter = function () {
            var self = this;
            var abFieldValue = [];
            function getVariantAssignment(abacusId) {
                if (typeof self.getVariantAssignment === "function") {
                    return self.getVariantAssignment(abacusId);
                }
                else {
                    return undefined;
                }
            }
            $(this.essAbacusIds).each(function (index, abId) {
                var variantAssignment = getVariantAssignment(abId);
                if (variantAssignment) {
                    abFieldValue.push(variantAssignment);
                }
            });
            return abFieldValue.length > 0 ? abFieldValue.join("|") : "";
        };
        RequestGenerator.prototype.constructEssUrl = function (srchText) {
            var suggestServiceUrl = this.suggestServiceUrlOptions.suggestServiceUrl;
            if (this.suggestServiceUrlOptions.overrideServiceUrl) {
                suggestServiceUrl = [
                    this.suggestServiceUrlOptions.overrideServiceUrl,
                    encodeURIComponent(srchText),
                ].join("");
            }
            else {
                suggestServiceUrl = [
                    this.suggestServiceUrlOptions.serviceUrl,
                    "/api/v4/typeahead/",
                    encodeURIComponent(srchText),
                    "?callback=?",
                ].join("");
            }
            return suggestServiceUrl;
        };
        RequestGenerator.ESS_ABACUS_IDS = [];
        return RequestGenerator;
    }());
    exports.RequestGenerator = RequestGenerator;
    /**
     * Function to allow the caller to provide the version of jQuery they want to use
     * and not rely on the page load time AMD module loader to provide one. This facilitates
     * unit testing so you can mock/stub/fake the jQuery functionality used in here.
     * @param jQuery
     */
    function overrideJQuery(jQuery) {
        $ = jQuery;
    }
    exports.overrideJQuery = overrideJQuery;
});



/// <amd-module name="typeahead/core/SearchParametersUpdater"/>
define("typeahead/core/SearchParametersUpdater", ["require", "exports", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger"], function (require, exports, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1) {
    "use strict";
    exports.__esModule = true;
    var featureExtractorByElement = {
        airport_code_element: "getTla",
        category_element: "getCategory",
        city_element: "getCity",
        country_code_element: "getCountryIsoCode2",
        heds_element: "getIsHeds",
        hotel_id_element: "getHotelId",
        lat_long_element: "getLatLong",
        region_id_element: "getRegionId",
        region_type_element: "getType",
        station_code_element: "getStationCode"
    };
    function updateElement(suggestion, elementId, valueGetter) {
        var jqElement = $("#" + elementId);
        var newValue = "";
        if (jqElement.length > 0) {
            if (suggestion) {
                if (_.isFunction(suggestion[valueGetter])) {
                    var v = suggestion[valueGetter]();
                    if (v.isPresent()) {
                        newValue = v.get();
                    }
                }
                else {
                    TypeaheadErrorLogger_1["default"].log(new Error("" + valueGetter + " is not a method of Suggestion"), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
                }
            }
            jqElement.val(newValue);
            triggerDomElementChange(suggestion, jqElement);
        }
    }
    function updateSearchName(searchQuery, suggestion, elementId) {
        /* This logic is applicable only to Hotels tab in Storefront. When a hotel is selected from the typeahead
        suggestions, the destination parameter in the search url needs to be set to the hotel city instead of the hotel name
         */
        var jqElement = $("#" + elementId);
        jqElement.val(suggestion ? (suggestion.getHotelId().isPresent() && suggestion.getCity().isPresent() ?
            suggestion.getCity().get() : suggestion.getDisplayText()) : searchQuery);
        triggerDomElementChange(suggestion, jqElement);
    }
    function triggerDomElementChange(suggestion, jqElement) {
        if (!suggestion || suggestion.shouldTriggerDomElementChangeOnSelection()) {
            jqElement.trigger("change");
        }
    }
    function updateForSuggestion(searchQuery, suggestion, elementIdByElementKey) {
        for (var element in featureExtractorByElement) {
            if (featureExtractorByElement.hasOwnProperty(element)) {
                updateElement(suggestion, elementIdByElementKey[element], featureExtractorByElement[element]);
            }
        }
        // update search_name
        updateSearchName(searchQuery, suggestion, elementIdByElementKey.search_name_element);
    }
    exports.updateForSuggestion = updateForSuggestion;
});



/// <amd-module name="typeahead/core/StripingConfiguration"/>
define("typeahead/core/StripingConfiguration", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function getExperiments(configurations) {
        if (configurations && configurations.length) {
            return configurations.map(function (config) { return config.experiment; })
                .filter(function (experiment) { return !!experiment; });
        }
        return [];
    }
    exports.getExperiments = getExperiments;
});



/// <amd-module name="typeahead/core/SuggestServiceParamModifier" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/SuggestServiceParamModifier", ["require", "exports", "typeahead/core/ConfigurableFeature", "typeahead/core/plugins/ExecutionHelper"], function (require, exports, ConfigurableFeature_1, ExecutionHelper) {
    "use strict";
    exports.__esModule = true;
    var SuggestServiceParamModifier = (function (_super) {
        __extends(SuggestServiceParamModifier, _super);
        function SuggestServiceParamModifier() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SuggestServiceParamModifier.prototype.modifyParameters = function (params, context, options) {
            var _this = this;
            var deferred = $.Deferred();
            this.shouldOverride(options)
                .done(function (shouldExecute) {
                if (shouldExecute) {
                    _this.modify(params, context, options);
                }
                deferred.resolve(params);
            })
                .fail(function () {
                if (_this.precondition(params, context, options)) {
                    ExecutionHelper.shouldExecute(context, _this.configuration)
                        .done(function (shouldExecute) {
                        if (shouldExecute) {
                            _this.modify(params, context, options);
                        }
                        deferred.resolve(params);
                    });
                }
                else {
                    deferred.resolve(params);
                }
            });
            return deferred.promise();
        };
        SuggestServiceParamModifier.prototype.addFeatureFlag = function (params, feature) {
            params.features = params.features && params.features.length && params.features.push ?
                params.features || [] : [];
            if (params.features.indexOf(feature) < 0) {
                params.features.push(feature);
            }
        };
        SuggestServiceParamModifier.prototype.addRegionType = function (params, regionType) {
            /* tslint:disable-next-line: no-bitwise */
            params.mask |= regionType;
        };
        SuggestServiceParamModifier.prototype.precondition = function (params, context, options) {
            return typeof params !== "undefined";
        };
        return SuggestServiceParamModifier;
    }(ConfigurableFeature_1.ConfigurableFeature));
    exports.SuggestServiceParamModifier = SuggestServiceParamModifier;
});



define("typeahead/core/Suggestion", ["require", "exports", "typeahead/core/util/Optional"], function (require, exports, Optional_1) {
    "use strict";
    exports.__esModule = true;
    ;
    var SuggestionCategory;
    (function (SuggestionCategory) {
        SuggestionCategory[SuggestionCategory["GEOLOCATION"] = 0] = "GEOLOCATION";
        SuggestionCategory[SuggestionCategory["USERHISTORY"] = 1] = "USERHISTORY";
        SuggestionCategory[SuggestionCategory["FLIGHTSBOOKING"] = 2] = "FLIGHTSBOOKING";
        SuggestionCategory[SuggestionCategory["GOOGLEMAPS"] = 3] = "GOOGLEMAPS";
    })(SuggestionCategory = exports.SuggestionCategory || (exports.SuggestionCategory = {}));
    ;
    var Suggestion = (function () {
        function Suggestion(data, hasChild) {
            if (hasChild === void 0) { hasChild = false; }
            this.data = data;
            this.hasChild = hasChild;
        }
        Suggestion.prototype.getSourceName = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getSourceId = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getRegionId = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getTla = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getType = function () {
            return Optional_1.Optional.ofNullable(this.data.type);
        };
        Suggestion.prototype.getRegionNames = function () {
            return Optional_1.Optional.ofNullable(this.data.regionNames);
        };
        Suggestion.prototype.getFullName = function () {
            return Optional_1.Optional.ofNullable(this.getRegionNames().orElse({}).fullName);
        };
        Suggestion.prototype.getLastSearchName = function () {
            return Optional_1.Optional.ofNullable(this.getRegionNames().orElse({}).lastSearchName);
        };
        Suggestion.prototype.getDisplayText = function () {
            return this.getLastSearchName().orElse("");
        };
        Suggestion.prototype.getIndex = function () {
            return parseInt(this.data.index, 10);
        };
        Suggestion.prototype.getPosition = function () {
            return this.getIndex() + 1;
        };
        Suggestion.prototype.getSuggestionHierarchyType = function () {
            return Optional_1.Optional.of("parent");
        };
        Suggestion.prototype.getHierarchyCode = function () {
            // Send the new instrumentation only for hotel LOB
            /**
             * Old nomenclature
             * C0 indicates item is parent
             * C1 indicates item is child
             * P0 indicates item has no child
             * P1 indicates item has child
             */
            // C indicates a chid suggestion
            // P indicates it is a parent suggestion having child/ children
            // D indicates the suggestion is neither a parent nor a child
            // L indicates level of item selected
            var hierarchyCode = "";
            if (this.getSuggestionHierarchyType().get() === "child") {
                // a child cannot have children
                hierarchyCode = "C"; // "P0C1";
            }
            else if (this.getSuggestionHierarchyType().get() === "parent" && this.hasChild) {
                hierarchyCode = "P"; // "P1C0";
            }
            else {
                // Default hierarchy code : has no Children, is a parent  if the suggestions are shown
                hierarchyCode = "D"; // "P0C0";
            }
            return hierarchyCode + "L#" + (!isNaN(this.getPosition()) ? this.getPosition() : "-");
        };
        Suggestion.prototype.getRelationInfo = function () {
            return Optional_1.Optional.of("-");
        };
        Suggestion.prototype.getHotelId = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getLatLong = function () {
            return Optional_1.Optional.ofNullable(this.data.coordinates ?
                this.data.coordinates.lat + "," + this.data.coordinates.long : undefined);
        };
        Suggestion.prototype.getTypeId = function () {
            return Optional_1.Optional.of("-");
        };
        Suggestion.prototype.getCity = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getMultiCity = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getSubType = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getHasChild = function () {
            return Optional_1.Optional.of(this.hasChild);
        };
        Suggestion.prototype.getCategory = function () {
            return Optional_1.Optional.ofNullable(this.data.category);
        };
        Suggestion.prototype.getStationCode = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getCountryName = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getCountryIsoCode2 = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        Suggestion.prototype.getCountryIsoCode3 = function () {
            return Optional_1.Optional.ofNullable(undefined);
        };
        /* returns an Optional containing either:
         * -- "true" if the selected suggestion is a HEDS (Hotel Expedia Doesn't Sell)
         * -- empty for all other selected suggestions
         * if "true", HEDS=true will be sent to HSRP
         * if empty, no query parameter will be sent
         */
        Suggestion.prototype.getIsHeds = function () {
            return Optional_1.Optional.empty();
        };
        Suggestion.prototype.isAddrAutoComplete = function () {
            return false;
        };
        return Suggestion;
    }());
    exports.Suggestion = Suggestion;
});



/// <amd-module name="typeahead/core/SuggestionFactory"/>
define("typeahead/core/SuggestionFactory", ["require", "exports", "typeahead/core/EssSuggestion", "typeahead/core/geolocation/GeolocationSuggestion", "typeahead/core/google/GoogleMapsSuggestion", "typeahead/core/Suggestion"], function (require, exports, EssSuggestion_1, GeolocationSuggestion_1, GoogleMapsSuggestion_1, Suggestion_1) {
    "use strict";
    exports.__esModule = true;
    function createSuggestion(suggestionResult, hasChild) {
        if (hasChild === void 0) { hasChild = false; }
        if (Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.GEOLOCATION] === suggestionResult.category) {
            return new GeolocationSuggestion_1.GeolocationSuggestion(suggestionResult);
        }
        else if (Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.GOOGLEMAPS] === suggestionResult.category) {
            return new GoogleMapsSuggestion_1.GoogleMapsSuggestion(suggestionResult);
        }
        else {
            return new EssSuggestion_1.EssSuggestion(suggestionResult, hasChild);
        }
    }
    exports.createSuggestion = createSuggestion;
});



/// <amd-module name="typeahead/core/SuggestionModifier" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/SuggestionModifier", ["require", "exports", "typeahead/core/ConfigurableFeature", "typeahead/core/plugins/ExecutionHelper"], function (require, exports, ConfigurableFeature_1, ExecutionHelper) {
    "use strict";
    exports.__esModule = true;
    var SuggestionModifier = (function (_super) {
        __extends(SuggestionModifier, _super);
        function SuggestionModifier() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SuggestionModifier.prototype.modifySuggestions = function (suggestions, context, options) {
            var _this = this;
            var deferred = $.Deferred();
            this.shouldOverride(options)
                .done(function (shouldExecute) {
                if (shouldExecute) {
                    _this.modify(suggestions, context);
                }
                deferred.resolve(suggestions);
            })
                .fail(function () {
                if (_this.precondition(suggestions, context)) {
                    ExecutionHelper.shouldExecute(context, _this.configuration)
                        .done(function (shouldExecute) {
                        if (shouldExecute) {
                            _this.modify(suggestions, context);
                        }
                        deferred.resolve(suggestions);
                    });
                }
                else {
                    deferred.resolve(suggestions);
                }
            });
            return deferred.promise();
        };
        SuggestionModifier.prototype.precondition = function (suggestions, context) {
            return suggestions && suggestions.length > 0;
        };
        return SuggestionModifier;
    }(ConfigurableFeature_1.ConfigurableFeature));
    exports.SuggestionModifier = SuggestionModifier;
});



define("typeahead/core/SuggestionsAggregator", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var SuggesterId;
    (function (SuggesterId) {
        SuggesterId[SuggesterId["RecentHistorySuggester"] = 0] = "RecentHistorySuggester";
        SuggesterId[SuggesterId["FlightBookingSuggester"] = 1] = "FlightBookingSuggester";
        SuggesterId[SuggesterId["CurrentLocationSuggester"] = 2] = "CurrentLocationSuggester";
        SuggesterId[SuggesterId["OnFocusSuggester"] = 3] = "OnFocusSuggester";
    })(SuggesterId = exports.SuggesterId || (exports.SuggesterId = {}));
    ;
    var SuggestionsAggregator = (function () {
        function SuggestionsAggregator(suggesters) {
            this.suggesters = suggesters;
            this.suggesterConfig = (_a = {},
                _a[SuggesterId.RecentHistorySuggester] = this.getRecentHistorySuggesterConfig(),
                _a[SuggesterId.FlightBookingSuggester] = this.getFlightBookingSuggesterConfig(),
                _a[SuggesterId.CurrentLocationSuggester] = this.getCurrentLocationSuggesterConfig(),
                _a);
            this.emptySuggesterResponse = { id: this.getId(), results: [] };
            var _a;
        }
        SuggestionsAggregator.prototype.suggest = function (options, context) {
            var deferred = $.Deferred();
            var that = this;
            /* tslint:disable-next-line: only-arrow-functions
             * arguments object is not available in arrow functions in ES3 and ES5.
             * arguments object contains the list of responses that are passed as parameters to this callback */
            var handleSuggestersPromises = function () {
                var responses = Array.prototype.slice.call(arguments);
                deferred.resolve(that.aggregate(responses));
            };
            if (this.suggesters && this.suggesters.length) {
                var suggestersPromises = this.suggesters.map(function (suggester) {
                    return suggester.suggest(options, context);
                });
                $.when.apply($, suggestersPromises).done(handleSuggestersPromises);
            }
            else {
                deferred.resolve(this.emptySuggesterResponse);
            }
            return deferred.promise();
        };
        SuggestionsAggregator.prototype.getMaxResults = function () {
            return 10;
        };
        SuggestionsAggregator.prototype.getSuggesterConfig = function (response) {
            return this.suggesterConfig[response.id] ? this.suggesterConfig[response.id] :
                { rank: SuggestionsAggregator.LOWEST_RANK, isEnabled: false };
        };
        SuggestionsAggregator.prototype.aggregate = function (responses) {
            if (responses) {
                responses = this.filter(responses);
                this.sort(responses);
            }
            return { id: this.getId(), results: this.getAggregatedSuggestionResults(responses) };
        };
        SuggestionsAggregator.prototype.filter = function (responses) {
            var _this = this;
            if (responses) {
                return responses.filter(function (response) {
                    return _this.getSuggesterConfig(response).isEnabled;
                });
            }
            return responses;
        };
        SuggestionsAggregator.prototype.sort = function (responses) {
            var _this = this;
            if (responses) {
                responses.sort(function (a, b) {
                    return _this.getSuggesterConfig(a).rank - _this.getSuggesterConfig(b).rank;
                });
            }
        };
        SuggestionsAggregator.prototype.getAggregatedSuggestionResults = function (responses) {
            var aggregatedResults = [];
            if (responses) {
                responses.forEach(function (response) {
                    Array.prototype.push.apply(aggregatedResults, response.results);
                });
                aggregatedResults = aggregatedResults.slice(0, this.getMaxResults());
                for (var i = 0; i < aggregatedResults.length; i++) {
                    aggregatedResults[i].index = i + "";
                }
            }
            return aggregatedResults;
        };
        SuggestionsAggregator.LOWEST_RANK = 999;
        return SuggestionsAggregator;
    }());
    exports.SuggestionsAggregator = SuggestionsAggregator;
});



/// <amd-module name="typeahead/core/TypeaheadUtils"/>
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define("typeahead/core/TypeaheadUtils", ["require", "exports", "underscore", "typeahead/core/loc", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger"], function (require, exports, _, loc, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1) {
    "use strict";
    exports.__esModule = true;
    var FlightType;
    (function (FlightType) {
        FlightType[FlightType["OneWay"] = 0] = "OneWay";
        FlightType[FlightType["RoundTrip"] = 1] = "RoundTrip";
        FlightType[FlightType["MultiDestination"] = 2] = "MultiDestination";
        FlightType[FlightType["Unknown"] = 3] = "Unknown";
    })(FlightType = exports.FlightType || (exports.FlightType = {}));
    // This enum has sample LOB values to be logged into omniture reflecting the LOB grouping in any wizard
    var Lob;
    (function (Lob) {
        Lob[Lob["Flight"] = 0] = "Flight";
        Lob[Lob["Hotel"] = 1] = "Hotel";
        Lob[Lob["Package"] = 2] = "Package";
        Lob[Lob["Car"] = 3] = "Car";
        Lob[Lob["Cruise"] = 4] = "Cruise";
        Lob[Lob["Activity"] = 5] = "Activity";
        Lob[Lob["Rail"] = 6] = "Rail";
        Lob[Lob["VacationRental"] = 7] = "VacationRental";
        Lob[Lob["OpenSearch"] = 8] = "OpenSearch";
        Lob[Lob["Unknown"] = 9] = "Unknown";
    })(Lob = exports.Lob || (exports.Lob = {}));
    var PackageType;
    (function (PackageType) {
        PackageType[PackageType["FlightHotel"] = 0] = "FlightHotel";
        PackageType[PackageType["FlightHotelCar"] = 1] = "FlightHotelCar";
        PackageType[PackageType["FlightCar"] = 2] = "FlightCar";
        PackageType[PackageType["HotelCar"] = 3] = "HotelCar";
        PackageType[PackageType["Unknown"] = 4] = "Unknown";
    })(PackageType = exports.PackageType || (exports.PackageType = {}));
    var RailType;
    (function (RailType) {
        RailType[RailType["OneWay"] = 0] = "OneWay";
        RailType[RailType["RoundTrip"] = 1] = "RoundTrip";
        RailType[RailType["Unknown"] = 2] = "Unknown";
    })(RailType = exports.RailType || (exports.RailType = {}));
    var SiteParam;
    (function (SiteParam) {
        SiteParam[SiteParam["eapid"] = 0] = "eapid";
        SiteParam[SiteParam["tpid"] = 1] = "tpid";
    })(SiteParam = exports.SiteParam || (exports.SiteParam = {}));
    var TypeaheadUtils = (function () {
        function TypeaheadUtils() {
        }
        TypeaheadUtils.getCookie = function (name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length === 2) {
                var cookieVal = parts.pop().split(";").shift();
                return cookieVal;
            }
            return "";
        };
        TypeaheadUtils.getGuid = function () {
            var guid = window.dctk && window.dctk.logging ? window.dctk.logging.guid : undefined;
            if (guid === undefined) {
                guid = window.utag_data ? window.utag_data.guid : undefined;
            }
            if (guid === undefined) {
                try {
                    require(["gc/pageModel"], function (gcPageModel) {
                        if (gcPageModel && gcPageModel.user) {
                            guid = gcPageModel.user.guid;
                        }
                    });
                }
                catch (e) {
                    // Ignore
                }
            }
            if (guid === undefined) {
                var mc1Cookie = this.getCookie("MC1");
                var pair = mc1Cookie && mc1Cookie.split("=");
                guid = $.isArray(pair) && pair.length === 2 ? pair[1] : "";
            }
            if (guid === undefined) {
                TypeaheadErrorLogger_1["default"].log(new Error("ERROR: Unable to get 'guid'"), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
            }
            else {
                guid = guid.replace(/-/g, "");
            }
            return guid;
        };
        // Get value of tpid or eapid
        TypeaheadUtils.getSiteParamValue = function (siteParam) {
            var paramValue = undefined;
            var siteParamCookieConfig = {
                eapid: {
                    cookieName: "iEAPID"
                },
                tpid: {
                    cookieName: "tpid"
                }
            };
            var param = SiteParam[siteParam];
            if (window.utag_data && window.utag_data.context && window.utag_data.context.site
                && window.utag_data.context.site[param] !== undefined) {
                paramValue = window.utag_data.context.site[param];
            }
            else {
                try {
                    require(["gc/pageModel"], function (gcPageModel) {
                        if (gcPageModel && gcPageModel.site && gcPageModel.site[param] !== undefined) {
                            paramValue = gcPageModel.site[param];
                        }
                    });
                }
                catch (e) {
                    // Ignore
                }
            }
            if (paramValue === undefined) {
                // Sample tpid cookie value - v.1,3
                // Sample iEAPID cookie value - 0
                var cookie = this.getCookie(siteParamCookieConfig[param].cookieName);
                if (cookie !== undefined) {
                    var cookieTokens = cookie.split(",");
                    paramValue = parseInt(cookieTokens.length > 1 ? cookieTokens[1] : cookieTokens[0], 10);
                }
            }
            if (typeof paramValue !== "number" || isNaN(paramValue)) {
                TypeaheadErrorLogger_1["default"].log(new Error("Unable to get " + param + " from utag_data/cookies/gcPageModel"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
            }
            return paramValue;
        };
        TypeaheadUtils.getPointOfSale = function () {
            return window.location.hostname;
        };
        TypeaheadUtils.getLocale = function () {
            return window.locale;
        };
        TypeaheadUtils.getSiteId = function () {
            return window.site_id;
        };
        TypeaheadUtils.getPageId = function () {
            var pageId = $("#pageId").val();
            if (!pageId) {
                pageId = "";
            }
            return pageId;
        };
        TypeaheadUtils.getDeviceType = function () {
            return window.utag_data ? window.utag_data.device_type : "Unavailable";
        };
        TypeaheadUtils.getBrowser = function () {
            var browser = (window.utag_data && window.utag_data.context && window.utag_data.context.clientInfo &&
                window.utag_data.context.clientInfo.deviceCharacteristics) ?
                window.utag_data.context.clientInfo.deviceCharacteristics.mobileBrowser : undefined;
            if (!browser) {
                browser = TypeaheadUtils.evaluateBrowserName();
            }
            return browser;
        };
        TypeaheadUtils.getClientId = function () {
            var clientId = $("input[data-provide=utypeahead]").data("clientId");
            if (!clientId) {
                clientId = $("meta[name=essClientId]").attr("content");
            }
            if (!clientId) {
                var pageId = TypeaheadUtils.defaultPageIdGetter();
                if (pageId) {
                    clientId = TypeaheadUtils.clientIdByPageId[pageId];
                }
            }
            if (!clientId) {
                clientId = TypeaheadUtils.clientIdByPath[window.location.pathname];
            }
            if (!clientId) {
                TypeaheadErrorLogger_1["default"].log(new Error("Could not determine client id"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
                clientId = TypeaheadUtils.TEST_CLIENT_ID;
            }
            return clientId ? clientId : "Unknown";
        };
        // NOTE: Utility function to set LOB for testing purpose only
        // To be called from *.spec.ts ONLY
        TypeaheadUtils.setClientId = function (clientId) {
            TypeaheadUtils.TEST_CLIENT_ID = clientId;
        };
        TypeaheadUtils.isStorefrontClient = function () {
            var storefrontClientIds = [
                "Homepage",
                "AWSHomepage",
                "LXLandingPage",
                "CarsLandingPage",
                "FlightsLandingPage",
                "HotelsLandingPage",
                "PackageLandingPage",
                "RailsLandingPage"
            ];
            return storefrontClientIds.indexOf(TypeaheadUtils.getClientId()) > -1;
        };
        TypeaheadUtils.getLob = function () {
            // Search if wizard page has LOB
            var lob = $("div.wizard-tabs").find("button.on").data("lob");
            // If page does not have LOB search if uTA input has data-lob
            lob = lob ? lob : $("input[data-provide=utypeahead]:visible").data("lob");
            // Check if the TEST LOB attribute is set
            lob = lob ? lob : TypeaheadUtils.LOB_ATTRIBUTE.TEST;
            if ("OpenSearchPage" === TypeaheadUtils.getClientId()) {
                return Lob.OpenSearch;
            }
            if (typeof lob === "string") {
                lob = lob.toLowerCase();
                if (lob.indexOf("flight") > -1) {
                    return Lob.Flight;
                }
                else if (lob.indexOf("hotel") > -1) {
                    return Lob.Hotel;
                }
                else if (lob.indexOf("vacationrental") > -1) {
                    return Lob.VacationRental;
                }
                else if (lob.indexOf("pack") > -1) {
                    return Lob.Package;
                }
                else if (lob.indexOf("car") > -1) {
                    return Lob.Car;
                }
                else if (lob.indexOf("cru") > -1) {
                    return Lob.Cruise;
                }
                else if (lob.indexOf("lx") > -1 || lob.indexOf("activit") > -1) {
                    return Lob.Activity;
                }
                else if (lob.indexOf("train") > -1 || lob.indexOf("rail") > -1) {
                    return Lob.Rail;
                }
                else if (lob.indexOf("open") > -1) {
                    return Lob.OpenSearch;
                }
            }
            return Lob.Unknown;
        };
        // NOTE: Utility function to set LOB for testing purpose only
        // To be called from *.spec.ts ONLY
        TypeaheadUtils.setLob = function (lob) {
            TypeaheadUtils.LOB_ATTRIBUTE.TEST = lob;
        };
        TypeaheadUtils.getFlightType = function (lob) {
            if (lob === Lob.Flight) {
                var flightTypeElementId = $("input[name=route-type], input[name=flight-type]").filter(":checked").attr("id");
                flightTypeElementId = flightTypeElementId ? flightTypeElementId : TypeaheadUtils.TEST_FLIGHT_TYPE_ID;
                if (flightTypeElementId) {
                    flightTypeElementId = flightTypeElementId.toLowerCase();
                    if (flightTypeElementId.indexOf("one") > -1) {
                        return FlightType.OneWay;
                    }
                    else if (flightTypeElementId.indexOf("round") > -1) {
                        return FlightType.RoundTrip;
                    }
                    else if (flightTypeElementId.indexOf("multi") > -1) {
                        return FlightType.MultiDestination;
                    }
                    else {
                        TypeaheadErrorLogger_1["default"].log(new Error("Could not determine flight type with dom element id - " +
                            flightTypeElementId), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
                    }
                }
                TypeaheadErrorLogger_1["default"].log(new Error("Unable to find flight-type dom element to determine flight type"), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
            }
            return FlightType.Unknown;
        };
        // NOTE: Utility function to set LOB for testing purpose only
        // To be called from *.spec.ts ONLY
        TypeaheadUtils.setFlightElementId = function (id) {
            TypeaheadUtils.TEST_FLIGHT_TYPE_ID = id;
        };
        TypeaheadUtils.getRailType = function (lob) {
            if (lob === Lob.Rail) {
                var railTypeElementId = $("input[name=journeyType]").filter(":checked").attr("id");
                railTypeElementId = railTypeElementId ? railTypeElementId : TypeaheadUtils.TEST_RAIL_TYPE_ID;
                if (railTypeElementId) {
                    railTypeElementId = railTypeElementId.toLowerCase();
                    if (railTypeElementId.indexOf("one") > -1) {
                        return RailType.OneWay;
                    }
                    else if (railTypeElementId.indexOf("round") > -1) {
                        return RailType.RoundTrip;
                    }
                    else {
                        TypeaheadErrorLogger_1["default"].log(new Error("Could not determine rail journey type with dom element id - " +
                            railTypeElementId), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
                    }
                }
                TypeaheadErrorLogger_1["default"].log(new Error("Unable to find journeyType dom element to determine rail journey type"), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
            }
            return RailType.Unknown;
        };
        // NOTE: Utility function to set LOB for testing purpose only
        // To be called from *.spec.ts ONLY
        TypeaheadUtils.setRailTypeId = function (id) {
            TypeaheadUtils.TEST_RAIL_TYPE_ID = id;
        };
        TypeaheadUtils.getPackageType = function () {
            var packageTypeElementId = $("input[name=package-lob], input[name=package-type]").filter(":checked").attr("id");
            packageTypeElementId = packageTypeElementId ? packageTypeElementId : TypeaheadUtils.TEST_PACKAGE_TYPE_ID;
            if (packageTypeElementId) {
                packageTypeElementId = packageTypeElementId.toLowerCase();
                if (packageTypeElementId.indexOf("fhc") > -1) {
                    return PackageType.FlightHotelCar;
                }
                else if (packageTypeElementId.indexOf("fh") > -1) {
                    return PackageType.FlightHotel;
                }
                else if (packageTypeElementId.indexOf("fc") > -1) {
                    return PackageType.FlightCar;
                }
                else if (packageTypeElementId.indexOf("hc") > -1) {
                    return PackageType.HotelCar;
                }
            }
            return PackageType.Unknown;
        };
        // NOTE: Utility function to set LOB for testing purpose only
        // To be called from *.spec.ts ONLY
        TypeaheadUtils.setPackageTypeId = function (id) {
            TypeaheadUtils.TEST_PACKAGE_TYPE_ID = id;
        };
        TypeaheadUtils.submitToOmniture = function (trackingData, activeESSTests) {
            require(["dctk/dctk"], function (dctk) {
                if (activeESSTests) {
                    dctk.addExperiments(activeESSTests);
                }
                dctk.trackEvent("o", "wizard-submit", trackingData, trackingData.eventString);
            });
        };
        TypeaheadUtils.getClientSideExperimentVariants = function () {
            if (!TypeaheadUtils.clientSideExperimentVariants) {
                require(["dctk/dctk"], function (dctk) {
                    // "list1" corresponds to the "l1" variable
                    TypeaheadUtils.clientSideExperimentVariants = dctk.omtr ? dctk.omtr.list1 : "";
                });
            }
            return TypeaheadUtils.clientSideExperimentVariants;
        };
        TypeaheadUtils.isWithinMobileBreakpoint = function () {
            return (uitk && uitk.mediaquery &&
                uitk.mediaquery.getMediaQueries() &&
                uitk.mediaquery.getMediaQueries().mobile &&
                uitk.mediaquery.getMediaQueries().mobile.matches);
        };
        TypeaheadUtils.isTouchDevice = function () {
            return Modernizr && Modernizr.touch;
        };
        TypeaheadUtils.getExpUserId = function () {
            var expuserid = $("#scratchpad-badge-expuserid").attr("data-id");
            if (!expuserid) {
                require(["gc/pageModel"], function (gcPageModel) {
                    expuserid = gcPageModel.user ? gcPageModel.user.expUserId : undefined;
                });
            }
            return expuserid || "-1";
        };
        TypeaheadUtils.iconOverride = function (category, icon) {
            // creates a copy of the category in order to not override the icon
            // in the original category entry, and returns the copy with icon replaced
            var copy = __assign({}, category);
            copy.icon = icon;
            return copy;
        };
        TypeaheadUtils.getOverrideIcon = function (type, subtype) {
            if (typeof subtype === "string") {
                type = type + "|" + subtype;
            }
            return TypeaheadUtils.categoryIconOverrides[type];
        };
        TypeaheadUtils.evaluateBrowserName = function () {
            var ua = navigator.userAgent;
            var tem;
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return "IE";
            }
            if (M[1] === "Chrome") {
                tem = ua.match(/\bOPR\/(\d+)/);
                if (tem != null) {
                    return "Opera";
                }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
            tem = ua.match(/version\/(\d+)/i);
            if (tem != null) {
                M.splice(1, 1, tem[1]);
            }
            return M[0];
        };
        TypeaheadUtils.defaultPageIdGetter = function () {
            var pageIdElement = $("#pageId");
            var pageId = pageIdElement.size() === 1 ? pageIdElement.val() : "";
            if (!pageId) {
                pageId = window.dctk ? (window.dctk.logging ? window.dctk.logging.pageName : "") : "";
            }
            return pageId ? pageId : "";
        };
        TypeaheadUtils.responsiveTAClasses = {
            autoCompleteClass: "autocomplete",
            centerClass: "pin-center",
            dropdownClass: "autocomplete-dropdown",
            hlClass: "highlight",
            leftClass: "pin-left",
            openClass: "autocomplete-open",
            rightClass: "pin-right"
        };
        TypeaheadUtils.bitMaskFlags = {
            ADDRESS: 32,
            AIRPORT: 1,
            CITY: 2,
            HOTEL: 128,
            METROCODE: 64,
            METROSTATION: 1024,
            MULTICITY: 4,
            MULTIREGION: 256,
            NEIGHBORHOOD: 8,
            POI: 16,
            TRAINSTATION: 512
        };
        TypeaheadUtils.defaultMask = (
        /* tslint:disable-next-line: no-bitwise */
        TypeaheadUtils.bitMaskFlags.AIRPORT |
            TypeaheadUtils.bitMaskFlags.CITY |
            TypeaheadUtils.bitMaskFlags.MULTICITY |
            TypeaheadUtils.bitMaskFlags.NEIGHBORHOOD |
            TypeaheadUtils.bitMaskFlags.POI);
        TypeaheadUtils.LOB_ATTRIBUTE = {
            ACTIVITIES: "ACTIVITIES",
            CARS: "CARS",
            FLIGHTS: "FLIGHTS",
            HOTELS: "HOTELS",
            PACKAGES: "PACKAGES",
            RAILS: "RAILS",
            TEST: "",
            VACATIONRENTALS: "VACATIONRENTALS"
        };
        TypeaheadUtils.CATEGORIES = {
            ADDRESS: {
                icon: "location",
                id: 4,
                name: loc.taCategoryNameAddress
            },
            AIRPORT: {
                icon: "flights",
                id: 2,
                name: loc.taCategoryNameAirports
            },
            AMENITY: {
                icon: "tag",
                id: 14,
                name: loc.taCategoryNameAmenities
            },
            ATTRACTION: {
                icon: "location",
                id: 1,
                name: loc.taCategoryNameAttractions
            },
            CITY: {
                icon: "location",
                id: 0,
                name: loc.taCategoryNameRegionCity
            },
            DEALS: {
                icon: "location",
                id: 13,
                name: loc.taCategoryNameDeals
            },
            GEOLOCATION: {
                icon: "geolocation",
                id: 16,
                name: undefined
            },
            HOTEL: {
                icon: "hotels",
                id: 3,
                name: loc.taCategoryNameHotels
            },
            METROCODE: {
                icon: "flights",
                id: 9,
                name: loc.taCategoryNameAirports
            },
            METROSTATION: {
                icon: "train",
                id: 6,
                name: loc.taCategoryNameMetros
            },
            MULTICITY: {
                icon: "location",
                id: 7,
                name: loc.taCategoryNameRegionCity
            },
            NEIGHBORHOOD: {
                icon: "location",
                id: 8,
                name: loc.taCategoryNameRegionCity
            },
            POI: {
                icon: "location",
                id: 11,
                name: loc.taCategoryNameAttractions
            },
            RENTAL: {
                icon: "cars",
                id: 12,
                name: loc.taCategoryNameRentals
            },
            TRAINSTATION: {
                icon: "train",
                id: 5,
                name: loc.taCategoryNameTrains
            },
            USERHISTORY: {
                icon: "notime",
                id: 15,
                name: loc.taCategoryNameRecentSearch
            }
        };
        TypeaheadUtils.categoryIconOverrides = {
            "ADDRESS|RENTALLOCATION": TypeaheadUtils.CATEGORIES.RENTAL.icon,
            "NEIGHBORHOOD|AIRNBH": "flights"
        };
        TypeaheadUtils.TEST_CLIENT_ID = "Unknown";
        TypeaheadUtils.TEST_FLIGHT_TYPE_ID = "Unknown";
        TypeaheadUtils.TEST_PACKAGE_TYPE_ID = "Unknown";
        TypeaheadUtils.TEST_RAIL_TYPE_ID = "Unknown";
        TypeaheadUtils.clientSideExperimentVariants = "";
        TypeaheadUtils.clientIdByPageId = {
            "Homepage": "Homepage",
            "aws_Homepage": "AWSHomepage",
            "page.Activities": "LXLandingPage",
            "page.Cars": "CarsLandingPage",
            "page.Flight-Search-Oneway": "Flights.Search",
            "page.Flight-Search-Roundtrip.Out": "Flights.Search",
            "page.Flight-Search.MDest": "Flights.Search",
            "page.Flights": "FlightsLandingPage",
            "page.Hotel-Search": "Hotels.Search",
            "page.Hotels": "HotelsLandingPage",
            "page.Hotels.Search": "Hotels.Search",
            "page.Packages": "PackageLandingPage",
            "page.Rails": "RailsLandingPage",
            "page.open-search": "OpenSearchPage"
        };
        TypeaheadUtils.clientIdByPath = {
            "/": "Homepage",
            "/Activities": "LXLandingPage",
            "/Cars": "CarsLandingPage",
            "/Flights": "FlightsLandingPage",
            "/Flights-Search": "Flights.Search",
            "/Holidays": "PackageLandingPage",
            "/Hotel-Search": "Hotels.Search",
            "/Hotels": "HotelsLandingPage",
            "/Vacation-Packages": "PackageLandingPage",
            "/search-results": "OpenSearchPage",
            "/trains": "RailsLandingPage"
        };
        return TypeaheadUtils;
    }());
    exports.TypeaheadUtils = TypeaheadUtils;
});



/// <amd-module name="typeahead/core/abTest" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="uitk" name="uitk"/>
define("typeahead/core/abTest", ["require", "exports", "jquery", "uitk", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger", "typeahead/core/plugins/DefaultPluginAssembly", "typeahead/core/TypeaheadUtils"], function (require, exports, $, uitk, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1, DefaultPluginAssembly_1, TypeaheadUtils_1) {
    /// <reference path="../../typings/typeahead/uitk.d.ts" />
    /// <reference path="../../typings/typeahead/dctk.d.ts" />
    /// <reference path="../../typings/typeahead/abTest.d.ts" />
    "use strict";
    exports.__esModule = true;
    var persistentCookie = uitk.createBrowserStorage ? uitk.createBrowserStorage("persistentCookies") : undefined;
    var abovCookieValue = TypeaheadUtils_1.TypeaheadUtils.getCookie("abov");
    var abTestMap = {};
    var loggedTests = [];
    // for same test, we don't want to fire multiple ajax requests
    // instead we should have this cache map to store deferred object
    // and resolve/reject the result
    // subsequent call will be handled by abTestMap cache
    var ajaxCallCache = {};
    /*
        To test on localhost, install Charles and add a mapping:
        https://ewegithub.sb.karmalab.net/EWE/datacapture-toolkit/
            blob/master/datacapture/src/main/resources/datacapture/js/docs/testing-changes-with-charles.md
        from http://localhost:8080/api/bucketing/v1/evaluateExperiments to
            https://www.expedia.com/api/bucketing/v1/evaluateExperiments
        from http://localhost:8080/api/bucketing/v1/evaluateExperimentsAndLog to
            https://www.expedia.com/api/bucketing/v1/evaluateExperimentsAndLog
    
        Gets the variant of an Abacus Test from its name.
        Asynchronous method!
        @param expName: Mandatory - String - The experiment name to evaluate.
        @param successCallback: Mandatory - DoneCallback -
            The callback function called after receiving a successful response from abacus service.
        @param successCallback: Optional - errorCallback -
            The callback function called after receiving an errorful response from abacus service.
     */
    function get(expName) {
        var deferred = $.Deferred();
        if (expName) {
            var test_1;
            var testCached = false;
            if (!!abTestMap[expName]) {
                test_1 = abTestMap[expName];
                testCached = true;
            }
            if (!testCached) {
                if (ajaxCallCache.hasOwnProperty(expName)
                    && typeof ajaxCallCache[expName] !== "undefined") {
                    // it is being evaluated, we can just queue it
                    ajaxCallCache[expName].push(deferred);
                }
                else {
                    // first time trying to evaluate this test
                    // we just cache it first
                    ajaxCallCache[expName] = [deferred];
                    require(["dctk/dctk"], function (dctk) {
                        dctk.evaluateExperiment(getDctkParams(expName, false, function (experiment) {
                            if (experiment.error) {
                                test_1 = new UtaExperiment(expName, undefined, undefined);
                                abTestMap[test_1.name] = test_1;
                                publishTestResult(new UtaExperiment(expName), !processDctkError(experiment, expName));
                            }
                            else {
                                if (experiment.id) {
                                    test_1 = new UtaExperiment(expName, experiment.id, experiment.value);
                                    abTestMap[test_1.name] = test_1;
                                }
                                publishTestResult(test_1, true);
                            }
                        }));
                    });
                }
            }
            else {
                deferred.resolve(test_1);
            }
        }
        else {
            deferred.reject(new UtaExperiment("experiment name must be provided"));
        }
        return deferred.promise();
    }
    /*
        Gets and Logs the variant of an Abacus Test from its name.
     */
    function getAndLog(expName) {
        if (expName) {
            // Do not log if test is already logged or previous test evaluation was an error
            if (loggedTests.indexOf(expName) < 0 && !(abTestMap[expName] && abTestMap[expName].value === undefined)) {
                loggedTests.push(expName);
                require(["dctk/dctk"], function (dctk) {
                    dctk.evaluateExperimentAndLog(getDctkParams(expName, true, undefined));
                });
            }
            return get(expName);
        }
        TypeaheadErrorLogger_1["default"].log(new Error("Experiment name missing when calling 'getAndLog'"), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
        return $.Deferred().reject().promise();
    }
    exports.getAndLog = getAndLog;
    function evaluateAllExperiments(plugins) {
        evaluateExperiments(getAllExperimentNames(plugins.get(DefaultPluginAssembly_1.DefaultPluginAssembly.experimentIdentifier)));
    }
    exports.evaluateAllExperiments = evaluateAllExperiments;
    function getAllExperimentNames(experimentalFeatures) {
        var experimentNames = [];
        var getExperimentName = function (experiment) {
            if (experimentNames.indexOf(experiment.name) < 0) {
                experimentNames.push(experiment.name);
            }
        };
        var getExperiments = function (experimentalFeature) {
            var experiments = experimentalFeature.getExperiments();
            if (experiments && experiments.length) {
                experiments.forEach(getExperimentName);
            }
        };
        if (experimentalFeatures && experimentalFeatures.length) {
            experimentalFeatures.forEach(getExperiments);
        }
        return experimentNames;
    }
    function evaluateExperiments(experiments) {
        if (experiments && experiments.length) {
            $.ajax({
                contentType: "application/json; charset=UTF-8",
                data: JSON.stringify(getAbacusParams(experiments)),
                dataType: "json",
                type: "POST",
                url: "/api/bucketing/v1/evaluateExperiments"
            }).done(function (response) {
                if (response && response.evaluatedExperiments && response.evaluatedExperiments.length) {
                    response.evaluatedExperiments.forEach(function (exp) {
                        abTestMap[exp.name] = new UtaExperiment(exp.name, exp.id, exp.message ? undefined : exp.value);
                    });
                }
            }).fail(function () {
                TypeaheadErrorLogger_1["default"].log(new Error("Unable to call abacus api to evaluate experiments at page load"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
            });
        }
    }
    /*
      Overrides the variant of an Abacus ID.
    
      @param testId: Mandatory - number - The experiment ID
      @param variant: Mandatory - number - the variant number (0=control, 1=variant1, etc)
    
    */
    function override(testId, variant) {
        var overrideValue = [testId, "0", variant].join("|");
        var abov = persistentCookie.readItem("abov");
        var newAbov = overrideValue;
        if (abov) {
            newAbov = abov;
            var testIdStr = testId + "";
            var testIdIndex = newAbov.indexOf(testIdStr + "|");
            if (testIdIndex >= 0) {
                var patt = new RegExp(testIdStr + "\\|[0-9]+\\|[0-9]+");
                newAbov = newAbov.replace(patt, overrideValue);
            }
            else {
                newAbov += ":" + overrideValue;
            }
        }
        persistentCookie.saveItem("abov", newAbov);
    }
    exports.override = override;
    /*
     Returns the content of the "abov" cookie, i.e. all the overriden experiments for the user on the current domain.
     */
    function getCookieValue() {
        return abovCookieValue ? abovCookieValue : undefined;
    }
    exports.getCookieValue = getCookieValue;
    /*
     This function is mainly used for unit testing, don't use it anywhere else
    */
    function _mockExperimentWithBucket(expName, bucketVal) {
        if (abTestMap.hasOwnProperty(expName)) {
            abTestMap[expName].value = bucketVal;
        }
        else {
            abTestMap[expName] = {
                id: -1,
                name: expName,
                value: bucketVal
            };
        }
    }
    exports._mockExperimentWithBucket = _mockExperimentWithBucket;
    var UtaExperiment = (function () {
        function UtaExperiment(name, id, value) {
            this.name = name;
            this.id = id;
            this.value = value;
        }
        return UtaExperiment;
    }());
    exports.UtaExperiment = UtaExperiment;
    // "Unexpected error occured"
    var defaultErrorCode = {
        id: 2000, problemOrigin: ProblemOrigin_1.ProblemOrigin.DataCaptureToolkit, severity: Severity_1.Severity.MustFix
    };
    var errorCodes = [
        defaultErrorCode,
        // Evaluation failures
        // "Error occurred during getting preserve data."
        { id: 50000, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "Invalid input parameters. {0}"
        { id: 50001, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "Error occurred during bucketing."
        { id: 50002, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        /* Error occurred during the evaluation of one or more experiments   type: WARN
        This error could occur when the experiment is being evaluated for a site where it is not enabled.*/
        { id: 50003, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.Negligible },
        // "The EntityType of the provided experiments must be the same. We have seen {0} and {1}"
        { id: 50004, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // Exposure Logging failures
        // "Request validation failed with: {0}"
        { id: 50100, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "An error occurred resolving experiment {0} ({1}) for exposure logging"
        { id: 50101, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "Experiment {0} ({1}) is not in test mode and so cannot be logged"
        { id: 50102, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "Experiment {0} ({1}) has already been logged"
        { id: 50103, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "Could not find a treatment group for value {0} in experiment {1}"
        { id: 50104, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // Data reading Failures
        // "Can't read the EntityType of the experiments"
        { id: 70001, problemOrigin: ProblemOrigin_1.ProblemOrigin.DataCaptureToolkit, severity: Severity_1.Severity.MustFix },
        // "Can't read the run type of the experiments"
        { id: 70002, problemOrigin: ProblemOrigin_1.ProblemOrigin.DataCaptureToolkit, severity: Severity_1.Severity.MustFix },
        // Site hierarchy
        // "No site found for siteId={0}"*/
        { id: 8000, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.MustFix },
        // "The given (TPID, EAPID) pair '(1, 0)' is not valid for the Experiment '13,081'"
        { id: 4301, problemOrigin: ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, severity: Severity_1.Severity.Negligible },
    ];
    // Returns true if error is not ignoreable and false if error can be ignored
    function processDctkError(response, expName, additionMsg) {
        var isError = true;
        if (response && response.error) {
            var errorCode = void 0;
            var filter = errorCodes.filter(function (errorCodeToFind) {
                var err = (typeof response.error === "string") ? response.error : response.error.toString();
                return err.indexOf(errorCodeToFind.id) > -1;
            });
            errorCode = (filter && filter.length > 0) ? filter[0] : defaultErrorCode;
            if (errorCode.severity !== Severity_1.Severity.Negligible) {
                TypeaheadErrorLogger_1["default"].log(new Error("Error evaluating experiment [" + expName + "]: " + response.error +
                    (additionMsg ? ", addition: " + additionMsg : "")), errorCode.severity, errorCode.problemOrigin);
            }
            else {
                isError = false;
            }
        }
        return isError;
    }
    function getDctkParams(expName, logToOmniture, callback) {
        var dctkParams = {
            callback: callback,
            eapid: TypeaheadUtils_1.TypeaheadUtils.getSiteParamValue(TypeaheadUtils_1.SiteParam.eapid),
            guid: TypeaheadUtils_1.TypeaheadUtils.getGuid(),
            logToOmniture: logToOmniture,
            name: expName,
            overrides: getCookieValue(),
            tpid: TypeaheadUtils_1.TypeaheadUtils.getSiteParamValue(TypeaheadUtils_1.SiteParam.tpid)
        };
        return dctkParams;
    }
    function getAbacusParams(experiments) {
        return {
            eapid: TypeaheadUtils_1.TypeaheadUtils.getSiteParamValue(TypeaheadUtils_1.SiteParam.eapid),
            guid: TypeaheadUtils_1.TypeaheadUtils.getGuid(),
            name: experiments,
            overrides: getCookieValue(),
            tpid: TypeaheadUtils_1.TypeaheadUtils.getSiteParamValue(TypeaheadUtils_1.SiteParam.tpid),
            verbose: true
        };
    }
    function publishTestResult(experiment, success) {
        var cacheKey = experiment ? experiment.name || "" : "";
        if (ajaxCallCache.hasOwnProperty(cacheKey)
            && typeof ajaxCallCache[cacheKey] !== "undefined") {
            while (ajaxCallCache[cacheKey].length) {
                // first come first served
                var deferred = ajaxCallCache[cacheKey].shift();
                // we notify the experiment: either a successful one or a failure one
                if (success) {
                    deferred.resolve(experiment);
                }
                else {
                    deferred.reject(experiment);
                }
            }
            ajaxCallCache[cacheKey] = undefined;
        }
    }
});



// Having an AMD require in the bundle makes sure the universalTypeahead module is loaded
// Since the universalTypeahead AMD module requires UITK, this will load after UITK is loaded.
var utaScriptLoadingStartedTimestamp = Date.now();
require('universalTypeahead', function (uTA) {
    window.utaModuleReadyTimeStamp = Date.now();
    // What is this thing doing?
    // After this file is loaded and once jQuery fires the document ready notification...
    // Then we look for any elements with attribute 'data-provide="utypeahead"' and if we
    // find any then we attach a focus handler using uTA.
    // This works in a similar manner to uitk-typeahead
    // (See http://uitoolkit.sb.karmalab.net/uitoolkit-current/docs/components/interactive/type-ahead)
    //
    //      data-provide="utypeahead"
    //      data-template="#uitk-ta-default || #uitk-ta-by-category"
    //      data-js-theme="typeahead || typeahead-by-category"
    //
    $(function autoAttachUniversalTypeahead() {

        var attachedInputIdCache = [];
        var dataProvideAttr = '[data-provide=utypeahead]';

        // If an element has the attribute 'data-provide={typeahead provider string}' then we
        // use that to attach a typeahead instance to it if there is also a 'data-template="<uitk template name>"'
        // and a 'data-js-theme="<uitk js theme name>"'
        $('body').on('focus.typeahead input.typeahead', dataProvideAttr, function () {
            var $el = $(this),
                inputId,
                template, // UITK required attribute
                jsTheme, // UITK required attribute
                options;

            // If this element already has a typeahead instance associated with it,
            // then there's nothing to do here so we just move along.
            if ($el.data('typeahead')) {
                return;
            }

            inputId = '#' + $el.attr('id');

            if(attachedInputIdCache.indexOf(inputId) > -1) {
                return;
            }
            attachedInputIdCache.push(inputId);

            template = $el.data('template');
            jsTheme = $el.data('jsTheme');
            options = $el.data();

            // UITK documentation states that data-template and data-js-theme are required in combination with data-provide="typeahead"
            // in order for a typeahead instance to be attached to an element. If that's not the case, notify the developers.
            if (!(_.isString(template) && _.isString(jsTheme))) {
                console && console.trace && console.trace(
                    "The data-template and data-js-theme attributes are required " +
                    "in combination with data-provide in order to attach a typeahead instance to an element. (according to UITK documentation) " +
                    "See: http://uitoolkit.sb.karmalab.net/uitoolkit-current/docs/components/interactive/type-ahead"
                );
            }

            // OK, all criteria seem to be met,
            // create a new uTA and associate with this element
            uTA.initTA(inputId, template, options);
        });

        uTA.handlePageLoad();
    });
});




// A hack to make modulizr work with AMD (a la RequireJS), which is used by JavaScript code that is transpiled from
// TypeScript.
if (define && define.amd) {
    try {
        define("require", function () {
            return require;
        });
    }
    catch (e) {
        // Error: Dependency already defined require
        // We don't care about this error.
    }
}


define("typeahead/core/handlebarHelpers", ["require", "exports", "handlebars.runtime", "typeahead/core/geolocation/GeolocationIcon"], function (require, exports, hbRuntime, GeolocationIcon_1) {
    "use strict";
    exports.__esModule = true;
    // FROM https://gist.github.com/3902173
    //
    // HELPER: #each_with_key
    //
    // Usage: {{#each_with_key container key="myKey"}}...{{/each_with_key}}
    //
    // Iterate over an object containing other objects. Each
    // inner object will be used in turn, with an added key ("myKey")
    // set to the value of the inner object's key in the container.
    hbRuntime["default"].registerHelper("each_with_key", function (obj, options) {
        var context;
        var buffer = "";
        var key;
        var keyName = options.hash.key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                context = obj[key];
                if (keyName) {
                    context[keyName] = key;
                }
                buffer += options.fn(context);
            }
        }
        return buffer;
    });
    // Helper to be called in hbs templates to display a suggestion according to the different business rules.
    // CF content/hbs/templates/destinationCustom.hbs for example.
    hbRuntime["default"].registerHelper("createListItem", function (suggestionResult) {
        function appendDistanceForNearbyAirportIfApplicable() {
            var html = suggestionResult.regionNames.displayName;
            // This feature is currently limited to en_GB and en_US because it is not yet localized. Proper localization
            // should translate "2 miles away" to "2 millas de distancia" for es_US and "3 km entfernt" for de_DE.
            var essSuggestionResult = suggestionResult;
            var nearbyAirportMiles = essSuggestionResult.hierarchyInfo && essSuggestionResult.hierarchyInfo.nearby ?
                essSuggestionResult.hierarchyInfo.nearby.distInMI : undefined;
            if (nearbyAirportMiles) {
                html = html + " (" + Math.round(nearbyAirportMiles) + " miles away)";
            }
            return html;
        }
        function makeIconHtml() {
            var html;
            if (suggestionResult.showAsHierarchy) {
                html = "<span data-tid=\"typeahead-icon"
                    + parseInt(suggestionResult.index, 10)
                    + "\" class=\"icon icon-return\" aria-hidden=\"true\"></span>";
            }
            else {
                if (suggestionResult.icon === "geolocation") {
                    html = "<span data-tid=\"typeahead-icon" + suggestionResult.index + "\" class=\"\" aria-hidden=\"true\">" +
                        "<img alt=\"\" style=\"height:1em;width:1em;vertical-align:middle;margin-right:0.8em;\" " +
                        "src='" + GeolocationIcon_1.locationIcon + "'/>" +
                        "</span>";
                }
                else if (suggestionResult.icon === "none") {
                    html = "<span data-tid=\"typeahead-icon"
                        + suggestionResult.index
                        + "\" aria-hidden=\"true\"/>";
                }
                else {
                    html = "<span data-tid=\"typeahead-icon"
                        + suggestionResult.index
                        + "\" class=\"icon icon-"
                        + suggestionResult.icon + " "
                        + "\"\""
                        + "\" aria-hidden=\"true\"/>";
                }
            }
            return html;
        }
        function createMultiLineHtml(topLeft, topRight, bottom) {
            var html = "<div class='multiLineDisplay'>";
            html += topLeft.trim();
            if (topRight) {
                html += topRight.trim();
            }
            if (bottom) {
                html += "<br>" + bottom.trim();
            }
            html += "</div>";
            return html;
        }
        function convertMainToMultiLineHtml(textHtml) {
            var primaryText = "";
            var bottomText = "";
            var extraText = "";
            var openParenIndex = textHtml.indexOf("(");
            var closeParenIndex = textHtml.indexOf(")");
            var tla;
            var rest;
            /* main suggestions should always have parentheses */
            if (openParenIndex !== -1 && closeParenIndex !== -1) {
                primaryText = textHtml.substring(0, openParenIndex);
                bottomText = textHtml.substring(openParenIndex + 1, closeParenIndex);
                var dashIndex = bottomText.indexOf("-");
                if (dashIndex !== -1) {
                    tla = bottomText.substring(0, dashIndex).replace(/&nbsp;/i, "").trim();
                    rest = bottomText.substring(dashIndex + 1, bottomText.length);
                }
                else {
                    tla = bottomText;
                    rest = "";
                }
                bottomText = "(<B>" + tla + "</B>)" + rest;
                if (closeParenIndex + 1 < textHtml.length) {
                    extraText = textHtml.substring(closeParenIndex + 1, textHtml.length);
                }
            }
            else {
                primaryText = textHtml;
            }
            return createMultiLineHtml(primaryText, extraText, bottomText);
        }
        function convertChildToMultiLineHtml(textHtml) {
            var dashIndex = textHtml.indexOf("-");
            if (dashIndex !== -1) {
                var tla = textHtml.substring(0, dashIndex).replace(/&nbsp;/i, "").trim();
                var rest = textHtml.substring(dashIndex + 1, textHtml.length);
                return "(<B>" + tla + "</B>)" + rest;
            }
            // Handling the case where hypen is not available after TLA in the ESS display text (example - YQG, Windsor ..)
            /*
             else {
             var result = new RegExp("^([A-Z]{3}),(.*)").exec(textHtml);
             if (result && result.length && result[1] && result[2]) {
             return "(<B>" + result[1] + "</B>)" + result[2];
             }
             }*/
            return textHtml;
        }
        function getMercuryWizardTab() {
            return $("li.tab:visible").children("button.on").data("lob");
        }
        function formatText(html) {
            if ("flight" === getMercuryWizardTab()) {
                return suggestionResult.showAsHierarchy ? convertChildToMultiLineHtml(html) :
                    convertMainToMultiLineHtml(html);
            }
            else {
                return html;
            }
        }
        var iconHtml = makeIconHtml();
        var textHtml = suggestionResult.regionNames.displayName;
        if (suggestionResult.showAsHierarchy) {
            textHtml = appendDistanceForNearbyAirportIfApplicable();
        }
        var iconAndTextHtml = iconHtml + formatText(textHtml);
        return suggestionResult.showAsHierarchy ? ("<div class=\"child-suggestion\" style=\"padding-left:" +
            ("none" === suggestionResult.icon ? "12px" : "1.88235em") +
            "; width: 100%;\">" + iconAndTextHtml + "</div>") : iconAndTextHtml;
    });
});



// Handlebars AMD is dependant on some features built into requirejs
// that aren't in modulizr. This file adds those features.

// module is not defined in modulizr, it is safe to just
// return a generic object
// define('jquery', function() { return $});
if(!require('module')) {
    try {
        define('module', function() {return {}});
        define('exports', function() {return {}});

    // requirejs handles paths to files while modulizr does not
    // we point the paths handlebars expects at the objects
        define('./utils', ['handlebars/utils'], function(utils) { return utils});
        define('./handlebars/utils', ['handlebars/utils'], function(utils) { return utils});
        define('./exception', ['handlebars/exception'], function(exception) { return exception});
        define('./handlebars/exception', ['handlebars/exception'], function(exception) { return exception});
        define('./safe-string', ['handlebars/safe-string'], function(safeString) { return safeString});
        define('./handlebars/safe-string', ['handlebars/safe-string'], function(safeString) { return safeString});
        define('./base', ['handlebars/base'], function(base) { return base});
        define('./handlebars/base', ['handlebars/base'], function(base) { return base});
        define('./no-conflict', ['handlebars/no-conflict'], function(noConflict) { return noConflict});
        define('./handlebars/no-conflict', ['handlebars/no-conflict'], function(noConflict) { return noConflict});
        define('./runtime', ['handlebars/runtime'], function(runtime) { return runtime});
        define('./handlebars/runtime', ['handlebars/runtime'], function(runtime) { return runtime});

    } catch (e) { }
}


require(['jquery', 'uitk_i18n', 'handlebars.runtime'], function ($, I18n, hbRuntime) {

    var hb = hbRuntime.default;
    
    // register an empty i18nJs helper:
    hb.registerHelper('i18nJs', function (arguments) {
        if (arguments.length > 1) {
            I18n.locale=arguments[0];
        }
        return '';
    });

    // redirect i18n helper to i18n.js:
    hb.registerHelper('i18n', function () {
        var key = arguments[0],
            i18nOpts = {},
            len = arguments.length - 1,  options = arguments[len];
        for(var i = 1; i < len; i++) {
            i18nOpts['arg' + (i - 1)] = arguments[i];
        }

        i18nOpts.locale = options.hash.locale;
        return I18n.t(key, i18nOpts);
    });

    // The compress helper strips out whitespace
    hb.registerHelper('compress', function(options) {
        var html = options.fn(this);
        html = html.replace(/>\s+</g, "><"); // Remove whitespace between tags
        return html;
    });

    // Compares two variables to determine if localization is required.
    // Original source http://doginthehat.com.au/2012/02/comparison-block-helper-for-hb-templates/
    // Edited CSE Expedia 2014/2015 E. C.
    // TODO This logic should all be moved to the typeahead script when possible.

    hb.registerHelper('compare', function(lvalue, rvalue, options) {

        // NOTE: navigator.language approach doesn't work well
        // Doesn't return proper results on Chrome, which returns the language of the build of the browser,
        // instead of the language setting in the browser. Tested and verified.
        // http://stackoverflow.com/questions/1043339/javascript-for-detecting-browser-language-preference
        // var userLang = window.navigator.language || window.navigator.userLanguage;
        // console.log('language from browser prefs: ' + userLang);

        var htmlLang,
            localeLang = $('#typeahead-categorized').attr('data-locale'),
            myLocale = 'en_US';

        // localeLang is kept for backwards compatibility
        if(typeof localeLang !== 'undefined'){
            myLocale = localeLang;
        }else{
            htmlLang = $('html').attr('data-language');
            if(typeof htmlLang !== 'undefined'){
                myLocale = htmlLang;
            }
        }

        if(typeof myLocale !== 'undefined'){
            if ((myLocale !== 'en-US' && myLocale != 'en' && myLocale != "EN" && myLocale != "en-us" && myLocale != "en_us" && myLocale != "en_US") && (lvalue == rvalue)) {
                // this is a string that will cause compare to evaluate to
                // false and the template will render the i18n value
                rvalue = 'this will evaluate to false';
            } else {
                // this will evaluate to true
                rvalue = lvalue;
            }
        } else {
            rvalue = 'true';
            lvalue = 'true';
        }

        if (arguments.length < 3)
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");

        operator = options.hash.operator || "==";

        var operators = {
            '==':       function(l,r) { return l == r; },
            '===':      function(l,r) { return l === r; },
            '!=':       function(l,r) { return l != r; },
            '<':        function(l,r) { return l < r; },
            '>':        function(l,r) { return l > r; },
            '<=':       function(l,r) { return l <= r; },
            '>=':       function(l,r) { return l >= r; },
            'typeof':   function(l,r) { return typeof l == r; }
        }

        if (!operators[operator])
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator "+operator);

        var result = operators[operator](lvalue,rvalue);

        if( result ) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    // The category helper was written to translate and localize category names on the typeahead component
    // as presently we don't have the ability to update the typeahead script so the logic is here.
    // NOTE: This helper can be extended to handle a wide range of values by passing in the categories and translatedCategories arrays,
    // or to simply compare two variables.
    // TODO This logic should all be moved to the typeahead script when possible.

    hb.registerHelper('category', function(categoryName) {

        var categories = ['Airports','Region/City','Attractions','Hotels','Address','Train Station','Metro Station'],
            genericCategories = ['airport','city','attraction','hotel','address','trainstation','metrostation'],
            translated = '',
            indexFlag,

            htmlLang,
            localeLang = $('#typeahead-categorized').attr('data-locale'),
            myLocale = 'en_US';


        // localeLang is kept for backwards compatibility
        if(typeof localeLang !== 'undefined'){
            myLocale = localeLang;
        }else{
            htmlLang = $('html').attr('data-language');
            if(typeof htmlLang !== 'undefined'){
                myLocale = htmlLang;
            }
        }

        indexFlag = $.inArray(categoryName,categories);

        if((typeof myLocale) != 'undefined') {

            if ((myLocale != 'en-US' && myLocale != 'en' && myLocale != "EN" && myLocale != "en-us" && myLocale != "en_us" && myLocale != "en_US") && (indexFlag != -1)) {
                // translate the string
                translated = I18n.t(genericCategories[indexFlag]);
                return translated;

            } else {
                // no need to translate
                translated = categoryName;
                return translated;
            }
        } else {
            // if locale not set, pass through the value of categoryName.
            // this supports default and custom strings
            translated = categoryName;
            return translated;
        }

    });

    return hb;
});



(function(Array){
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
    // Production steps of ECMA-262, Edition 5, 15.4.4.14
    // Reference: http://es5.github.io/#x15.4.4.14
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(searchElement, fromIndex) {

            var k;

            // 1. Let o be the result of calling ToObject passing
            //    the this value as the argument.
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let lenValue be the result of calling the Get
            //    internal method of o with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = o.length >>> 0;

            // 4. If len is 0, return -1.
            if (len === 0) {
                return -1;
            }

            // 5. If argument fromIndex was passed let n be
            //    ToInteger(fromIndex); else let n be 0.
            var n = +fromIndex || 0;

            if (Math.abs(n) === Infinity) {
                n = 0;
            }

            // 6. If n >= len, return -1.
            if (n >= len) {
                return -1;
            }

            // 7. If n >= 0, then Let k be n.
            // 8. Else, n<0, Let k be len - abs(n).
            //    If k is less than 0, then let k be 0.
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            // 9. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ToString(k).
                //   This is implicit for LHS operands of the in operator
                // b. Let kPresent be the result of calling the
                //    HasProperty internal method of o with argument Pk.
                //   This step can be combined with c
                // c. If kPresent is true, then
                //    i.  Let elementK be the result of calling the Get
                //        internal method of o with the argument ToString(k).
                //   ii.  Let same be the result of applying the
                //        Strict Equality Comparison Algorithm to
                //        searchElement and elementK.
                //  iii.  If same is true, return k.
                if (k in o && o[k] === searchElement) {
                    return k;
                }
                k++;
            }
            return -1;
        };
    }
})(Array);


/// <amd-module name="universalTypeahead" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="handlebars.runtime" name="hbRuntime" />
/// <amd-dependency path="handlebars" name="hb" />
/// <amd-dependency path="underscore" name="_" />
/// <amd-dependency path="uitk" name="uitk"/>
/// <amd-dependency path="uitk_i18n" name="i18n"/>
/// <amd-dependency path="hammer" name="Hammer"/>
/// <amd-dependency path="uitk_tooltip"/>
/// <amd-dependency path="uitk-ta-by-category.hbs"/>
/// <amd-dependency path="uitk-ta-default.hbs"/>
/// <amd-dependency path="typeahead/core/loc" name="loc"/>
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>
/// <amd-dependency path="typeahead/core/handlebarHelpers"/>
define("universalTypeahead", ["require", "exports", "jquery", "handlebars.runtime", "handlebars", "underscore", "uitk", "uitk_i18n", "hammer", "typeahead/core/loc", "typeahead/core/context", "typeahead/client/ClientHandlerRegistry", "typeahead/core/ConfigurableFeature", "typeahead/core/EssDataProvider", "typeahead/core/ExpediaSuggestServiceRequestGenerator", "typeahead/core/google/GoogleMapsDataProvider", "typeahead/core/logging/OmnitureLogger", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/ScanabilityLogger", "typeahead/core/logging/SelectionToSubmissionLogger", "typeahead/core/logging/Severity", "typeahead/core/logging/SuggestionEngagementLogger", "typeahead/core/logging/TypeaheadErrorLogger", "typeahead/core/message/ElementFocusedMessage", "typeahead/core/message/InputClearedMessage", "typeahead/core/message/InputValueEditedMessage", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/SuggestionShownMessage", "typeahead/core/message/TypeaheadMessage", "typeahead/core/message/UserExitedMessage", "typeahead/core/OnFocusSuggester", "typeahead/core/plugins/CompositePageLoadHandler", "typeahead/core/plugins/DefaultPluginAssembly", "typeahead/core/plugins/SuggestionsProvider", "typeahead/core/presentation/DropdownContentHandlersAssembly", "typeahead/core/presentation/DropDownHideHandlersAssembly", "typeahead/core/presentation/DropDownShowHandlersAssembly", "typeahead/core/presentation/IInputElementFocusHandler", "typeahead/core/SearchParametersUpdater", "typeahead/core/SuggestionFactory", "typeahead/core/TypeaheadUtils", "typeahead/core/util/Functional", "uitk_tooltip", "uitk-ta-by-category.hbs", "uitk-ta-default.hbs", "typeahead/core/handlebarHelpers"], function (require, exports, $, hbRuntime, hb, _, uitk, i18n, Hammer, loc, coreContext, ClientHandlerRegistry_1, ConfigurableFeature_1, EssDataProvider_1, ExpediaSuggestServiceRequestGenerator_1, GoogleMapsDataProvider_1, OmnitureLogger_1, ProblemOrigin_1, ScanabilityLogger_1, SelectionToSubmissionLogger_1, Severity_1, SuggestionEngagementLogger_1, TypeaheadErrorLogger_1, ElementFocusedMessage_1, InputClearedMessage_1, InputValueEditedMessage_1, SuggestionSelectedMessage_1, SuggestionShownMessage_1, TypeaheadMessage_1, UserExitedMessage_1, OnFocusSuggester_1, CompositePageLoadHandler_1, DefaultPluginAssembly_1, SuggestionsProvider_1, DropdownContentHandlersAssembly_1, DropDownHideHandlersAssembly_1, DropDownShowHandlersAssembly_1, IInputElementFocusHandler_1, SearchParametersUpdater, SuggestionFactory, TypeaheadUtils_1, Functional_1) {
    "use strict";
    exports.__esModule = true;
    var UniversalTypeaheadImpl = (function () {
        function UniversalTypeaheadImpl(inputId, template, options) {
            var _this = this;
            this.essDataProvider = new EssDataProvider_1.EssDataProvider();
            this.suggestionsProvider = new SuggestionsProvider_1.SuggestionsProvider(UniversalTypeaheadImpl.pluginAssembly);
            this.googleMapsDataProvider = new GoogleMapsDataProvider_1.GoogleMapsDataProvider();
            this.defaultEssOptions = {
                abtest: "",
                additionalDataSourceUrl: "",
                dest: false,
                features: [],
                lob: TypeaheadUtils_1.TypeaheadUtils.LOB_ATTRIBUTE.FLIGHTS,
                locale: "en_US",
                mask: TypeaheadUtils_1.TypeaheadUtils.defaultMask,
                maxitems: 20,
                maxresults: 10,
                overrideDataRequest: null,
                overrideServiceUrl: "",
                serviceUrl: "//suggest.expedia.com",
                version: "v2"
            };
            this.defaultTAOptions = {
                // Some options may be overwriten with data-XXX html attributes on the input element
                closetext: loc.closetext,
                continuetext: loc.continuetext,
                forceicon: false,
                minchar: 1,
                /*
                 // notifications
                 //
                 // The gcTypeahead control will notify when these events happen.
                 // They don't expect
                 */
                onInputBlur: null,
                onInputFocus: null,
                // called when an item is selected with mouse or keyboard, with one argument that is the selected <a>.
                onItemSelected: null,
                onItemSelectionChanged: null,
                onPopupClosed: null,
                onPopupOpened: null,
                openDefaultTa: false,
                playBackText: "",
                /*
                 // transform hooks
                 //
                 // preRenderTransform is a hook to allow updating or transforming
                 // the list of items to be rendered.
                 // Caution: called inline when rendering. Should be synchronous and not
                 // take too long to avoid UI jank.
                 // Takes in a search term and a list of items
                 // Returns a new list of items
                 // Used within render thusly:
                 //
                 //    results
                 */
                preRenderTransform: null,
                selectFirstElementByDefault: true,
                tooltip: true
            };
            this.defaultOptions = _.extend({}, this.defaultTAOptions, this.defaultEssOptions);
            this.dropdownContentHandlersAssembly = new DropdownContentHandlersAssembly_1.DropdownContentHandlersAssembly(UniversalTypeaheadImpl.pluginAssembly);
            this.dropDownShowHandlersAssembly = new DropDownShowHandlersAssembly_1.DropDownShowHandlersAssembly(UniversalTypeaheadImpl.pluginAssembly);
            this.dropDownHideHandlersAssembly = new DropDownHideHandlersAssembly_1.DropDownHideHandlersAssembly(UniversalTypeaheadImpl.pluginAssembly);
            this.inputElementFocusHandlers = UniversalTypeaheadImpl.pluginAssembly.get(IInputElementFocusHandler_1.isInputElementFocusHandler);
            this.cachedOnFocusSuggestions = undefined;
            this.onFocusSuggester = new OnFocusSuggester_1.OnFocusSuggester(UniversalTypeaheadImpl.pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.onFocusSuggestionsProviderIdentifier));
            // The <input>
            this.$input = $(inputId);
            // The <input>'s parent (wrapping div)
            this.$parent = this.$input.closest("." + TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.autoCompleteClass);
            // The <input>'s <label>
            this.$label = this.$input.closest("label");
            // Defaults positioning of the autocomplete dropdown to the left. If another class is set, it will stay as is
            this.setPinClass(this.$parent);
            // clone the options - https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
            this.opts = $.extend(true, {}, this.defaultOptions, options, {
                browser: TypeaheadUtils_1.TypeaheadUtils.getBrowser(),
                device: TypeaheadUtils_1.TypeaheadUtils.getDeviceType(),
                guid: TypeaheadUtils_1.TypeaheadUtils.getGuid(),
                locale: coreContext.locale,
                serviceUrl: coreContext.serviceUrl,
                siteid: coreContext.siteid
            });
            this.requestGenerator = this.constructRequestGenerator(this.opts, UniversalTypeaheadImpl.pluginAssembly);
            if (!this.opts.clientId) {
                this.opts.clientId = TypeaheadUtils_1.TypeaheadUtils.getClientId();
            }
            this.context = this.constructContext(this.opts);
            this.opts.featureOverrides = ConfigurableFeature_1.ConfigurableFeature.getFeatureOverrides(this.$input);
            this.ariaOwns = this.$input.attr("aria-owns") || "backwards";
            this.templateUsed = template;
            // Accessibility
            this.firstItemFlag = true;
            this.lastItemFlag = true;
            // "template" can be a CSS selector or an element or precompiled
            if (!this.opts.rawHtml) {
                this.template = this.getCompiledTemplate(template, null);
                if (!this.template) {
                    // maybe the template param is an id for script tag?
                    template = $(template).html();
                    this.template = hb.compile(template);
                }
            }
            else {
                this.template = hb.compile(template);
            }
            // State:
            this.searchType = null;
            this.cache = {};
            this.ignoreNext = false; // ???
            this.isClickOn = false;
            this.bodyClick = false;
            // Set up the input and listeners:
            this.$input.autocomplete = "off";
            this.$input
                .on("focus", $.proxy(this.focus, this))
                .on("keydown", $.proxy(this.keyDown, this))
                .on("keyup", $.proxy(this.keyUp, this))
                .on("keypress", $.proxy(this.keyPress, this))
                .on("input", $.proxy(this.input, this))
                .on("blur", $.proxy(this.blur, this))
                .on("input", $.proxy(this.inputEdit, this));
            // gcTypeahead popup dialog UI is rendered in this element
            this.$popupContent = this.$input
                .closest("." + TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.autoCompleteClass)
                .children("." + TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.dropdownClass);
            if (uitk.isTouchDevice) {
                new Hammer(this.$popupContent[0]).on("tap", $.proxy(this.hammerTapHandler, this));
            }
            // attach a reference of this instance to the input
            // acts as a marker to signal that a gcTypeahead control
            // is attached to the to the element.
            this.$input.data("typeahead", this);
            // Sometimes the first dataRequest is too slow, we ping the service ahead of
            // time to help speed it up:
            if (this.opts.openDefaultTa) {
                this.shouldBeOpen = true;
                this.dataRequest("defaultResponse", false);
            }
            else {
                //
                this.dataRequest("zzzzzz", true);
            }
            this.renderedData = {
                query: "",
                results: []
            };
            if (!UniversalTypeaheadImpl.seLogger) {
                UniversalTypeaheadImpl.seLogger = new SuggestionEngagementLogger_1.SuggestionEngagementLogger();
            }
            if (!UniversalTypeaheadImpl.scanabilityLogger) {
                UniversalTypeaheadImpl.scanabilityLogger = new ScanabilityLogger_1.ScanabilityLogger();
            }
            if (!UniversalTypeaheadImpl.selectionToSubmissionLogger) {
                UniversalTypeaheadImpl.selectionToSubmissionLogger = new SelectionToSubmissionLogger_1.SelectionToSubmissionLogger();
            }
            if (!UniversalTypeaheadImpl.oLogger) {
                UniversalTypeaheadImpl.oLogger = new OmnitureLogger_1.OmnitureLogger();
            }
            TypeaheadMessage_1.TypeaheadMessage.subscribe(InputClearedMessage_1.InputClearedMessage.getTopic(), function (topic, message) {
                if (message && message.$elem) {
                    var clearedElementId = message.$elem.attr("id");
                    if (_this.$input.attr("id") === clearedElementId) {
                        _this.inputEdit(null);
                    }
                }
            });
        }
        UniversalTypeaheadImpl.initOmnitureLogger = function () {
            UniversalTypeaheadImpl.oLogger = new OmnitureLogger_1.OmnitureLogger();
        };
        UniversalTypeaheadImpl.getOmnitureLogger = function () {
            return UniversalTypeaheadImpl.oLogger;
        };
        ;
        // takes in an html string and returns an html string
        // with every <a /> tag being marked with a data-row=index
        // attribute. This allows determining the location of an <a/> tag in a list.
        // This can be used to figure out which item in a list the user picked.
        UniversalTypeaheadImpl.prototype.addRowIndexToAnchors = function (htmlStr) {
            var _this = this;
            // create a jQuery object to work with from
            // the incoming html string
            var $jqDev = $("<div/>").html(htmlStr);
            // use this jQuery object to go in and
            // grab all the anchor tags, then loop through
            // those and add a data-row=index attribute
            $jqDev.find("a")
                .each(function (index) {
                $(_this).attr("data-row", index);
            });
            // return the resulting html as a string
            return $jqDev.html();
        };
        // private helper functions
        UniversalTypeaheadImpl.prototype.getCategory = function (result) {
            // Uses "feature detection" rather than looking for
            // a specific version or whatever.
            // returns a type or undefined
            if (result.category === "USERHISTORY") {
                return TypeaheadUtils_1.TypeaheadUtils.CATEGORIES.USERHISTORY;
            }
            else if (typeof result.type !== "undefined") {
                var overrideIcon = TypeaheadUtils_1.TypeaheadUtils.getOverrideIcon(result.type, result.subtype);
                if (typeof overrideIcon === "string") {
                    return TypeaheadUtils_1.TypeaheadUtils.iconOverride(TypeaheadUtils_1.TypeaheadUtils.CATEGORIES[result.type], overrideIcon);
                }
                return TypeaheadUtils_1.TypeaheadUtils.CATEGORIES[result.type];
            }
            else if (typeof result.t !== "undefined") {
                return TypeaheadUtils_1.TypeaheadUtils.CATEGORIES[result.t];
            }
        };
        UniversalTypeaheadImpl.prototype.addIndexToItems = function (items) {
            items.forEach(function (item, i) {
                item.index = i;
            });
        };
        UniversalTypeaheadImpl.prototype.initResultsByCategory = function (results, lob) {
            var categoriesPresent = this.getCategoriesPresent(results);
            var resultsByCategory = {};
            /* tslint:disable-next-line: no-string-literal */
            if (lob === "HOTELS") {
                if (categoriesPresent["Region/City"]) {
                    resultsByCategory["Region/City"] = [];
                }
                /* tslint:disable-next-line: no-string-literal */
                if (categoriesPresent["Attractions"]) {
                    /* tslint:disable-next-line: no-string-literal */
                    resultsByCategory["Attractions"] = [];
                }
                /* tslint:disable-next-line: no-string-literal */
                if (categoriesPresent["Airports"]) {
                    /* tslint:disable-next-line: no-string-literal */
                    resultsByCategory["Airports"] = [];
                }
                /* tslint:disable-next-line: no-string-literal */
                if (categoriesPresent["Amenities"]) {
                    /* tslint:disable-next-line: no-string-literal */
                    resultsByCategory["Amenities"] = [];
                }
                /* tslint:disable-next-line: no-string-literal */
                if (categoriesPresent["Hotels"]) {
                    /* tslint:disable-next-line: no-string-literal */
                    resultsByCategory["Hotels"] = [];
                }
            }
            else if (lob === "CARS") {
                /* tslint:disable-next-line: no-string-literal */
                if (categoriesPresent["Airports"]) {
                    /* tslint:disable-next-line: no-string-literal */
                    resultsByCategory["Airports"] = [];
                }
                if (categoriesPresent["Region/City"]) {
                    resultsByCategory["Region/City"] = [];
                }
                /* tslint:disable-next-line: no-string-literal */
                if (categoriesPresent["Attractions"]) {
                    /* tslint:disable-next-line: no-string-literal */
                    resultsByCategory["Attractions"] = [];
                }
            }
            return resultsByCategory;
        };
        UniversalTypeaheadImpl.prototype.getCategoriesPresent = function (results) {
            var categoriesPresent = {};
            var that = this;
            $.each(results, function (i, result) {
                var category = that.getCategory(result);
                var categoryName = category ? category.name : "Other";
                if (typeof categoriesPresent[categoryName] === "undefined") {
                    categoriesPresent[categoryName] = true;
                }
            });
            return categoriesPresent;
        };
        UniversalTypeaheadImpl.prototype.getResultsByCategory = function (results, lob) {
            var resultsByCategory = this.initResultsByCategory(results, lob);
            var that = this;
            $.each(results, function (i, result) {
                var category = that.getCategory(result);
                // TODO : does this case exist? can we move the string to config?
                var categoryName = category ? category.name : "Other";
                if (typeof resultsByCategory[categoryName] === "undefined") {
                    resultsByCategory[categoryName] = [];
                }
                resultsByCategory[categoryName].push(result);
            });
            return resultsByCategory;
        };
        UniversalTypeaheadImpl.prototype.updateSearchSuggestions = function (suggestions, suggestionsProvider, context, forceIcon) {
            function setSuggestionIcon(suggestion, category) {
                if (forceIcon) {
                    suggestion.icon = forceIcon;
                }
                else {
                    suggestion.icon = category ? category.icon : "location";
                }
            }
            function updateSuggestionLastSearchName(suggestion) {
                if (typeof suggestion.regionNames !== "undefined") {
                    if (typeof suggestion.regionNames.lastSearchName !== "undefined") {
                        suggestion.regionNames.lastSearchName =
                            suggestion.regionNames.lastSearchName.replace(/'/g, "&#39;");
                    }
                    else if (typeof suggestion.regionNames.fullName !== "undefined") {
                        suggestion.regionNames.fullName = suggestion.regionNames.fullName.replace(/'/g, "&#39;");
                        suggestion.regionNames.lastSearchName = suggestion.regionNames.fullName;
                    }
                }
            }
            /**
             * categoryVM is a specific model attribute for the category template.
             * It is not returned by ESS, it is added to differentiate it with the other model attributes.
             */
            function updateSuggestionForCategoryTemplate(suggestion) {
                suggestion.categoryVM = { displayName: "", fullName: "" };
                if ("regionNames" in suggestion) {
                    suggestion.categoryVM.displayName = suggestion.regionNames.displayName;
                    suggestion.categoryVM.fullName = suggestion.regionNames.fullName;
                    suggestion.categoryVM.lastSearchName = suggestion.regionNames.lastSearchName;
                }
                else if ("d" in suggestion) {
                    suggestion.categoryVM.displayName = suggestion.d;
                    suggestion.categoryVM.fullName = suggestion.l;
                }
            }
            var that = this;
            // modify Suggestions
            return this.suggestionsProvider.modifySuggestions(suggestions, context, this.opts)
                .then(function (modifiedSuggestions) {
                $.each(modifiedSuggestions, function (i, suggestion) {
                    var category = that.getCategory(suggestion);
                    suggestion.categoryName = category ? category.name : "Other";
                    if (!suggestion.icon) {
                        setSuggestionIcon(suggestion, category);
                    }
                    updateSuggestionLastSearchName(suggestion);
                    updateSuggestionForCategoryTemplate(suggestion);
                });
            });
        };
        UniversalTypeaheadImpl.prototype.addTypeaheadPopupHostContainer = function () {
            // Accessibility
            // The ID for the DIV that is to receive the dynamic content
            // passed in via data attribute in INPUT markup.
            // For backwards compatibility, we use a preset ID so that tooltip
            // can append content correctly, even if accessibility doesnt work it won't
            // break pages.
            var acceptingID = "uitk_ta_content";
            var acceptingDiv = "<div id=\"" + acceptingID + "\" role=\"presentation\"></div>";
            var alreadyExists = $("#" + acceptingID).length;
            if (alreadyExists === 0) {
                $("body").append(acceptingDiv);
            }
        };
        UniversalTypeaheadImpl.prototype.getCompiledTemplate = function (templateId, registerPartial) {
            // returns a compiled handlebars template based on an id.
            // The template could be a precompiled template, a named template partial
            // or a template with in a script tag
            var compiledTemplate;
            var script;
            var templateIdNoHash = "";
            if (templateId.length > 1 && templateId.indexOf("#") === 0) {
                // user passed in a jQuery style id such as "#uitk-ta-default"
                templateIdNoHash = templateId.substring(1);
            }
            /* PRE-COMPILED
             There are two places where templates live. One is in the full Handlebars library (AMMD mapped here to "hb")
             and one in the handlebars.runtime library (AMD mapped to "Handlebars"). The uTA server side pre-compiled
             templates live in the Handlebars.partials hash while the UITK templates live in the hb.templates hash. Thus the
              reason for using both "Handlebars" and "hb" here.
            */
            compiledTemplate = hb.partials[templateId] ||
                hbRuntime["default"].partials[templateId] ||
                hb.templates[templateIdNoHash] ||
                hb.templates[templateIdNoHash
                    + ".hbs"];
            if (!compiledTemplate) {
                // UN-COMPILED
                // check for <script> tag
                script = $(templateId);
                if (script.length > 0) {
                    compiledTemplate = hb.compile(script.html());
                }
                else {
                    TypeaheadErrorLogger_1["default"].log(new Error("ERROR: No template found"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
                    return;
                }
            }
            if (registerPartial) {
                hbRuntime["default"].registerPartial(templateId, compiledTemplate);
            }
            return compiledTemplate;
        };
        UniversalTypeaheadImpl.prototype.constructContext = function (opts) {
            return {
                clientId: opts.clientId,
                expuserid: TypeaheadUtils_1.TypeaheadUtils.getExpUserId(),
                guid: opts.guid,
                lob: opts.lob,
                locale: opts.locale,
                siteid: opts.siteid,
                tab: ClientHandlerRegistry_1.ClientHandlerRegistry.getTab()
            };
        };
        UniversalTypeaheadImpl.prototype.constructSuggestionServiceUrlOptions = function (opts) {
            return {
                locale: opts.locale,
                overrideServiceUrl: opts.overrideServiceUrl,
                serviceUrl: opts.serviceUrl,
                suggestServiceUrl: opts.suggestServiceUrl
            };
        };
        UniversalTypeaheadImpl.prototype.constructRequestGenerator = function (opts, pluginAssembly) {
            var generator = new ExpediaSuggestServiceRequestGenerator_1.ExpediaSuggestServiceRequestGenerator(ExpediaSuggestServiceRequestGenerator_1.ExpediaSuggestServiceRequestGenerator.ESS_ABACUS_IDS, _.isFunction(ExpediaSuggestServiceRequestGenerator_1.ExpediaSuggestServiceRequestGenerator.defaultVariantAssigner) ?
                ExpediaSuggestServiceRequestGenerator_1.ExpediaSuggestServiceRequestGenerator.defaultVariantAssigner : undefined, this.constructSuggestionServiceUrlOptions(opts), opts.siteid, pluginAssembly);
            return generator;
        };
        UniversalTypeaheadImpl.prototype.getDomElementId = function () {
            return this.$input.attr("id");
        };
        UniversalTypeaheadImpl.prototype.showPopup = function () {
            if (this.$popupContent.is(":hidden")) {
                // handle mouse messages
                this.$popupContent
                    .on("mousedown", $.proxy(this.clickOn, this))
                    .on("mouseup", $.proxy(this.clickOff, this))
                    .on("mouseenter", "a", $.proxy(this.mouseEnter, this));
                this.$popupContent.closest("." + TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.autoCompleteClass).
                    addClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.openClass);
                this.$popupContent.show();
                this.dropDownShowHandlersAssembly.runHandlers(this.$popupContent, this.$input, this.context);
            }
            this.dropdownContentHandlersAssembly.runHandlers(this.$popupContent, this.$input, this.context);
        };
        UniversalTypeaheadImpl.prototype.startRequest = function () {
            var srchText = this.$input.val();
            if (srchText.length >= this.opts.minchar) {
                var cachedEssResponse = this.cache[srchText];
                if (!cachedEssResponse) {
                    this.dataRequest(srchText);
                }
                else {
                    this.render(cachedEssResponse.query, cachedEssResponse.results, cachedEssResponse.activeABTests);
                }
            }
            else {
                this.close();
            }
        };
        UniversalTypeaheadImpl.prototype.dataRequest = function (srchText, ignoreResults) {
            if (ignoreResults === void 0) { ignoreResults = false; }
            var typeaheadOptions = $.extend(true, {}, this.opts, {
                context: this.context,
                ignoreResults: ignoreResults,
                inputElementId: this.getDomElementId(),
                requestGenerator: this.requestGenerator,
                srchText: srchText
            });
            this.essDataProvider
                .fetchData(typeaheadOptions)
                .then($.proxy(this.essResponseResolver, this))
                .fail(function (error) {
                TypeaheadErrorLogger_1["default"].log(error, Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ExpediaSuggestService);
            });
        };
        UniversalTypeaheadImpl.prototype.essResponseResolver = function (essResponse) {
            var _this = this;
            if (essResponse) {
                if (essResponse.isReferralToGoogleMaps) {
                    var options = $.extend(true, {}, this.opts, {
                        activeEssTests: essResponse.activeABTests,
                        domElementId: this.getDomElementId(),
                        requestType: essResponse.responseCode,
                        srchText: essResponse.query
                    });
                    this.googleMapsDataProvider.fetchData(options).then(function (response) {
                        _this.googleMapsDataProviderResponseResolver(response);
                    });
                }
                else {
                    this.cache[essResponse.query] = essResponse;
                    if (essResponse.results && this.shouldBeOpen) {
                        this.render(essResponse.query, essResponse.results, essResponse.activeABTests);
                    }
                    else {
                        this.close();
                    }
                }
            }
        };
        UniversalTypeaheadImpl.prototype.googleMapsDataProviderResponseResolver = function (response) {
            this.cache[response.query] = response;
            if (response.results && this.shouldBeOpen) {
                this.render(response.query, response.results, undefined);
            }
            else {
                this.close();
            }
        };
        UniversalTypeaheadImpl.prototype.appendUserTypedText = function (results, text) {
            var addPlayBackText = true;
            var textResult = {};
            var regex = /\d/;
            var regexScript = /<script[\s\S]+?script\s*>?/ig;
            var str;
            if (this.opts.playBackText && text !== "defaultResponse") {
                $.each(results, function (i, result) {
                    if (result.id === -1) {
                        addPlayBackText = false;
                    }
                });
                if (addPlayBackText) {
                    // scrub input for script tags
                    text = text.replace(regexScript, "");
                    // What's happening here is that the "playBackText" string that's passed
                    // in via the options parameter is expected to have a digit that will be
                    // replaced by the search term text.
                    // Example:
                    //      "Hello, '0'".replace(/\d/, 'world');
                    // will output the string
                    //     Hello, 'world'
                    // This is a poor man's way of doing a simple format string.
                    str = this.opts.playBackText;
                    str = str.replace(regex, text);
                    textResult.l = text;
                    textResult.d = str;
                    textResult.id = -1;
                    textResult.i = -1;
                    if (this.opts.lob === "HOTELS") {
                        textResult.t = "HOTEL";
                    }
                    // append the new play back text line item
                    results.push(textResult);
                }
            }
        };
        UniversalTypeaheadImpl.prototype.render = function (srchTerm, suggestions, activeABTests) {
            var renderStart = Date.now();
            /* if input element text value does not match with the search term value, it means that the response received
                 is for a previous input text value and should not be rendered */
            if (this.$input.val() && srchTerm && this.$input.val() !== srchTerm && !this.opts.openDefaultTa) {
                return;
            }
            var results = $.extend(true, [], suggestions); // (jQuery) clone the suggestions array
            // if there are no results available, do not render and close the dropdown if already open
            if (results.length === 0) {
                this.close();
                return;
            }
            var content = "";
            var resultsByCategory = {};
            var height;
            var offset;
            var resultsMessage;
            var resultsNo;
            var that = this;
            var viewModel;
            if ($(document.activeElement).attr("id") !== this.$input.attr("id")) {
                // if this input control is not the one with focus, then don't render
                return;
            }
            this.appendUserTypedText(results, srchTerm);
            this.addIndexToItems(results);
            // if we have a preRenderTransform hook registered, call it now
            // This hook allows outside callers to alter, add to, or even replace the list
            // of search results. The call is expected to return the new list, however it's been altered.
            // NOTE: We may not want this hook as it allows outside caller to totally alter the
            // the list of items that's been carefully crafted to work with the templates. Perhaps a
            // hook like this should only allow altering say the display name or something????
            if (this.opts.preRenderTransform && typeof this.opts.preRenderTransform === "function") {
                results = this.opts.preRenderTransform(srchTerm, results);
                if (!results || !_.isArray(results)) {
                    throw new Error("preRenderTransform callback must return a valid array.");
                }
            }
            this.updateSearchSuggestions(results, this.suggestionsProvider, this.context, this.opts.forceicon)
                .then(function () {
                // re-index items after allowing updates to list
                that.addIndexToItems(results);
                resultsByCategory = that.getResultsByCategory(results, that.opts.lob);
                // The viewModel object is the data context passed to
                // the Handlebars template in order to resolve the variables
                // in the mustaches: ex: {{ariaOwns}}
                viewModel = {
                    // TODO: These view model properties in here are the ones that
                    // the Handlebars templates expect so should be called out
                    // in the docs for the custom "template" parameter passed
                    // in to initTA()
                    closeText: that.opts.closetext,
                    continueText: that.opts.continuetext,
                    results: results,
                    resultsByCategory: resultsByCategory
                };
                // Fix for Android with Talkback on
                if (!(("android" in Modernizr) && Modernizr.android)) {
                    viewModel.ariaOwns = that.ariaOwns;
                }
                that.renderedData.query = srchTerm;
                that.renderedData.results = $.extend(true, [], results);
                // apply the viewModel to the template to generate the final UI
                // popup content, then add to DOM and show
                content = that.template(viewModel);
                that.$popupContent.html(that.addRowIndexToAnchors(content));
                that.showPopup();
                that.$label.addClass("focused");
                resultsNo = results.length;
                if (resultsNo === 1) {
                    resultsMessage = "typeahead_results_displayed_one";
                }
                else {
                    resultsMessage = "typeahead_results_displayed_other";
                }
                if (conditionizr.safari) {
                    setTimeout(function () {
                        uitk.utils.liveAnnounce(i18n.t(resultsMessage, {
                            arg0: resultsNo
                        }), "polite");
                        setTimeout(function () {
                            uitk.utils.liveAnnounce("", "polite");
                        }, 200); // Reset the last spoken text
                    }, 800); // Delay to give enough time for the voice over to finish saying the current word
                }
                else {
                    uitk.utils.liveAnnounce(i18n.t(resultsMessage, {
                        arg0: resultsNo
                    }), "polite");
                }
                var renderEnd = Date.now();
                var renderTime = renderEnd - renderStart;
                TypeaheadMessage_1.TypeaheadMessage.publish(new SuggestionShownMessage_1.SuggestionShownMessage(that.renderedData.results, srchTerm, activeABTests, that.opts.lob, renderTime, that.getDomElementId()));
            });
        };
        UniversalTypeaheadImpl.prototype.close = function () {
            var _this = this;
            // unhook mouse messages
            this.$popupContent
                .off("mousedown", $.proxy(this.clickOn, this))
                .off("mouseup", $.proxy(this.clickOff, this))
                .off("mouseenter", "a", $.proxy(this.mouseEnter, this));
            if (this.$popupContent.is(":hidden")) {
                return;
            }
            this.$label.removeClass("focused");
            this.$popupContent.closest("." + TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.autoCompleteClass).removeClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.openClass);
            this.removeActiveDescendant();
            if (this.bodyClick) {
                this.$popupContent.unbind("mousedown", $.proxy(this.cancelEvent, this));
                $(document.body).unbind("mousedown", $.proxy(this.close, this));
                this.bodyClick = false;
            }
            this.dropDownHideHandlersAssembly.runHandlers(this.$popupContent, this.$input, this.context);
            var scrollTopToRestore = $(document.body).scrollTop();
            setTimeout(function () {
                $(document.body).scrollTop(scrollTopToRestore);
                _this.$popupContent.hide();
                _this.$popupContent.html("");
            }, 0);
        };
        // Accessibility
        // Added to remove the aria-activedescendant attribute when closing the dropdown. This was previously
        // taken care automatically by Tooltips. The attribute should be removed once the dropdown is closed for
        // any reason including selection, blur, etc.
        UniversalTypeaheadImpl.prototype.removeActiveDescendant = function () {
            var needToRemove = $("input[aria-activedescendant]");
            if (needToRemove.length > 0) {
                needToRemove.removeAttr("aria-activedescendant");
            }
        };
        UniversalTypeaheadImpl.prototype.prev = function () {
            var links = this.$popupContent.find("a");
            var current = this.$popupContent.find("." +
                TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass).removeClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
            var i = links.index(current);
            var prevIndex = i - 1;
            var prev = links[prevIndex];
            var $prev = $(prev);
            var prevID = $(prev).attr("id");
            var lastItem = links.length - 1;
            var accyText = "";
            if (prevIndex < -1) {
                // when prevIndex is -2 (or less)
                // the user has up-arrowed back into the input box.
                // On the next up-arrow, roll around to the last item or bottom
                // in the list, whatever that is (could be "Close" button if we have one)
                prev = links[lastItem];
                $prev = $(prev);
            }
            if (prev) {
                $(prev).addClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
                // if we have a on onInputFocus handler registered, call it now
                if (this.opts.onItemSelectionChanged && typeof this.opts.onItemSelectionChanged === "function") {
                    this.opts.onItemSelectionChanged($prev);
                }
                if ($(prev).hasClass("close")) {
                    uitk.utils.liveAnnounce(i18n.t("close"), "assertive");
                }
                else {
                    accyText = $(prev).attr("data-value");
                    // conditionally doing liveAnnounce as it is causing NVDA to read extraneous data-value on Firefox
                    if (!conditionizr.firefox) {
                        uitk.utils.liveAnnounce(accyText, "polite");
                    }
                    this.$input.attr("aria-activedescendant", prevID);
                }
            }
            else {
                // "reset" by removing attributes
                this.$input.removeAttr("aria-activedescendant");
                // Accessibility: when user navigates back to input, read the value (Toby)
                uitk.utils.liveAnnounce(this.$input.val(), "polite");
            }
        };
        UniversalTypeaheadImpl.prototype.next = function () {
            var links = this.$popupContent.find("a");
            var current = this.$popupContent.find("." +
                TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass).removeClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
            var i = links.index(current);
            var nextIndex = i + 1;
            var next = links[nextIndex];
            var $next = $(next);
            var nextID = $(next).attr("id");
            var item;
            var accyText = "";
            if (next) {
                $next.addClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
                // if we have a on onInputFocus handler registered, call it now
                if (this.opts.onItemSelectionChanged && typeof this.opts.onItemSelectionChanged === "function") {
                    this.opts.onItemSelectionChanged($next);
                }
                if ($(next).hasClass("close")) {
                    uitk.utils.liveAnnounce(i18n.t("close"), "assertive");
                }
                else {
                    this.$input.attr("aria-activedescendant", nextID);
                    // conditionally doing liveAnnounce as it is causing NVDA to read extraneous data-value on Firefox
                    if (!conditionizr.firefox) {
                        uitk.utils.liveAnnounce($(next).attr("data-value"), "polite");
                    }
                }
            }
            else {
                // Accessibility: navigated to input, read the value (Toby)
                uitk.utils.liveAnnounce(this.$input.val(), "polite");
            }
        };
        UniversalTypeaheadImpl.prototype.removeHighlights = function () {
            this.$popupContent.find("." +
                TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass).removeClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
        };
        UniversalTypeaheadImpl.prototype.getSelectedSuggestion = function (itemId) {
            if (this.renderedData.results && itemId) {
                var resultIndex = itemId.substring(itemId.lastIndexOf("-") + 1);
                // Check if the result has Child
                var nextIndex = parseInt(resultIndex, 10) + 1;
                var hasChild = false;
                if (nextIndex < this.renderedData.results.length) {
                    var nextSuggestion = this.renderedData.results[nextIndex];
                    hasChild = (nextSuggestion.hierarchyInfo && nextSuggestion.hierarchyInfo.isChild === "true");
                }
                return SuggestionFactory.createSuggestion(this.renderedData.results[resultIndex], hasChild);
            }
            return null;
        };
        UniversalTypeaheadImpl.prototype.selectHighlighted = function (e, closeFlag) {
            var $item = this.$popupContent.find("." + TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
            var itemTextFull = $item.text();
            var itemText;
            var closeText;
            var $html = $("html");
            var resultsClass = "results-item";
            var target = $(e.target);
            // either the closeFlag was specifically passed in or the
            // the user actually clicked (or pressed enter key) on the close button
            closeFlag = closeFlag || target.hasClass("close") || target.parent().hasClass("close");
            // used for touch devices as they don't have hover and therefore don't highlight
            if (uitk.isTouchDevice) {
                $item = target.closest("." + resultsClass).find("a");
                itemTextFull = $item.text();
                // User clicked on Close
                closeFlag = (itemTextFull === "");
            }
            // this trims whitespace off ends of the string
            itemText = itemTextFull.replace(/(^\s+|\s+$)/g, "");
            this.updateTextField($item);
            $item.removeClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.hlClass);
            // Accessibility
            // Announces that a selection has been made and the value selected,
            // or that the user closed the menu with the close button.
            // NOTE: once the sentences have been localized, we can simplify this logic below.
            if (closeFlag === true) {
                // the close button was selected, so
                // get the potentially localized 'close' text
                closeText = $item.text().replace(/(^\s+|\s+$)/g, "");
                uitk.utils.liveAnnounce(i18n.t("close_button_menu_closed"));
                this.close();
            }
            else {
                var msg = i18n.t("item_selected_menu_closed", {
                    "arg0": itemText
                });
                uitk.utils.liveAnnounce(msg, "assertive");
            }
            // Publish selected suggestion payload
            if ($item && $item.attr("id")) {
                var selectedSuggestion = this.getSelectedSuggestion($item.attr("id"));
                SearchParametersUpdater.updateForSuggestion(this.$input.val(), selectedSuggestion, this.opts);
                TypeaheadMessage_1.TypeaheadMessage.publish(new SuggestionSelectedMessage_1.SuggestionSelectedMessage(selectedSuggestion, e, this.opts.lob, this.getDomElementId()));
            }
            $item.context = this.$input;
            // Publish select element event on typeahead select (Used by HSRP client)
            // TODO: needs to be removed in future
            var data = {
                element: $item
            };
            uitk.publish("typeahead.resultSelected", data);
        };
        UniversalTypeaheadImpl.prototype.updateTextField = function ($item) {
            var _this = this;
            var func;
            var lastDashIndex;
            var resultIndex;
            var searchResult;
            var value;
            var itemId = $item.attr("id");
            if ($item && itemId) {
                lastDashIndex = itemId.lastIndexOf("-");
                resultIndex = +itemId.substring(lastDashIndex + 1);
                searchResult = this.renderedData.results[resultIndex];
                value = $item.attr("data-value");
                if (value) {
                    value = value.replace(/&#39;/g, "'");
                    this.$input.val(value);
                    var id = $item.attr("data-id");
                    if (id) {
                        this.$input.attr("data-id", id);
                    }
                }
                this.close();
                setTimeout(function () {
                    if (_this.$input[0]) {
                        _this.$input[0].setSelectionRange(0, 9999);
                    }
                }, 0);
            }
        };
        UniversalTypeaheadImpl.prototype.focus = function (evt) {
            var _this = this;
            if (!evt.isTrigger) {
                TypeaheadMessage_1.TypeaheadMessage.publish(new ElementFocusedMessage_1.ElementFocusedMessage(this.$input.val(), this.context, this.getDomElementId()));
                Functional_1.mapMethodByName(this.inputElementFocusHandlers, "handleInputElementFocus", this.$input, this.context);
                if (this.cachedOnFocusSuggestions) {
                    this.render("", this.cachedOnFocusSuggestions, "");
                }
                else {
                    var oldInputValue_1 = this.$input.val();
                    this.onFocusSuggester.suggest(this.opts, this.context)
                        .done($.proxy(function (response) {
                        if (response) {
                            _this.cachedOnFocusSuggestions = response.results;
                            // render only if input value is empty or has not changed
                            if (!_this.$input.val() || oldInputValue_1 === _this.$input.val()) {
                                _this.render("", _this.cachedOnFocusSuggestions, "");
                            }
                        }
                    }, this));
                }
                // if we have a on onInputFocus handler registered, call it now
                if (this.opts.onInputFocus && typeof this.opts.onInputFocus === "function") {
                    this.opts.onInputFocus(evt);
                }
            }
        };
        UniversalTypeaheadImpl.prototype.blur = function (evt) {
            var _this = this;
            // whenever the input loses focus, the popup window should close
            // after this handler has run to completion
            // For local testing please comment the below line to prevent TA closing on inspection
            setTimeout($.proxy(function () { _this.close(); }, this), 0);
            // if we have a on onInputBlur handler registered, call it now
            if (this.opts.onInputBlur && typeof this.opts.onInputBlur === "function") {
                this.opts.onInputBlur(evt);
            }
            // IE10 Win8 fix
            if (window.navigator.msPointerEnabled && !window.PointerEvent) {
                return;
            }
            // need a delay so we can cancel if the ta is being clicked on
            if (this.isClickOn) {
                this.$popupContent.bind("mousedown", $.proxy(this.cancelEvent, this));
                $(document.body).bind("mousedown", $.proxy(this.close, this));
                this.bodyClick = true;
            }
            TypeaheadMessage_1.TypeaheadMessage.publish(new UserExitedMessage_1.UserExitedMessage());
        };
        UniversalTypeaheadImpl.prototype.inputEdit = function (evt) {
            SearchParametersUpdater.updateForSuggestion(this.$input.val(), undefined, this.opts);
            TypeaheadMessage_1.TypeaheadMessage.publish(new InputValueEditedMessage_1.InputValueEditedMessage(this.$input.val(), this.opts.lob, this.getDomElementId()));
            // Callback
            if (this.opts.onInputEdited) {
                this.opts.onInputEdited(this.$input.val());
            }
        };
        UniversalTypeaheadImpl.prototype.keyDown = function (evt) {
            var keyCode;
            if (!evt) {
                evt = window.event;
            }
            keyCode = evt.keyCode;
            switch (keyCode) {
                case 27:// Escape
                    this.close();
                    evt.stopPropagation();
                    break;
                case 9: // Tab
                case 13:// Enter
                    if (this.opts.selectFirstElementByDefault) {
                        if (this.$popupContent.find(".highlight").length <= 0 && this.$label.hasClass("focused")) {
                            var liElm = this.$popupContent.find("li.category-item");
                            if (!liElm || liElm.length === 0) {
                                liElm = this.$popupContent.find("li.results-item");
                            }
                            if (liElm) {
                                var firstLiElm = liElm.first();
                                if (firstLiElm) {
                                    firstLiElm.find("a").addClass("highlight");
                                }
                            }
                        }
                    }
                    if (this.$popupContent.find(".highlight").length) {
                        // The stopPropagation() in the following line might be a source of bugs similar to these:
                        //     https://jira/jira/browse/MAIN-155786
                        //     https://jira/jira/browse/MAIN-155786
                        // The target of the event is the <input>, on which there may be other handlers for the same keyDown
                        // event, and stopPropagation() may prevent those handlers from running. That may not be desirable.
                        // The reason why that line was added cannot be discovered, and it is unclear whether removing it
                        // will cause regression.
                        evt.stopPropagation();
                        if (keyCode === 13) {
                            evt.preventDefault();
                        }
                        this.selectHighlighted(evt, this.$popupContent.find(".highlight").hasClass("close"));
                    }
                    break;
                case 32:// space
                    if (this.$popupContent.find(".highlight").hasClass("close")) {
                        evt.stopPropagation();
                        evt.preventDefault();
                    }
                    break;
                case 39:// Right
                    if (this.$popupContent.find(".highlight").length) {
                        this.ignoreNext = true;
                        // The stopPropagation() in the following line might be a source of bugs similar to these:
                        //     https://jira/jira/browse/MAIN-155786
                        //     https://jira/jira/browse/MAIN-155786
                        // The target of the event is the <input>, on which there may be other handlers for the same keyDown
                        // event, and stopPropagation() may prevent those handlers from running. That may not be desirable.
                        // The reason why that line was added cannot be discovered, and it is unclear whether removing it
                        // will cause regression.
                        evt.stopPropagation();
                        this.selectHighlighted(evt, false);
                    }
                    break;
                case 38:// Up
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.prev();
                    break;
                case 40:// Down
                    evt.stopPropagation();
                    evt.preventDefault();
                    this.next();
                    break;
                default:
            }
        };
        UniversalTypeaheadImpl.prototype.keyPress = function (evt) {
            if (!evt) {
                evt = window.event;
            }
            if (evt.keyCode === 13 /* Enter/Return */) {
                this.close();
            }
        };
        UniversalTypeaheadImpl.prototype.keyUp = function (evt) {
            // prevents a key up after an item has been selected by the key board
            if (this.ignoreNext) {
                this.ignoreNext = false;
                return;
            }
            if (!evt) {
                evt = window.event;
            }
            switch (evt.keyCode) {
                case 37:// Left
                    this.removeHighlights();
                    break;
                case 38:// Up
                    evt.preventDefault();
                    evt.stopPropagation();
                    break;
                case 40:// Down
                    evt.stopPropagation();
                    evt.preventDefault();
                    break;
                case 13:// Enter/Return
                    this.shouldBeOpen = false;
                    break;
                case 32:// space
                    if (this.$popupContent.find(".highlight").hasClass("close")) {
                        evt.stopPropagation();
                        evt.preventDefault();
                        this.selectHighlighted(evt, this.$popupContent.find(".highlight").hasClass("close"));
                    }
                    break;
                default:
            }
        };
        UniversalTypeaheadImpl.prototype.input = function (evt) {
            this.shouldBeOpen = true;
            this.startRequest();
        };
        UniversalTypeaheadImpl.prototype.clickOn = function (evt) {
            var target = $(evt.target);
            if (!(target.hasClass("close") || target.parent().hasClass("close"))) {
                // only set this flag when the user clicks on anything
                // but the close button
                this.isClickOn = true;
            }
            this.click(evt);
        };
        UniversalTypeaheadImpl.prototype.clickOff = function () {
            this.isClickOn = false;
        };
        UniversalTypeaheadImpl.prototype.click = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            // A click triggers a selection if and only if it's done with the left mouse button.
            if (evt.button === 0 || uitk.isTouchDevice) {
                this.selectHighlighted(evt, false);
            }
        };
        UniversalTypeaheadImpl.prototype.mouseEnter = function (e) {
            this.removeHighlights();
            $(e.currentTarget).addClass("highlight");
        };
        UniversalTypeaheadImpl.prototype.cancelEvent = function (evt) {
            evt.cancelBubble = true;
            if (evt.stopPropagation) {
                evt.stopPropagation();
            }
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            evt.returnValue = false;
        };
        UniversalTypeaheadImpl.prototype.remove = function () {
            this.$input.autocomplete = "on";
            this.$input.closest("form").attr("autocomplete", "on");
            this.$input
                .off("focus", $.proxy(this.focus, this))
                .off("keydown", $.proxy(this.keyDown, this))
                .off("keyup", $.proxy(this.keyUp, this))
                .off("keypress", $.proxy(this.keyPress, this))
                .off("input", $.proxy(this.input, this))
                .off("blur", $.proxy(this.blur, this));
            this.$popupContent
                .off("mousedown", $.proxy(this.clickOn, this))
                .off("mouseup", $.proxy(this.clickOff, this))
                .off("mouseenter", "a", $.proxy(this.mouseEnter, this))
                .remove(); // removes this element from the DOM as well as all its children
        };
        UniversalTypeaheadImpl.prototype.setPinClass = function ($parent) {
            if (!$parent.hasClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.leftClass) &&
                !$parent.hasClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.rightClass) &&
                !$parent.hasClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.centerClass)) {
                $parent.addClass(TypeaheadUtils_1.TypeaheadUtils.responsiveTAClasses.leftClass);
            }
        };
        UniversalTypeaheadImpl.prototype.hammerTapHandler = function (hammerInput) {
            var srcEvent = _.isObject(hammerInput) && hammerInput.srcEvent;
            if (_.isObject(srcEvent)) {
                this.click(srcEvent);
            }
        };
        /*
         this plugin assembly is parked here so that we could wrap it in this module
         the rationale I put it here is so that we don't introduce additional dependency
         in the same time, it could be considered as our plugin registry
         */
        UniversalTypeaheadImpl.pluginAssembly = new DefaultPluginAssembly_1.DefaultPluginAssembly();
        // This is literally the name of a jQuery plugin that
        // is available on every DOM element where UITK is on the page.
        UniversalTypeaheadImpl.tooltipPlugin = "uitk_tooltip";
        return UniversalTypeaheadImpl;
    }());
    ;
    function handlePageLoad() {
        UniversalTypeaheadImpl.initOmnitureLogger();
        // Page load handlers have to be called after all amd modules have initialized
        setTimeout(function () {
            // For mercury wizard (Storefront clients), wait for gc/pageModel to be ready before calling page load handlers
            if (TypeaheadUtils_1.TypeaheadUtils.isStorefrontClient()) {
                require(["gc/pageModel"], function (gcPageModel) {
                    CompositePageLoadHandler_1.CompositePageLoadHandler.getInstance().handlePageLoad(UniversalTypeaheadImpl.pluginAssembly);
                });
            }
            else {
                CompositePageLoadHandler_1.CompositePageLoadHandler.getInstance().handlePageLoad(UniversalTypeaheadImpl.pluginAssembly);
            }
        }, 0);
    }
    exports.handlePageLoad = handlePageLoad;
    function initTA(input, template, options) {
        return new UniversalTypeaheadImpl(input, template, options);
    }
    exports.initTA = initTA;
    function registerPlugin(plugin) {
        UniversalTypeaheadImpl.pluginAssembly.registerPlugin(plugin);
    }
    exports.registerPlugin = registerPlugin;
});



require('handlebars.runtime', function(hbRuntime) { hbRuntime.default.registerPartial("hbs/templates/destinationCustom", hbRuntime.default.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <li class=\"results-item\" role=\"presentation\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.html : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "    </li>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "            "
    + ((stack1 = ((helper = (helper = helpers.html || (depth0 != null ? depth0.html : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"html","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "            <a href=\"#\"\n               class=\"details\"\n               data-value=\""
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n               id=\"aria-option-"
    + alias1(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n               role=\"option\" tabindex=\"-1\"\n               aria-selected=\"false\"\n               data-type=\""
    + alias1(((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"type","hash":{},"data":data}) : helper)))
    + "\"\n               data-id=\""
    + alias1(((helper = (helper = helpers.gaiaId || (depth0 != null ? depth0.gaiaId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"gaiaId","hash":{},"data":data}) : helper)))
    + "\">\n                "
    + ((stack1 = (helpers.createListItem || (depth0 && depth0.createListItem) || alias2).call(depth0,depth0,{"name":"createListItem","hash":{},"data":data})) != null ? stack1 : "")
    + "\n            </a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<ul id=\""
    + this.escapeExpression(((helper = (helper = helpers.ariaOwns || (depth0 != null ? depth0.ariaOwns : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ariaOwns","hash":{},"data":data}) : helper)))
    + "\" role=\"listbox\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.results : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n<footer class=\"footer\">\n    <a class=\"close\" href=\"#\" tabindex='-1' aria-label='"
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'>\n        "
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n        <span class=\"icon icon-close\"></span>\n    </a>\n</footer>\n";
},"useData":true}));});
require('handlebars.runtime', function(hbRuntime) { hbRuntime.default.registerPartial("hbs/templates/gemmaCustom", hbRuntime.default.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "    <li class=\"results-item\" role=\"presentation\">\n        <a href=\"#\"\n           class=\"details\"\n           data-value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n           id=\"aria-option-"
    + alias2(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n           role=\"option\" tabindex=\"-1\"\n           aria-selected=\"false\"\n           data-id=\""
    + alias2(((helper = (helper = helpers.gaiaId || (depth0 != null ? depth0.gaiaId : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"gaiaId","hash":{},"data":data}) : helper)))
    + "\">\n            <span class=\"icon icon-"
    + alias2(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" aria-hidden='true'></span>"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "\n        </a>\n    </li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<ul id=\""
    + this.escapeExpression(((helper = (helper = helpers.ariaOwns || (depth0 != null ? depth0.ariaOwns : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ariaOwns","hash":{},"data":data}) : helper)))
    + "\" role=\"listbox\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.results : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n<footer class=\"footer\">\n    <a class=\"close\" href=\"#\" tabindex='-1' aria-label='"
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'>\n        "
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n        <span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true}));});
require('handlebars.runtime', function(hbRuntime) { hbRuntime.default.registerPartial("hbs/templates/originCategoryCustom", hbRuntime.default.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li role=\"presentation\"\n            data-tid=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n            id=\"typeahead-category-"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\"\n            class=\"results-item-ally category-name-ally\"\n            style=\"list-style: none\">"
    + alias3(((helper = (helper = helpers.categoryName || (depth0 != null ? depth0.categoryName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"categoryName","hash":{},"data":data}) : helper)))
    + "\n        </li>\n"
    + ((stack1 = helpers.each.call(depth0,depth0,{"name":"each","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        <li class=\"category-divider\" style=\"list-style:none\">&nbsp;</li>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.lambda, alias2=this.escapeExpression, alias3=helpers.helperMissing, alias4="function";

  return "        <a href=\"#\"\n           class=\"details\"\n           data-value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.categoryVM : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n           id=\"aria-option-"
    + alias2(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n           role=\"option\" tabindex=\"-1\"\n           aria-selected=\"false\"\n           data-id=\""
    + alias2(((helper = (helper = helpers.gaiaId || (depth0 != null ? depth0.gaiaId : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"gaiaId","hash":{},"data":data}) : helper)))
    + "\">\n           <span class=\"icon icon-"
    + alias2(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\"\n                 aria-hidden='true'></span>"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.categoryVM : depth0)) != null ? stack1.displayName : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<ul role=\"presentation\" data-tid=\"typeahead-list-category\">\n"
    + ((stack1 = (helpers.each_with_key || (depth0 && depth0.each_with_key) || alias1).call(depth0,(depth0 != null ? depth0.resultsByCategory : depth0),{"name":"each_with_key","hash":{"key":"categoryName"},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n<footer class=\"footer\">\n    <a class=\"close\" tabindex='-1' href=\"#\" aria-label='"
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'>\n        "
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n        <span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true}));});
require('handlebars.runtime', function(hbRuntime) { hbRuntime.default.registerPartial("hbs/templates/originDefaultCustom", hbRuntime.default.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=this.escapeExpression, alias2=helpers.helperMissing, alias3="function";

  return "    <li class=\"results-item\" role=\"presentation\">\n        <a href=\"#\"\n            class=\"details\"\n            data-value=\""
    + alias1(this.lambda(((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.lastSearchName : stack1), depth0))
    + "\"\n            id=\"aria-option-"
    + alias1(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\"\n            role=\"option\" tabindex=\"-1\"\n            aria-selected=\"false\"\n            data-id=\""
    + alias1(((helper = (helper = helpers.gaiaId || (depth0 != null ? depth0.gaiaId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(depth0,{"name":"gaiaId","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showAsHierarchy : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "        </a>\n    </li>\n";
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + ((stack1 = (helpers.createSuggestion || (depth0 && depth0.createSuggestion) || helpers.helperMissing).call(depth0,true,(depth0 != null ? depth0.index : depth0),undefined,((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),undefined,((stack1 = ((stack1 = (depth0 != null ? depth0.hierarchyInfo : depth0)) != null ? stack1.nearby : stack1)) != null ? stack1.distInMI : stack1),{"name":"createSuggestion","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + ((stack1 = (helpers.createSuggestion || (depth0 && depth0.createSuggestion) || helpers.helperMissing).call(depth0,false,(depth0 != null ? depth0.index : depth0),(depth0 != null ? depth0.icon : depth0),((stack1 = (depth0 != null ? depth0.regionNames : depth0)) != null ? stack1.displayName : stack1),(depth0 != null ? depth0.rightFloatingTextHtml : depth0),{"name":"createSuggestion","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<ul id=\""
    + this.escapeExpression(((helper = (helper = helpers.ariaOwns || (depth0 != null ? depth0.ariaOwns : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"ariaOwns","hash":{},"data":data}) : helper)))
    + "\" role=\"listbox\" class=\"results\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.results : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n<footer class=\"footer\">\n    <a class=\"close\" href=\"#\" tabindex='-1' aria-label='"
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "'>\n        "
    + ((stack1 = ((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"closeText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n        <span class=\"icon icon-close\"></span>\n    </a>\n</footer>";
},"useData":true}));});
define("typeahead/core/geolocation/GeolocationDataProvider", ["require", "exports", "typeahead/core/loc", "typeahead/core/geolocation/message/GeolocationClearedMessage", "typeahead/core/geolocation/message/GeolocationRequestMessage", "typeahead/core/geolocation/message/GeolocationResponseMessage", "typeahead/core/IListItem", "typeahead/core/message/TypeaheadMessage"], function (require, exports, loc, GeolocationClearedMessage_1, GeolocationRequestMessage_1, GeolocationResponseMessage_1, IListItem_1, TypeaheadMessage_1) {
    "use strict";
    exports.__esModule = true;
    var GeolocationDataProvider = (function () {
        function GeolocationDataProvider() {
            this.geolocationResult = {
                category: GeolocationDataProvider.CATEGORY,
                listItemType: IListItem_1.ListItemType.Suggestion,
                regionNames: {
                    displayName: GeolocationDataProvider.MESSAGES.SUGGESTION_TEXT,
                    lastSearchName: GeolocationDataProvider.MESSAGES.DISPLAY_TEXT
                },
                type: GeolocationDataProvider.CATEGORY
            };
        }
        GeolocationDataProvider.prototype.fetchData = function (options) {
            var deferred = $.Deferred();
            return deferred.resolve({ results: [this.getGeolocationResult()] }).promise();
        };
        GeolocationDataProvider.prototype.findGeolocation = function (domElementId, submitButton) {
            var _this = this;
            if (submitButton === void 0) { submitButton = undefined; }
            var responseReceived = false;
            TypeaheadMessage_1.TypeaheadMessage.publish(new GeolocationRequestMessage_1.GeolocationRequestMessage(domElementId));
            navigator.geolocation.getCurrentPosition(function (position) {
                responseReceived = true;
                _this.setGeolocation(position);
                TypeaheadMessage_1.TypeaheadMessage.publish(new GeolocationResponseMessage_1.GeolocationResponseMessage(_this.objectifyPosition(position), undefined, _this.getGeolocationResult(), submitButton));
                setTimeout(function () {
                    _this.setGeolocation(undefined);
                    TypeaheadMessage_1.TypeaheadMessage.publish(new GeolocationClearedMessage_1.GeolocationClearedMessage(_this.getGeolocationResult()));
                }, GeolocationDataProvider.TTL_IN_MILLISEC); // clear after 3 minutes
            }, 
            // Multiple error responses can be received for a single geolocation request
            function (positionError) {
                if (!responseReceived) {
                    responseReceived = true;
                    TypeaheadMessage_1.TypeaheadMessage.publish(new GeolocationResponseMessage_1.GeolocationResponseMessage(undefined, _this.objectifyPositionError(positionError), _this.getGeolocationResult()));
                }
            }, {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: GeolocationDataProvider.TIMEOUT_IN_MILLISEC
            });
        };
        GeolocationDataProvider.prototype.getGeolocationResult = function () {
            return this.geolocationResult;
        };
        GeolocationDataProvider.prototype.setGeolocation = function (position) {
            if (position && position.coords) {
                this.geolocationResult.coordinates = {
                    lat: position.coords.latitude + "",
                    long: position.coords.longitude + ""
                };
            }
            else {
                this.geolocationResult.coordinates = undefined;
            }
        };
        // Postion returned by geolocation api is not a regular json object
        GeolocationDataProvider.prototype.objectifyPosition = function (position) {
            return {
                coords: position.coords ? {
                    accuracy: position.coords.accuracy,
                    altitude: position.coords.altitude,
                    altitudeAccuracy: position.coords.altitudeAccuracy,
                    heading: position.coords.heading,
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    speed: position.coords.speed
                } : undefined,
                timestamp: position.timestamp
            };
        };
        GeolocationDataProvider.prototype.objectifyPositionError = function (positionError) {
            return {
                code: positionError.code,
                message: positionError.message
            };
        };
        GeolocationDataProvider.CATEGORY = "GEOLOCATION";
        GeolocationDataProvider.TIMEOUT_IN_MILLISEC = 6000;
        GeolocationDataProvider.TTL_IN_MILLISEC = 180000;
        GeolocationDataProvider.MESSAGES = {
            DISPLAY_TEXT: loc.geolocationDisplayText || "Your current location",
            SUGGESTION_TEXT: loc.geolocationSuggestionText || "Use your current location"
        };
        return GeolocationDataProvider;
    }());
    exports.GeolocationDataProvider = GeolocationDataProvider;
});



/// <amd-module name="typeahead/core/geolocation/GeolocationIcon" />
define("typeahead/core/geolocation/GeolocationIcon", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports.locationIcon = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE2cHgiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwID" +
        "E2IDE2IiB3aWR0aD0iMTZweCIgDQp4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2" +
        "hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIiANCnhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGUvPjxkZW" +
        "ZzLz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIA0KaWQ9Ikljb25zIHdpdGggbnVtYmVycyIgc3Ryb2tlPSJub25lIiBzdHJva2" +
        "Utd2lkdGg9IjEiPjxnIGZpbGw9IiMwMDY1YjgiIGlkPSJHcm91cCIgDQp0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ0LjAwMDAwMCwgLTE5Mi4wMD" +
        "AwMDApIj4NCjxwYXRoIGQ9Ik0xNDQuMDE3NDU2LDIwMCBMMTYwLjAxOTY1MywxOTIuMDQzMDkxIEwxNTIsMjA4LjA4ODYyMyBMMTUyLDIwMCBMMT" +
        "Q0LjAxNzQ1NiwyMDAgWiBNMTQ0LjAxNzQ1NiwyMDAiIA0KaWQ9IlBhdGggMjIxIi8+PC9nPjwvZz48L3N2Zz4=";
});



/// <amd-module name="typeahead/core/geolocation/GeolocationSuggestion"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/geolocation/GeolocationSuggestion", ["require", "exports", "typeahead/core/Suggestion"], function (require, exports, Suggestion_1) {
    "use strict";
    exports.__esModule = true;
    var GeolocationSuggestion = (function (_super) {
        __extends(GeolocationSuggestion, _super);
        function GeolocationSuggestion() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GeolocationSuggestion.prototype.shouldTriggerDomElementChangeOnSelection = function () {
            return false;
        };
        return GeolocationSuggestion;
    }(Suggestion_1.Suggestion));
    exports.GeolocationSuggestion = GeolocationSuggestion;
});



define("typeahead/core/geolocation/MercuryGeolocationViewController", ["require", "exports", "typeahead/core/loc", "typeahead/core/geolocation/GeolocationDataProvider", "typeahead/core/geolocation/message/GeolocationClearedMessage", "typeahead/core/geolocation/message/GeolocationRequestMessage", "typeahead/core/geolocation/message/GeolocationResponseMessage", "typeahead/core/message/ElementFocusedMessage", "typeahead/core/message/FormSubmittedMessage", "typeahead/core/message/SubmitClickedMessage", "typeahead/core/message/SuggestionAutoSelectedMessage", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/TypeaheadMessage", "typeahead/core/SearchParametersUpdater", "typeahead/core/SuggestionFactory"], function (require, exports, loc, GeolocationDataProvider_1, GeolocationClearedMessage_1, GeolocationRequestMessage_1, GeolocationResponseMessage_1, ElementFocusedMessage_1, FormSubmittedMessage_1, SubmitClickedMessage_1, SuggestionAutoSelectedMessage_1, SuggestionSelectedMessage_1, TypeaheadMessage_1, SearchParametersUpdater, SuggestionFactory) {
    "use strict";
    exports.__esModule = true;
    var MercuryGeolocationViewController = (function () {
        function MercuryGeolocationViewController(geolocationDataProvider) {
            var _this = this;
            this.geolocationDataProvider = geolocationDataProvider;
            this.errorConfigMap = {
                1: { code: 1, closeTypeahead: true, message: MercuryGeolocationViewController.MESSAGES.PERMISSION_DENIED },
                2: { code: 2, closeTypeahead: true, message: MercuryGeolocationViewController.MESSAGES.POSITION_UNAVAILABLE },
                3: { code: 3, closeTypeahead: false, message: MercuryGeolocationViewController.MESSAGES.TIMEOUT },
                4: { code: 4, closeTypeahead: false, message: MercuryGeolocationViewController.MESSAGES.UNKNOWN_ERROR }
            };
            this.interstitialContentSelector = ".wrap";
            TypeaheadMessage_1.TypeaheadMessage.subscribe(ElementFocusedMessage_1.ElementFocusedMessage.getTopic(), function (topic, message) {
                _this.domElementId = message.getDomElementId();
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionSelectedMessage_1.SuggestionSelectedMessage.getTopic(), function (topic, message) {
                if (GeolocationDataProvider_1.GeolocationDataProvider.CATEGORY === message.getSuggestion().getCategory().orElse("") &&
                    !_this.getLatLongElementValue()) {
                    _this.geolocationDataProvider.findGeolocation(_this.getDomElementId());
                }
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SubmitClickedMessage_1.SubmitClickedMessage.getTopic(), function (topic, message) {
                if (_this.isGeolocationSuggestionSelected(_this.getVisibleTypeaheadDivElement())) {
                    if (!_this.getLatLongElementValue()) {
                        if (message.getEvent()) {
                            message.getEvent().preventDefault(); // stop submit
                        }
                        _this.geolocationDataProvider.findGeolocation(_this.getDomElementId(), $(message.getEvent().currentTarget));
                    }
                    else {
                        _this.disableLocalStorage();
                    }
                }
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(FormSubmittedMessage_1.FormSubmittedMessage.getTopic(), function (topic, message) {
                if (message.isFormValid() &&
                    _this.isGeolocationSuggestionSelected(_this.getVisibleTypeaheadDivElement())) {
                    var $form = $("form:has(input[data-provide=utypeahead]):visible");
                    $form.append($("<input>").attr("type", "hidden").attr("name", "sort").val("distance"));
                }
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(GeolocationRequestMessage_1.GeolocationRequestMessage.getTopic(), function (topic, message) {
                _this.showInterstitial();
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(GeolocationResponseMessage_1.GeolocationResponseMessage.getTopic(), function (topic, message) {
                _this.handleGeolocationResponse(message);
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(GeolocationClearedMessage_1.GeolocationClearedMessage.getTopic(), function (topic, message) {
                _this.updateSearchParameters(message.getGeolocationResult(), $("#" + _this.getDomElementId()));
            });
        }
        // On Mobile device, show current location, if no previous search or previous search was current location
        MercuryGeolocationViewController.prototype.updateView = function (tab) {
            var _this = this;
            this.geolocationDataProvider.fetchData(undefined).done(function (response) {
                var suggestionResult = response.results[0];
                var $inputElement = $("form[data-lob-form=" + tab + "]").find("input[name=destination]");
                var $autoCompleteDiv = $inputElement.closest("div.autocomplete");
                if ($autoCompleteDiv.length) {
                    if (!$inputElement.val() || _this.isGeolocationCategory($autoCompleteDiv)) {
                        $inputElement.val(suggestionResult.regionNames.lastSearchName);
                        _this.updateSearchParameters(suggestionResult, $inputElement);
                        TypeaheadMessage_1.TypeaheadMessage.publish(new SuggestionAutoSelectedMessage_1.SuggestionAutoSelectedMessage(SuggestionFactory.createSuggestion(suggestionResult), $inputElement.attr("id")));
                    }
                }
            });
        };
        MercuryGeolocationViewController.prototype.handleGeolocationResponse = function (message) {
            this.hideInterstitial();
            if (message.getPositionError()) {
                this.showErrorModal(message.getPositionError().code);
                $("#" + this.getDomElementId()).val("");
            }
            else {
                this.updateSearchParameters(message.getGeolocationResult(), $("#" + this.getDomElementId()));
                if (message.getSubmitButton()) {
                    message.getSubmitButton().trigger("click");
                }
            }
        };
        MercuryGeolocationViewController.prototype.showInterstitial = function () {
            $("#" + this.getDomElementId()).blur();
            uitk.publish("results.changed", {
                contentId: this.interstitialContentSelector,
                disable: true,
                message: "<p>" + MercuryGeolocationViewController.MESSAGES.FINDING_GEOLOCATION + "</p>",
                scrollToTop: false,
                showLoader: true
            });
        };
        MercuryGeolocationViewController.prototype.hideInterstitial = function () {
            uitk.publish("results.complete", {
                ariaLevel: "polite",
                contentId: this.interstitialContentSelector,
                focusElement: this.getDomElementId()
            });
        };
        MercuryGeolocationViewController.prototype.showErrorModal = function (code) {
            var _this = this;
            var errorModal = uitk.modal.create({
                content: "<p>" + this.getErrorMessage(code) + "</p>",
                focusClose: this.getDomElementId(),
                modalId: "geolocationErrorModal",
                title: MercuryGeolocationViewController.MESSAGES.ERROR_TITLE
            });
            uitk.subscribe("modal.close", function (topic, modal) {
                if (modal === errorModal) {
                    if (!_this.errorConfigMap[code].closeTypeahead) {
                        $("#" + _this.getDomElementId()).one("focus", function () {
                            var htmlInputEl = document.getElementById(_this.getDomElementId());
                            if (htmlInputEl) {
                                htmlInputEl.setSelectionRange(0, 9999);
                            }
                        });
                    }
                }
            });
        };
        MercuryGeolocationViewController.prototype.getErrorMessage = function (code) {
            return this.errorConfigMap[code] ? this.errorConfigMap[code].message : this.errorConfigMap[4].message;
        };
        MercuryGeolocationViewController.prototype.updateSearchParameters = function (suggestionResult, $element) {
            SearchParametersUpdater.updateForSuggestion(undefined, SuggestionFactory.createSuggestion(suggestionResult), $element.data());
        };
        MercuryGeolocationViewController.prototype.isGeolocationCategory = function ($typeaheadDivElement) {
            return GeolocationDataProvider_1.GeolocationDataProvider.CATEGORY === $typeaheadDivElement.find("[id*=category]").val();
        };
        MercuryGeolocationViewController.prototype.isGeolocationSuggestionSelected = function ($typeaheadDivElement) {
            return GeolocationDataProvider_1.GeolocationDataProvider.CATEGORY === $typeaheadDivElement.find("[id*=region_type]").val();
        };
        MercuryGeolocationViewController.prototype.getLatLongElementValue = function () {
            return this.getVisibleTypeaheadDivElement().find("[id*=lat_long]").val();
        };
        MercuryGeolocationViewController.prototype.getDomElementId = function () {
            return this.domElementId ? this.domElementId :
                $("div.autocomplete:visible").find("input[name=destination]").attr("id");
        };
        MercuryGeolocationViewController.prototype.getVisibleTypeaheadDivElement = function () {
            return this.getDomElementId() ? $("#" + this.getDomElementId()).closest("div.autocomplete") :
                $("div.autocomplete:visible");
        };
        MercuryGeolocationViewController.prototype.disableLocalStorage = function () {
            this.getVisibleTypeaheadDivElement().find(".gcw-storeable").not("[id*=category]").each(function (index, element) {
                $(element).removeClass("gcw-storeable");
            });
        };
        MercuryGeolocationViewController.MESSAGES = {
            ERROR_TITLE: loc.geolocationErrorTitle || "We are unable to determine your current location",
            FINDING_GEOLOCATION: loc.geolocationFindingMessage || "Finding your current location",
            PERMISSION_DENIED: loc.geolocationPermissionDeniedMessage || "Please turn on the location services on your " +
                "device so we can determine your location or type in a destination.",
            POSITION_UNAVAILABLE: loc.geolocationPositionUnavailableMessage || "Please type in a destination.",
            TIMEOUT: loc.geolocationTimeoutMessage || "Please retry or type in a destination.",
            UNKNOWN_ERROR: loc.geolocationUnknownErrorMessage || "Please retry or type in a destination."
        };
        return MercuryGeolocationViewController;
    }());
    exports.MercuryGeolocationViewController = MercuryGeolocationViewController;
});



///<amd-module name="typeahead/core/google/AddressAutocompleteFailureMetric" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/google/AddressAutocompleteFailureMetric", ["require", "exports", "typeahead/core/logging/TypeaheadMetric"], function (require, exports, TypeaheadMetric_1) {
    "use strict";
    exports.__esModule = true;
    var AddressAutocompleteFailureMetric = (function (_super) {
        __extends(AddressAutocompleteFailureMetric, _super);
        function AddressAutocompleteFailureMetric(lob, elementId, userTypedQuery, status, activeESSTests) {
            var _this = _super.call(this, lob, elementId, "AddressAutocompleteFailure", activeESSTests) || this;
            _this.userTypedQuery = userTypedQuery;
            _this.status = status;
            return _this;
        }
        return AddressAutocompleteFailureMetric;
    }(TypeaheadMetric_1.TypeaheadMetric));
    exports.AddressAutocompleteFailureMetric = AddressAutocompleteFailureMetric;
});



define("typeahead/core/google/GoogleMapsDataProvider", ["require", "exports", "typeahead/core/EssDataProvider", "typeahead/core/google/AddressAutocompleteFailureMetric", "typeahead/core/google/PoweredByGoogleLogo", "typeahead/core/IListItem", "typeahead/core/logging/CollectorTransport", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger", "typeahead/core/Suggestion"], function (require, exports, EssDataProvider_1, AddressAutocompleteFailureMetric_1, PoweredByGoogleLogo_1, IListItem_1, CollectorTransport_1, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1, Suggestion_1) {
    "use strict";
    exports.__esModule = true;
    // Load and execute google maps api script
    $.getScript("https://maps.googleapis.com/maps/api/js?client=gme-expedia&channel=ess&libraries=places");
    var GoogleMapsDataProvider = (function () {
        function GoogleMapsDataProvider() {
        }
        GoogleMapsDataProvider.getSuggestionResult = function (prediction, index) {
            return {
                category: Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.GOOGLEMAPS],
                coordinates: undefined,
                listItemType: IListItem_1.ListItemType.Suggestion,
                regionNames: {
                    displayName: GoogleMapsDataProvider.boldMatchedSubStringInPrediction(prediction),
                    fullName: prediction.description,
                    lastSearchName: prediction.description
                },
                sourceId: prediction.place_id,
                sourceName: "GPA",
                type: "ADDRESS",
                index: index
            };
        };
        GoogleMapsDataProvider.boldMatchedSubStringInPrediction = function (prediction) {
            var displayname = prediction.description;
            var result = "";
            var connectHead = 0;
            var matchedSubstrings = prediction.matched_substrings;
            var matchedSubstring;
            for (var index = 0; index < matchedSubstrings.length; index++) {
                matchedSubstring = matchedSubstrings[index];
                result += displayname.slice(connectHead, matchedSubstring.offset);
                result += "<B>" + displayname.slice(matchedSubstring.offset, matchedSubstring.offset +
                    matchedSubstring.length) + "</B>";
                connectHead = matchedSubstring.offset + matchedSubstring.length;
            }
            return result + displayname.slice(connectHead);
        };
        GoogleMapsDataProvider.prototype.fetchData = function (options) {
            var _this = this;
            var deferred = $.Deferred();
            var request = {
                input: options.srchText,
                types: EssDataProvider_1.GoogleRequestType[EssDataProvider_1.GoogleRequestType.ADDRESS_AUTOCOMPLETE] === options.requestType ?
                    ["geocode"] : undefined
            };
            if (google && google.maps && google.maps.places && google.maps.places.AutocompleteService) {
                this.getGoogleAutocompleteService().getPlacePredictions(request, function (predictions, status) {
                    _this.handlePredictionsResponse(predictions, status, options, deferred);
                });
            }
            else {
                TypeaheadErrorLogger_1["default"].log(new Error("Google maps script not loaded"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
            }
            return deferred.promise();
        };
        GoogleMapsDataProvider.prototype.getGoogleAutocompleteService = function () {
            if (!this.googleAutocompleteService) {
                this.googleAutocompleteService = new google.maps.places.AutocompleteService();
            }
            return this.googleAutocompleteService;
        };
        GoogleMapsDataProvider.prototype.handlePredictionsResponse = function (predictions, status, options, deferred) {
            var suggestionResults = [];
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                // status = ZERO_RESULT is treated as a failure as we only log failures for now.
                // In failure metrics we will get to know how often ZERO_RESULT happens.
                if (predictions) {
                    var suggestionCount = Math.min(GoogleMapsDataProvider.MAX_RESULTS, predictions.length);
                    for (var i = 0; i < suggestionCount; i++) {
                        suggestionResults.push(GoogleMapsDataProvider.getSuggestionResult(predictions[i], i));
                    }
                }
            }
            else {
                new CollectorTransport_1.CollectorTransport().log(new AddressAutocompleteFailureMetric_1.AddressAutocompleteFailureMetric(options.lob, options.domElementId, options.srchText, google.maps.places.PlacesServiceStatus[status], options.activeEssTests));
            }
            if (suggestionResults && suggestionResults.length) {
                suggestionResults.push(this.getPoweredByGoogleListItem());
            }
            deferred.resolve({ query: options.srchText, results: suggestionResults });
        };
        GoogleMapsDataProvider.prototype.getPoweredByGoogleListItem = function () {
            var getHtml = function () {
                return "<div style='text-align:right;position:relative;top:0.5em;'>" +
                    "<img src='" + PoweredByGoogleLogo_1.POWERED_BY_GOOGLE_LOGO + "'/></div>";
            };
            return new IListItem_1.LabelTypeListItem(getHtml());
        };
        GoogleMapsDataProvider.MAX_RESULTS = 5;
        return GoogleMapsDataProvider;
    }());
    exports.GoogleMapsDataProvider = GoogleMapsDataProvider;
});



/// <amd-module name="typeahead/core/google/GoogleMapsSuggestion"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/google/GoogleMapsSuggestion", ["require", "exports", "typeahead/core/Suggestion", "typeahead/core/util/Optional"], function (require, exports, Suggestion_1, Optional_1) {
    "use strict";
    exports.__esModule = true;
    var GoogleMapsSuggestion = (function (_super) {
        __extends(GoogleMapsSuggestion, _super);
        function GoogleMapsSuggestion() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GoogleMapsSuggestion.prototype.getSourceName = function () {
            return Optional_1.Optional.of(this.data.sourceName);
        };
        GoogleMapsSuggestion.prototype.getSourceId = function () {
            return Optional_1.Optional.of(this.data.sourceId);
        };
        GoogleMapsSuggestion.prototype.shouldTriggerDomElementChangeOnSelection = function () {
            return true;
        };
        GoogleMapsSuggestion.prototype.isAddrAutoComplete = function () {
            return true;
        };
        return GoogleMapsSuggestion;
    }(Suggestion_1.Suggestion));
    exports.GoogleMapsSuggestion = GoogleMapsSuggestion;
});



define("typeahead/core/google/PoweredByGoogleLogo", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    /// <amd-module name="typeahead/core/google/PoweredByGoogleLogo" />
    exports.POWERED_BY_GOOGLE_LOGO = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAASCAYAAAC0PldrAAAIHElEQVR4Ae3ZBXDbWB7H8efglpm" +
        "ZGW0HlhzJDpSZmZkZ3W3s2DpmZmbmKx0zM/NdoGhotxTf9x9LHY027paW85v5bBRQopn32weqasqzk5Jw7BE9nHijHo5/Rw/HfqaHYl/" +
        "keldZ8GJ7qBeqZ/6PNGlPUT5DeVKNqkyc18PJ6VDPtfEfnvUJz0dmpbwfmzMW6k5YFy96pBRTkCnL4MUDiy94oS0F+ZVZlD/5qxLLfNF" +
        "kz0D0fBtfKOkpCcffrFfG6vVQ4hDUc6ypQLdDFmMdMiWIcjywaOHEB8zynPEFa1pCOWnHLw2Bej5oKtDzqEC+cGyoWZ5YaTDeGer57r4" +
        "LRPLRCi40liy0QR4eVB5CG2QhU3KQneG+TM/qQhvk424L1Bwt73P22d9QoFD8bVB3KxVUWTX+gqW1mvvLtbr7Z7V+z6frNM/UlFIuKAD" +
        "83I2v5y69eiL3y9dPZP/s2tdyPn39ZN7UVEq5oCz8x+WvjC/SQrEv8/u/z/O9siSUKNfC8agWSbrRaIH+p3lH1Pg976jxe38gz8JzzLM" +
        "/g2QhpmIuIjCwB/0cg6HjGAxEsQQtIZmCtbBnLbY4BngZptkGaQmiMHAUhbCyEJMxCxGsh6QFltruOwIv7BmEfTAQwWwsvYMCTcMqGKa" +
        "t6AJJCXYjD1ZcWIdZsEdK8K50gZLroez4+l4G8j1PURlfAJWaMye7Vvd+otbvTVVr7hvVmvc/ci0YyNdAidTHVPa1EzmfuH4iN0WBbnD" +
        "9H7lu8PXc10CJYDCVxanvffI8nAZvloQTNenZMXYt/YyJ5Y3tgar9nkCt5n2y4Tl073+5TprPEIYSknW2ARpkWosQOkFSiijK0BtuHME" +
        "2ZGMMDLSDpBMMU29bYaIYBxfW4wBGojcmw8BIWM8Vwjq40QMubMR+231TYGAYJN1QhVUYgEHYgMgdFCiCBeiLYdiJI2iO9og6St4XBgZ" +
        "nKpAWjm2AsmNZO+E8jdlnqzrdvS49aO4fndWLekDVlbmHMoB/MQewAorCrDML86P6E816QD35lbyhzER/SZcouwJKq0oskd9PSX9aVnm" +
        "5F1RJVbKQr13IVKCU251b7Xf/WwpcqxfMkVnngm9MW+sZ6gJeD24N1BHkwUouDmI28hDGBNjTDwZGIR9hFEOiYyu2YRIkY1GFhzAABvr" +
        "CnpVYbyvQAeTAyiBHKa2sNUnmY5/jvnwcvYMCbXDMmG1QBR2SJdhu+5l52NXYMsqA7EsXI/5OKBvEhnMKK7LwtePpgYy9HIpB+lbDIGm" +
        "FbihLTcAzs6FAuueDUJTkW0hdO5XrhrJc/1reTPk6BfsgZMY7iZS/KumFsmihxIFMBaoNeHxmiT/6H5+7Y41esJcl7K/pmdD9N64n4tZ" +
        "ALYQzs7EDvTMMmgtBW7GWYyUk26DDj/1wYYHt+z7bUhixMXDMVqDFznG5zX1HIdmDGbDnTvdAGpzZhGWO/2n6ojnCKIIzDNClwQ1LRmU" +
        "8ETCS3aEysU5r7FHmQckAyUD9sWJgPpSlNlA4SL7O0vJNqGtfz/6bFKX+SyofyvLk1/IGNcxAX8v9JpS8QpDfX/Ha+nwoC8vplIwFYq/" +
        "TUFbN+w9Zxqr93vpq3fOFWn/BJFlioYQ1UEvgzHxsRQ8Y6NdIgY6jDBI3wugGA53QxVa+IAogeQwR9EB3h27IVGwfqjLc1xWSnZgNZ5b" +
        "dQYECcGabrcgubMUCPIZjtztQWPsOZpjvPRq52A7KSatKTpV3QfxcXenL61tASUFk8M7q7gIoiywl6UF1fwBKCmLONAVQlhsn8+aYX/8" +
        "AVEll4pQ8h7x7grLIRj9TgWo0z8Ppsnqv1eqeyP98hX2hZClrrEDH0QpWWuIYJiMbQcx1TNWjYWCQbY8TwQbshJXdWI+obdPdEwbGwJ7" +
        "ipylQH2vZdN5nK9AMHEVzx1JUeQcF2uVY+rojimJYGY8q7MdEZIy8MGTwfmHuhf5JkTbJex/fyxJdtcpLDzNob5JNrbn/mQMl2ECvNpe" +
        "Kn1sDV6MVjGEz/U9zWSmFYuO82tzr/PzK6fy+UFdP5o6hNP9M742ySyFL1VJrDxSIXu4NJUunvAXPVCApCfufP5p7rg1y2pMZkeswX/u" +
        "+zIawF0jtwyOmvThiK5UXBhbDgwkIY7mjVKthoBRWymE0MngLbXsrN+bbS5WhQC4sRggVjvtGQ9IWQexGMR7BfjxxBwV6AptRgBIcxU7" +
        "kwkoODiOCtrhtZOZhkD52m3/KiFGs+VCAdYT3fsicAer5WIcU4DGghPzcta/nfKjhFPa13HrUybW5fBlQQk5hWmXi/fL3rNnuTk5hdX6" +
        "Pl79/wTwNXrJOYbIXOh9w98atgVqAx7EPx7AUHWDPSGy2la0MOY38zCp0gZWuWNXIbJONAPYhhK0YDSsTocGZbJRmuM9KJ6zAceyHD48" +
        "9zYyxCGMwGYdts24LOLMWi3DHkQ0sg/QqWU5KwvEf4HPMDHseDcc6QTnJUiH7EGajz8g7GPYiH2EWKoOyk/c9vAeax6zzGcryAz5+5Pr" +
        "J7DIoO37QxTufhRT0C+zLvst11FrC5JQG5f7IrJd5Pjzzx56Pzh4CJc76CnryHugVPMe3OcqfYTkLymkMCpk30RnTlG62jfQLIr5gKkf" +
        "+wVY29lAWWULTM2HsMah70VSgu888bIULL4hw2pqRPhEmfiMbadmbyWzE/utqSSj2nznBVB7UvWgq0N2lLSIYhxdOWL5k+Xzq/it2mdc" +
        "GAah7ZV00eQlgxvFRpNfJeyc+Bn2RK32h7sf/AesqcHB02e65AAAAAElFTkSuQmCC";
});



/// <amd-module name="typeahead/core/logging/CollectorTransport"/>
define("typeahead/core/logging/CollectorTransport", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var CollectorTransport = (function () {
        function CollectorTransport() {
        }
        CollectorTransport.prototype.log = function (payload) {
            var isBatch = true;
            if (!_.isArray(payload)) {
                isBatch = false;
            }
            var url = "//"
                + window.location.hostname
                + (window.location.port ? ":" + window.location.port : "")
                + "/cl/data"
                + "/typeahead_client_metrics.json?stream=true&persist=true&batch=" + (isBatch ? "true" : "false");
            $.ajax({
                contentType: "application/json; charset=UTF-8",
                url: url,
                data: JSON.stringify(payload),
                dataType: "json",
                type: "POST"
            });
        };
        return CollectorTransport;
    }());
    exports.CollectorTransport = CollectorTransport;
});



/// <amd-module name="typeahead/core/logging/DctkClientLogErrorTransport"/>
define("typeahead/core/logging/DctkClientLogErrorTransport", ["require", "exports", "underscore", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity"], function (require, exports, _, ProblemOrigin_1, Severity_1) {
    "use strict";
    exports.__esModule = true;
    var DctkClientLogErrorTransport = (function () {
        function DctkClientLogErrorTransport() {
        }
        DctkClientLogErrorTransport.prototype.log = function (e, severity, origin, additional) {
            var _this = this;
            if (additional === void 0) { additional = {}; }
            try {
                if (!_.isObject(additional)) {
                    var tmp = additional;
                    additional = {};
                    additional.additional_info = tmp;
                }
                additional.severity = Severity_1.Severity[severity];
                additional.problemOrigin = ProblemOrigin_1.ProblemOrigin[origin];
                // Inline require is being done so that this module creation does not fail in case the client does not use
                // clientLogging.js.
                if (!this.clientLogger) {
                    require(["dctk/clientLogging", "dctk/dctk"], function (cl, dctk) {
                        _this.clientLogger = cl;
                        _this.doClientLogging(e, severity, additional);
                    });
                }
                else {
                    this.doClientLogging(e, severity, additional);
                }
            }
            catch (e) {
                // Ignore
            }
        };
        DctkClientLogErrorTransport.prototype.doClientLogging = function (e, severity, additional) {
            if (this.clientLogger) {
                if (Severity_1.Severity.MustFix === severity) {
                    this.clientLogger.logError("UniversalTypeahead", e, additional);
                }
                else {
                    if (e) {
                        additional.message = e.message;
                        additional.name = e.name;
                        additional.stack = e.stack;
                    }
                    this.clientLogger.logMessage("UniversalTypeahead", additional);
                }
            }
            else {
                if (console && _.isFunction(console.error)) {
                    console.error(e);
                }
            }
        };
        return DctkClientLogErrorTransport;
    }());
    exports.DctkClientLogErrorTransport = DctkClientLogErrorTransport;
});



///<amd-module name="typeahead/core/logging/Element" />
define("typeahead/core/logging/Element", ["require", "exports", "typeahead/core/Suggestion", "typeahead/core/util/Optional", "typeahead/core/IListItem"], function (require, exports, Suggestion_1, Optional_1, IListItem_1) {
    "use strict";
    exports.__esModule = true;
    var Element = (function () {
        function Element(domElementId) {
            if (domElementId === void 0) { domElementId = ""; }
            this.domElementId = domElementId;
            this.value = "";
            this.mostRecentSelection = Optional_1.Optional.empty();
            this.mostRecentInputValue = "";
            this.essSuggestionCount = 0;
            this.userHistorySuggestionCount = 0;
            this.elementFocused = false;
            this.suggestionShown = false;
            this.suggestionSelected = false;
            if (domElementId) {
                this.value = $("#" + domElementId).val() || "";
            }
        }
        Element.prototype.setElementFocused = function () {
            this.elementFocused = true;
        };
        Element.prototype.setSuggestionShown = function (suggestions) {
            this.suggestionShown = true;
            this.setSuggestionCount(suggestions);
        };
        Element.prototype.setSuggestionSelected = function (suggestion) {
            this.suggestionSelected = true;
            this.mostRecentSelection = Optional_1.Optional.of(suggestion);
            this.value = suggestion.getDisplayText();
        };
        Element.prototype.setMostRecentInputValue = function (value) {
            this.suggestionSelected = false;
            this.mostRecentInputValue = value;
            this.mostRecentSelection = Optional_1.Optional.empty();
            this.value = value;
        };
        Element.prototype.isSuggestionShown = function () {
            return this.suggestionShown;
        };
        Element.prototype.isSuggestionSelected = function () {
            return this.suggestionSelected;
        };
        Element.prototype.getMostRecentInputValue = function () {
            return this.mostRecentInputValue;
        };
        Element.prototype.getEssSuggestionCount = function () {
            return this.essSuggestionCount;
        };
        Element.prototype.getUserHistorySuggestionCount = function () {
            return this.userHistorySuggestionCount;
        };
        Element.prototype.getMostRecentSelection = function () {
            return this.mostRecentSelection;
        };
        Element.prototype.getVal = function () {
            return this.value;
        };
        Element.prototype.setSuggestionCount = function (suggestions) {
            var _this = this;
            this.userHistorySuggestionCount = 0;
            this.essSuggestionCount = 0;
            if (suggestions) {
                suggestions.forEach(function (suggestionResult) {
                    if (IListItem_1.ListItemType.Label !== suggestionResult.listItemType) {
                        switch (suggestionResult.category) {
                            case Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.USERHISTORY]: {
                                _this.userHistorySuggestionCount++;
                                break;
                            }
                            case Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.GEOLOCATION]: {
                                break;
                            }
                            case Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.GOOGLEMAPS]: {
                                break;
                            }
                            default: {
                                _this.essSuggestionCount++;
                            }
                        }
                    }
                });
            }
        };
        return Element;
    }());
    exports.Element = Element;
});



///<amd-module name="typeahead/core/logging/ErrorLogger"/>
define("typeahead/core/logging/ErrorLogger", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var ErrorLogger = (function () {
        function ErrorLogger(transport) {
            this.transport = transport;
        }
        ErrorLogger.prototype.log = function (error, severity, origin, additional) {
            if (additional === void 0) { additional = {}; }
            try {
                this.transport.log(error, severity, origin, additional);
            }
            catch (transportError) {
                if (console && _.isFunction(console.error)) {
                    console.error(transportError);
                }
            }
        };
        return ErrorLogger;
    }());
    exports.ErrorLogger = ErrorLogger;
});



///<amd-module name="typeahead/core/logging/ErrorTransport"/>
define("typeahead/core/logging/ErrorTransport", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});



///<amd-module name="typeahead/core/logging/Leg" />
define("typeahead/core/logging/Leg", ["require", "exports", "typeahead/core/logging/Element", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger"], function (require, exports, Element_1, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1) {
    "use strict";
    exports.__esModule = true;
    var Leg = (function () {
        function Leg() {
        }
        Leg.isOrigin = function (domElementId) {
            domElementId = domElementId.toLowerCase();
            return domElementId.indexOf("origin") > -1 ||
                domElementId.indexOf("from") > -1 ||
                domElementId.indexOf("departure") > -1 ||
                domElementId.indexOf("drop") > -1;
        };
        Leg.isDestination = function (domElementId) {
            domElementId = domElementId.toLowerCase();
            return domElementId.indexOf("dest") > -1 ||
                domElementId.indexOf("to") > -1 ||
                domElementId.indexOf("arrival") > -1 ||
                domElementId.indexOf("near") > -1 ||
                domElementId.indexOf("pick") > -1 ||
                domElementId.indexOf("uta-search-query") > -1; // open search is considered as destination for now
        };
        Leg.prototype.getElement = function (domElementId) {
            var isOrigin = Leg.isOrigin(domElementId);
            var isDestination = Leg.isDestination(domElementId);
            if (domElementId) {
                if (isOrigin) {
                    if (!this.origin) {
                        this.origin = new Element_1.Element(domElementId);
                    }
                    return this.origin;
                }
                if (isDestination) {
                    if (!this.destination) {
                        this.destination = new Element_1.Element(domElementId);
                    }
                    return this.destination;
                }
            }
            if (!isOrigin && !isDestination) {
                TypeaheadErrorLogger_1["default"].log(new Error("Could not determine origin or destination type for domElementId - "
                    + domElementId), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.ClientOfUniversalTypeahead);
            }
            if (domElementId) {
                // Honor the element id as provided
                return new Element_1.Element(domElementId);
            }
            else {
                // Set a dummy element
                return new Element_1.Element();
            }
        };
        Leg.prototype.getOriginElement = function () {
            return this.origin ? this.origin : this.getElement("origin");
        };
        Leg.prototype.getDestinationElement = function () {
            return this.destination ? this.destination : this.getElement("destination");
        };
        return Leg;
    }());
    exports.Leg = Leg;
});



///<amd-module name="typeahead/core/logging/OmnitureLogger" />
define("typeahead/core/logging/OmnitureLogger", ["require", "exports", "typeahead/core/logging/Element", "typeahead/core/logging/Leg", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity", "typeahead/core/logging/TypeaheadErrorLogger", "typeahead/core/message/ElementFocusedMessage", "typeahead/core/message/FormSubmittedMessage", "typeahead/core/message/InputValueEditedMessage", "typeahead/core/message/SubmitClickedMessage", "typeahead/core/message/SuggestionAutoSelectedMessage", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/SuggestionShownMessage", "typeahead/core/message/TypeaheadMessage", "typeahead/core/Suggestion", "typeahead/core/TypeaheadUtils", "typeahead/core/util/Optional"], function (require, exports, Element_1, Leg_1, ProblemOrigin_1, Severity_1, TypeaheadErrorLogger_1, ElementFocusedMessage_1, FormSubmittedMessage_1, InputValueEditedMessage_1, SubmitClickedMessage_1, SuggestionAutoSelectedMessage_1, SuggestionSelectedMessage_1, SuggestionShownMessage_1, TypeaheadMessage_1, Suggestion_1, TypeaheadUtils_1, Optional_1) {
    "use strict";
    exports.__esModule = true;
    var OmnitureLogger = (function () {
        function OmnitureLogger() {
            var _this = this;
            this.rfrrIdPrefix = "";
            this.isAutoSelected = false;
            this.resetLoggerState();
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.element_focused" and handler
             * Required params for handler "typeahead.element_focused" and <TypeaheadMessage> ElementFocusedMessage object
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(ElementFocusedMessage_1.ElementFocusedMessage.getTopic(), function (topic, message) {
                _this.getElement(message.getDomElementId()).setElementFocused();
            });
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.suggestion_shown" and handler
             * Required params for handler "typeahead.suggestion_shown" and <TypeaheadMessage> SuggestionShownMessage object
             * Handler gets element based on getLegIndex & setSuggestionShown based on SuggestionShownMessage object
             * Handler sets mostRecentElementInteracted to a value enforced by Optional (non null & undefined)
             * Handler gets activeESSTests from SuggestionShownMessage
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionShownMessage_1.SuggestionShownMessage.getTopic(), function (topic, message) {
                _this.getElement(message.getDomElementId()).setSuggestionShown(message.getShownSuggestions());
                _this.mostRecentElementInteracted = Optional_1.Optional.of(_this.getElement(message.getDomElementId()));
                _this.activeESSTests = message.getActiveESSTests();
            });
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.input_value_edited" and handler
             * Required params for handler "typeahead.input_value_edited" & <TypeaheadMessage> InputValueEditedMessage
             * Handler gets element based on getLegIndex & setMostRecentInputValue based on InputValueEditedMessage object
             * If newInputValue handler sets mostRecentElementInteracted to the element
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(InputValueEditedMessage_1.InputValueEditedMessage.getTopic(), function (topic, message) {
                _this.getElement(message.getDomElementId())
                    .setMostRecentInputValue(message.getNewInputValue());
                if (message.getNewInputValue()) {
                    _this.mostRecentElementInteracted = Optional_1.Optional.of(_this.getElement(message.getDomElementId()));
                }
            });
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.suggestion_auto_selected" and handler
             * Required params for handler
             * "typeahead.suggestion_auto_selected" & <TypeaheadMessage> SuggestionAutoSelectedMessage
             * Handler gets element based on getLegIndex &
             * setSuggestionSelected based on SuggestionAutoSelectedMessage object
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionAutoSelectedMessage_1.SuggestionAutoSelectedMessage.getTopic(), function (topic, message) {
                _this.getElement(message.getDomElementId()).setSuggestionSelected(message.getSuggestion());
                _this.isAutoSelected = true;
            });
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.suggestion_selected" and handler
             * Required params for handler "typeahead.suggestion_selected" & <TypeaheadMessage> SuggestionSelectedMessage
             * Handler gets element based on getLegIndex & setSuggestionSelected based on SuggestionSelectedMessage object
             * Handler sets mostRecentElementInteracted to the element
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionSelectedMessage_1.SuggestionSelectedMessage.getTopic(), function (topic, message) {
                _this.getElement(message.getDomElementId()).setSuggestionSelected(message.getSuggestion());
                _this.mostRecentElementInteracted = Optional_1.Optional.of(_this.getElement(message.getDomElementId()));
            });
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.submit_clicked" and handler
             * Required params for handler "typeahead.submit_clicked" & <TypeaheadMessage> SubmitClickedMessage
             * Handler sets the rfrrIdPrefix based on SubmitClickedMessage
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SubmitClickedMessage_1.SubmitClickedMessage.getTopic(), function (topic, message) {
                _this.rfrrIdPrefix = message.getRfrrIdPrefix();
            });
            /**
             * Required params for  TypeaheadMessage subscribe utility "typeahead.form_submitted" and handler
             * Required params for handler "typeahead.form_submitted" & <TypeaheadMessage> FormSubmittedMessage
             * Handler submits to Omniture via submitTrackingData utility in OmnitureLogger
             */
            TypeaheadMessage_1.TypeaheadMessage.subscribe(FormSubmittedMessage_1.FormSubmittedMessage.getTopic(), function (topic, message) {
                _this.submitTrackingData(message);
            });
        }
        // This utility determines which leg of the journey  esp. in multi destination flights but applicable to all
        OmnitureLogger.getLegIndex = function (domElementId) {
            var index = domElementId.replace(/\D/g, ""); // Replace all non digits with empty
            return index ? parseInt(index, 10) - 1 : 0;
        };
        // Utility function to return referrer information LaunchView|SrchWzd|Tab|LOB|Locale|SiteId
        OmnitureLogger.getBasicReport = function (rfrrIdPrefix, lob, flightType, packageType, railType, clientId, locale, siteid) {
            var parts = [
                OmnitureLogger.getLaunchView(clientId),
                OmnitureLogger.getWizardName(rfrrIdPrefix, clientId),
                OmnitureLogger.getTab(lob),
                OmnitureLogger.getShortLob(lob, flightType, packageType, railType),
                locale,
                siteid,
            ];
            return _.compact(parts).join("|");
        };
        OmnitureLogger.getWizardName = function (rfrrIdPrefix, clientId) {
            var wizardIdentifier;
            if (rfrrIdPrefix) {
                switch (rfrrIdPrefix) {
                    case "FLT.SR|UpdateSearch":
                        wizardIdentifier = "UpdateSearch";
                        break;
                    case "HOT.SR|UpdateSearch":
                        wizardIdentifier = "UpdateSearch";
                        break;
                    case "Open.Search|UpdateSearch":
                        wizardIdentifier = "UpdateSearch";
                        break;
                    default: wizardIdentifier = "CoreWzd";
                }
            }
            else if (clientId) {
                switch (clientId) {
                    case "Flights.Search":
                        wizardIdentifier = "UpdateSearch";
                        break;
                    case "Hotels.Search":
                        wizardIdentifier = "UpdateSearch";
                        break;
                    default: wizardIdentifier = "CoreWzd";
                }
            }
            return wizardIdentifier;
        };
        OmnitureLogger.getShortLob = function (lob, flightType, packageType, railType) {
            switch (lob) {
                case TypeaheadUtils_1.Lob.Flight: {
                    switch (flightType) {
                        case TypeaheadUtils_1.FlightType.OneWay:
                            return "F.OW";
                        case TypeaheadUtils_1.FlightType.RoundTrip:
                            return "F.RT";
                        case TypeaheadUtils_1.FlightType.MultiDestination:
                            return "F.MD";
                        default:
                            return "-";
                    }
                }
                case TypeaheadUtils_1.Lob.Hotel:
                    return "H";
                case TypeaheadUtils_1.Lob.VacationRental:
                    return "VR";
                case TypeaheadUtils_1.Lob.Package: {
                    switch (packageType) {
                        case TypeaheadUtils_1.PackageType.FlightHotelCar:
                            return "FHC";
                        case TypeaheadUtils_1.PackageType.HotelCar:
                            return "HC";
                        case TypeaheadUtils_1.PackageType.FlightCar:
                            return "FC";
                        case TypeaheadUtils_1.PackageType.FlightHotel:
                            return "FH";
                        default:
                            return "-";
                    }
                }
                case TypeaheadUtils_1.Lob.Activity:
                    return "LX";
                case TypeaheadUtils_1.Lob.Rail: {
                    switch (railType) {
                        case TypeaheadUtils_1.RailType.OneWay:
                            return "R.OW";
                        case TypeaheadUtils_1.RailType.RoundTrip:
                            return "R.RT";
                        default:
                            return "-";
                    }
                }
                case TypeaheadUtils_1.Lob.Cruise:
                    return "CR";
                case TypeaheadUtils_1.Lob.Car:
                    return "C";
                case TypeaheadUtils_1.Lob.OpenSearch:
                    return "OS";
                default:
                    return "-";
            }
        };
        // TODO : include logic for getting launchview info for HSRP and FSRP
        OmnitureLogger.getLaunchView = function (clientId) {
            clientId = clientId.toLowerCase();
            if (clientId.indexOf("home") > -1) {
                return "Home";
            }
            else if (clientId.indexOf("flight") > -1) {
                return "FLT";
            }
            else if (clientId.indexOf("hotels.search") > -1) {
                return "HOT.SR";
            }
            else if (clientId.indexOf("hotel") > -1) {
                return "HTL";
            }
            else if (clientId.indexOf("vacationrental") > -1) {
                return "VR";
            }
            else if (clientId.indexOf("pack") > -1) {
                return "PKG";
            }
            else if (clientId.indexOf("car") > -1) {
                return "CAR";
            }
            else if (clientId.indexOf("cru") > -1) {
                return "CRU";
            }
            else if (clientId.indexOf("lx") > -1) {
                return "LX";
            }
            else if (clientId.indexOf("rail") > -1) {
                return "RAIL";
            }
            else if (clientId.indexOf("open") > -1) {
                return "OPEN";
            }
            return clientId;
        };
        OmnitureLogger.getTab = function (lob) {
            switch (lob) {
                case TypeaheadUtils_1.Lob.Flight: return "Flights";
                case TypeaheadUtils_1.Lob.Hotel: return "Hotels";
                case TypeaheadUtils_1.Lob.Package: return "Package";
                case TypeaheadUtils_1.Lob.Car: return "Car";
                case TypeaheadUtils_1.Lob.Cruise: return "Cruise";
                case TypeaheadUtils_1.Lob.Activity: return "Activity";
                case TypeaheadUtils_1.Lob.Rail: return "Rails";
                case TypeaheadUtils_1.Lob.VacationRental: return "VacationRental";
                case TypeaheadUtils_1.Lob.OpenSearch: return "OpenSearch";
                default: return "Unknown";
            }
        };
        OmnitureLogger.getSuggestionInfo = function (s) {
            return s.getSourceName().orElse("-")
                + ":"
                + s.getSourceId().orElse("-")
                + "|"
                + s.getType().orElse("-")
                + "|"
                + "R#"
                + s.getRelationInfo().orElse("-")
                + "|"
                + s.getRegionNames().orElse(OmnitureLogger.emptyRegionNames).lastSearchName
                + (OmnitureLogger.isSuggestionInCategory(s, Suggestion_1.SuggestionCategory.USERHISTORY) ?
                    "|" + Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.USERHISTORY] : "");
        };
        OmnitureLogger.isSuggestionInCategory = function (suggestion, category) {
            return Suggestion_1.SuggestionCategory[category] === suggestion.getCategory().orElse("");
        };
        OmnitureLogger.getMultiFlightSuggestionInfo = function (s) {
            return s.getSourceName().orElse("-")
                + ":"
                + s.getSourceId().orElse("-")
                + "|"
                + s.getType().orElse("-");
        };
        // NOTE: Utility function to set LOB for testing purpose only
        // To be called from *.spec.ts ONLY
        OmnitureLogger.prototype.setMostRecentElementInteracted = function (elem) {
            this.mostRecentElementInteracted = elem;
        };
        OmnitureLogger.prototype.getElement = function (domElementId) {
            var legIndex = OmnitureLogger.getLegIndex(domElementId);
            if (!this.legs[legIndex]) {
                this.legs[legIndex] = new Leg_1.Leg();
            }
            return this.legs[legIndex].getElement(domElementId);
        };
        OmnitureLogger.prototype.getEvar48 = function (lob, flightType) {
            if (lob === TypeaheadUtils_1.Lob.Flight && flightType === TypeaheadUtils_1.FlightType.MultiDestination) {
                return this.getMultiFlightEvar48();
            }
            else {
                var evar48 = "";
                var destination = this.legs[0].getDestinationElement();
                if (destination.getMostRecentSelection().isPresent()) {
                    evar48 = OmnitureLogger.getSuggestionInfo(destination.getMostRecentSelection().get());
                }
                else {
                    var previousDestination = destination.getVal();
                    evar48 = "-:-|-|R#-|" + (previousDestination || "TANoneSelected");
                }
                return evar48;
            }
        };
        OmnitureLogger.prototype.getProp73 = function (lob, flightType, packageType) {
            if (TypeaheadUtils_1.Lob.Flight === lob && flightType === TypeaheadUtils_1.FlightType.MultiDestination) {
                return this.getMultiFlightProp73();
            }
            else if (this.isFlightInvolved(lob, packageType) || TypeaheadUtils_1.Lob.Car === lob || TypeaheadUtils_1.Lob.Rail === lob) {
                var prop73 = "";
                var origin = this.legs[0].getOriginElement();
                if (origin.getMostRecentSelection().isPresent()) {
                    prop73 = OmnitureLogger.getSuggestionInfo(origin.getMostRecentSelection().get());
                }
                else {
                    var previousOrigin = origin.getVal();
                    prop73 = "-:-|-|R#-|" + (previousOrigin || "TANoneSelected");
                }
                return prop73;
            }
            else if (TypeaheadUtils_1.Lob.Hotel === lob || TypeaheadUtils_1.Lob.Activity === lob ||
                (TypeaheadUtils_1.Lob.Package === lob && packageType === TypeaheadUtils_1.PackageType.HotelCar)) {
                return "-:-|-|R#-|OriginNotApplicable";
            }
            return "";
        };
        OmnitureLogger.prototype.getProp74 = function (lob, flightType) {
            var prop74 = "\"" +
                this.mostRecentElementInteracted.orElse(OmnitureLogger.emptyElement)
                    .getMostRecentInputValue() + "\"";
            if (lob === TypeaheadUtils_1.Lob.Flight && flightType === TypeaheadUtils_1.FlightType.MultiDestination) {
                var origins = [];
                var destinations = [];
                for (var _i = 0, _a = this.legs; _i < _a.length; _i++) {
                    var leg = _a[_i];
                    origins.push(leg.getOriginElement().getVal());
                    destinations.push(leg.getDestinationElement().getVal());
                }
                prop74 += "." + origins.join("#") + "." + destinations.join("#");
            }
            return prop74;
        };
        // capture the Typeahead triggers
        OmnitureLogger.prototype.getTypeaheadTrigger = function () {
            var trigger = "";
            if (!this.mostRecentElementInteracted.isPresent()) {
                if (this.isAutoSelected) {
                    trigger = "TANoShow.TAAutoSelection";
                }
                else {
                    trigger = "TANoShow.TAPrevSearch";
                }
            }
            else if (!this.mostRecentElementInteracted.get().isSuggestionShown()) {
                trigger = "TANoShow";
                if (!this.mostRecentElementInteracted.get().getMostRecentInputValue()) {
                    trigger += ".TAPrevSearch";
                }
            }
            else {
                /*
                Focus Trigger Typeahead : TAShow.TAFocus ( Focus on input element  &&
                    (no text or previously populated text) ) )  (No user interaction except focus on input box)
                x Character Typeahead and user selection from Typeahead : TAShow.TASelection
                    ( Focus on input element + >= 0 character input and selection )
                User specific string, i.e., the user didn’t select anything from the Typeahead but Submitted with the user
                    specific string : x Character Typeahead and NO user selection from Typeahead : TAShow.TANoSelection
                    ( Focus on input element +>0 character input but no selection)
                User submitted autopopulated String without interacting with Typeahead (TANoShow.TAPrevSearch)
                User submitted autopopulated String after interacting with typeahead (TAShow.TAPrevSearch)
                */
                trigger = "TAShow";
                if (this.mostRecentElementInteracted.get().isSuggestionSelected()) {
                    if (!this.mostRecentElementInteracted.get().getMostRecentInputValue()) {
                        trigger += ".TAFocus";
                    }
                    else {
                        trigger += ".TASelection";
                    }
                }
                else if (this.mostRecentElementInteracted.get().getMostRecentInputValue() ||
                    !this.mostRecentElementInteracted.get().getVal()) {
                    /* TAShow.TANoSelection : If Typeahead is shown and user submits a manual search query not equal
                        to previously populated search text
                       For CARS lob, in dropoff input, if typeahead is shown and no selection is made
                     */
                    trigger += ".TANoSelection";
                }
                else {
                    trigger += ".TAPrevSearch";
                }
            }
            return trigger;
        };
        // Function to generate Typeahead related event string
        OmnitureLogger.prototype.getEventString = function () {
            if (this.mostRecentElementInteracted.isPresent() &&
                this.mostRecentElementInteracted.get().isSuggestionShown()) {
                var userTypedQuery = this.mostRecentElementInteracted.get().getMostRecentInputValue();
                var eventStr = "event45";
                if (userTypedQuery) {
                    eventStr = "event46=" + userTypedQuery.length + "," + eventStr;
                }
                else {
                    eventStr = "event46=0," + eventStr;
                }
                if (this.mostRecentElementInteracted.get().getMostRecentSelection().isPresent()) {
                    eventStr = "event44=" +
                        this.mostRecentElementInteracted.get().getMostRecentSelection().get().getPosition()
                        + "," + eventStr;
                }
                return eventStr;
            }
            return "";
        };
        OmnitureLogger.prototype.getHierarchyCode = function () {
            return this.mostRecentElementInteracted.orElse(OmnitureLogger.emptyElement)
                .getMostRecentSelection().isPresent() ?
                this.mostRecentElementInteracted.get().getMostRecentSelection().get()
                    .getHierarchyCode()
                : "DL#-";
        };
        OmnitureLogger.prototype.getSelectedSuggestionPostion = function () {
            return this.mostRecentElementInteracted.orElse(OmnitureLogger.emptyElement)
                .getMostRecentSelection().isPresent() ?
                this.mostRecentElementInteracted.get().getMostRecentSelection().get().getPosition().toString()
                : "-";
        };
        OmnitureLogger.prototype.getInstrumentationValue = function (lob) {
            return _.compact([
                // Vijayalaxmi Mohapatra (vmohapatra) : Abbreviate the tag names as per below
                // L = Level of selection
                // ESS = Number of suggestions sent by ESS, always present as ESS is the primary service provider for TA
                // UH = Number of suggestions from user history
                // Hierarchy info or Level of selection from the suggestions shown for LOBs other than hotel or flight
                _.contains([TypeaheadUtils_1.Lob.Flight, TypeaheadUtils_1.Lob.Hotel], lob) ? this.getHierarchyCode() :
                    "L#" + this.getSelectedSuggestionPostion(),
                // Search Type
                // "ST#" + (model.get("TASearchType") ? model.get("TASearchType") : "-"),
                // ESS Suggestion count
                "ESS#" +
                    this.mostRecentElementInteracted.orElse(OmnitureLogger.emptyElement).getEssSuggestionCount(),
                // User History Suggestion count for unknown lob
                (TypeaheadUtils_1.Lob.Hotel === lob) ? "UH#" +
                    this.mostRecentElementInteracted.orElse(OmnitureLogger.emptyElement)
                        .getUserHistorySuggestionCount() : "",
            ]).join("|");
        };
        OmnitureLogger.prototype.getTADetails = function (lob) {
            var trigger = this.getTypeaheadTrigger();
            var instrumentationValue = this.getInstrumentationValue(lob);
            var parts = [
                trigger,
                instrumentationValue,
            ];
            return _.compact(parts).join("|");
        };
        OmnitureLogger.prototype.getTrackingData = function (isFormValid, context) {
            var lob = TypeaheadUtils_1.TypeaheadUtils.getLob();
            var flightType = TypeaheadUtils_1.TypeaheadUtils.getFlightType(lob);
            var railType = TypeaheadUtils_1.TypeaheadUtils.getRailType(lob);
            var packageType = TypeaheadUtils_1.TypeaheadUtils.getPackageType();
            var clientId = TypeaheadUtils_1.TypeaheadUtils.getClientId();
            var trackingData;
            if (isFormValid) {
                trackingData = this.getValidFormTrackingdata(context, lob, flightType, packageType, railType, clientId);
            }
            else {
                trackingData = this.getInvalidFormTrackingdata(context, lob, flightType, packageType, railType, clientId);
            }
            return trackingData;
        };
        OmnitureLogger.prototype.submitTrackingData = function (message) {
            try {
                var context = message.getContext();
                if (message.isFormValid()) {
                    var trackingData = this.getTrackingData(true, context);
                    TypeaheadUtils_1.TypeaheadUtils.submitToOmniture(trackingData, this.activeESSTests);
                    this.resetLoggerState();
                }
                else {
                    var trackingData = this.getTrackingData(false, context);
                    TypeaheadUtils_1.TypeaheadUtils.submitToOmniture(trackingData, null);
                    this.resetLoggerState();
                }
            }
            catch (e) {
                TypeaheadErrorLogger_1["default"].log(new Error("Error occurred while submitting typeahead tracking data to Omniture"), Severity_1.Severity.Excusable, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead, "StackTrace:\n" + e.stack);
                console.error("Error occurred while submitting typeahead tracking data to Omniture.\nCause:\n" + e.stack);
            }
        };
        OmnitureLogger.prototype.resetLoggerState = function () {
            this.mostRecentElementInteracted = Optional_1.Optional.empty();
            this.legs = [new Leg_1.Leg()];
            this.activeESSTests = "";
        };
        OmnitureLogger.prototype.getValidFormTrackingdata = function (context, lob, flightType, packageType, railType, clientId) {
            this.populateNonInteractedElements();
            var basicReport = "";
            // The rfrrIdPrefix is not passed by corewizard
            if (!this.rfrrIdPrefix) {
                basicReport = OmnitureLogger.getBasicReport(this.rfrrIdPrefix, lob, flightType, packageType, railType, clientId, context.locale, context.siteid);
            }
            else {
                basicReport = this.rfrrIdPrefix + "|" +
                    OmnitureLogger.getShortLob(lob, flightType, packageType, railType) + "|" + context.locale
                    + "|" + context.siteid;
            }
            var detailedInfo = basicReport + "|" + this.getTADetails(lob);
            var trackingData;
            trackingData = {
                eVar28: detailedInfo,
                eVar48: this.getEvar48(lob, flightType),
                eventString: this.getEventString(),
                prop16: detailedInfo,
                prop73: this.getProp73(lob, flightType, packageType),
                prop74: this.getProp74(lob, flightType)
            };
            return trackingData;
        };
        OmnitureLogger.prototype.getInvalidFormTrackingdata = function (context, lob, flightType, packageType, railType, clientId) {
            var trackingData;
            if (this.rfrrIdPrefix) {
                var formInvalidRfrrId = this.rfrrIdPrefix + "|" +
                    OmnitureLogger.getShortLob(lob, flightType, packageType, railType)
                    + "|" + context.locale + "|" +
                    context.siteid + "|Form-Invalid";
                trackingData = {
                    "eVar28": formInvalidRfrrId,
                    "prop16": formInvalidRfrrId
                };
            }
            else {
                var formInvalidRfrrId = OmnitureLogger.getBasicReport(this.rfrrIdPrefix, lob, flightType, packageType, railType, clientId, context.locale, context.siteid) + "|Form-Invalid";
                trackingData = {
                    "eVar28": formInvalidRfrrId,
                    "prop16": formInvalidRfrrId
                };
            }
            return trackingData;
        };
        OmnitureLogger.prototype.getMultiFlightEvar48 = function () {
            var evar48 = "";
            for (var _i = 0, _a = this.legs; _i < _a.length; _i++) {
                var leg = _a[_i];
                evar48 += (leg.getDestinationElement().getMostRecentSelection().isPresent() ?
                    OmnitureLogger.getMultiFlightSuggestionInfo(leg.getDestinationElement().getMostRecentSelection().get()) : "-:-|-") + "#";
            }
            return evar48.slice(0, -1); // remove the last "#" character
        };
        OmnitureLogger.prototype.getMultiFlightProp73 = function () {
            var prop73 = "";
            for (var _i = 0, _a = this.legs; _i < _a.length; _i++) {
                var leg = _a[_i];
                prop73 += (leg.getOriginElement().getMostRecentSelection().isPresent() ?
                    OmnitureLogger.getMultiFlightSuggestionInfo(leg.getOriginElement().getMostRecentSelection().get()) : "-:-|-") + "#";
            }
            return prop73.slice(0, -1); // remove the last "#" character
        };
        OmnitureLogger.prototype.populateNonInteractedElements = function () {
            var _this = this;
            $("input[data-provide=utypeahead]:visible").each(function (index, domElement) {
                var domElementId = $(domElement).attr("id");
                _this.getElement(domElementId);
            });
        };
        OmnitureLogger.prototype.isFlightInvolved = function (lob, packageType) {
            return (TypeaheadUtils_1.Lob.Flight === lob ||
                (TypeaheadUtils_1.Lob.Package === lob &&
                    (TypeaheadUtils_1.PackageType.FlightCar === packageType ||
                        TypeaheadUtils_1.PackageType.FlightHotelCar === packageType ||
                        TypeaheadUtils_1.PackageType.FlightHotel === packageType)));
        };
        OmnitureLogger.emptyRegionNames = {
            fullName: "-",
            lastSearchName: "-"
        };
        OmnitureLogger.emptyEssId = {
            sourceId: "-",
            sourceName: "-"
        };
        // empty Element suggests that no typeahead element in the form was interacted
        OmnitureLogger.emptyElement = new Element_1.Element();
        return OmnitureLogger;
    }());
    exports.OmnitureLogger = OmnitureLogger;
});



///<amd-module name="typeahead/core/logging/ProblemOrigin"/>
define("typeahead/core/logging/ProblemOrigin", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var ProblemOrigin;
    (function (ProblemOrigin) {
        ProblemOrigin[ProblemOrigin["Unspecified"] = 0] = "Unspecified";
        ProblemOrigin[ProblemOrigin["ExpediaSuggestService"] = 1] = "ExpediaSuggestService";
        ProblemOrigin[ProblemOrigin["UniversalTypeahead"] = 2] = "UniversalTypeahead";
        ProblemOrigin[ProblemOrigin["ClientOfUniversalTypeahead"] = 3] = "ClientOfUniversalTypeahead";
        ProblemOrigin[ProblemOrigin["DataCaptureToolkit"] = 4] = "DataCaptureToolkit";
    })(ProblemOrigin = exports.ProblemOrigin || (exports.ProblemOrigin = {}));
});



///<amd-module name="typeahead/core/logging/ScanabilityLogger" />
define("typeahead/core/logging/ScanabilityLogger", ["require", "exports", "typeahead/core/logging/CollectorTransport", "typeahead/core/logging/ScanabilityMetric", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/SuggestionShownMessage", "typeahead/core/message/TypeaheadMessage"], function (require, exports, CollectorTransport_1, ScanabilityMetric_1, SuggestionSelectedMessage_1, SuggestionShownMessage_1, TypeaheadMessage_1) {
    "use strict";
    exports.__esModule = true;
    var ScanabilityLogger = (function () {
        function ScanabilityLogger() {
            var _this = this;
            this.activeESSTests = "";
            // Suggestions displayed
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionShownMessage_1.SuggestionShownMessage.getTopic(), function (topic, message) {
                _this.domElementId = message.getDomElementId();
                _this.lob = message.getLob();
                _this.activeESSTests = message.getActiveESSTests();
                _this.suggestionShownTimestamp = Date.now();
            });
            // Suggestion selected
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionSelectedMessage_1.SuggestionSelectedMessage.getTopic(), function (topic, message) {
                if (_this.domElementId) {
                    _this.selectionMethod = message.getSelectionMethod();
                    _this.suggestionSelectedTimestamp = Date.now();
                    _this.emitScanabilityMetric();
                    // reset logger state
                    _this.domElementId = undefined;
                    _this.lob = undefined;
                    _this.selectionMethod = undefined;
                    _this.suggestionShownTimestamp = 0;
                    _this.suggestionSelectedTimestamp = 0;
                }
            });
        }
        ScanabilityLogger.prototype.emitScanabilityMetric = function () {
            new CollectorTransport_1.CollectorTransport().log(new ScanabilityMetric_1.ScanabilityMetric(this.lob, this.domElementId, this.suggestionShownTimestamp, this.suggestionSelectedTimestamp, this.selectionMethod, this.activeESSTests));
        };
        return ScanabilityLogger;
    }());
    exports.ScanabilityLogger = ScanabilityLogger;
});



///<amd-module name="typeahead/core/logging/ScanabilityMetric" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/logging/ScanabilityMetric", ["require", "exports", "typeahead/core/logging/TypeaheadMetric"], function (require, exports, TypeaheadMetric_1) {
    "use strict";
    exports.__esModule = true;
    var ScanabilityMetric = (function (_super) {
        __extends(ScanabilityMetric, _super);
        function ScanabilityMetric(lob, elementId, suggestionShownTimestamp, suggestionSelectedTimestamp, selectionMethod, activeESSTests) {
            var _this = _super.call(this, lob, elementId, "scan", activeESSTests) || this;
            _this.latency = suggestionSelectedTimestamp - suggestionShownTimestamp;
            _this.selectionMethod = selectionMethod;
            return _this;
        }
        return ScanabilityMetric;
    }(TypeaheadMetric_1.TypeaheadMetric));
    exports.ScanabilityMetric = ScanabilityMetric;
});



///<amd-module name="typeahead/core/logging/SelectionToSubmissionLogger" />
define("typeahead/core/logging/SelectionToSubmissionLogger", ["require", "exports", "typeahead/core/logging/CollectorTransport", "typeahead/core/logging/SelectionToSubmissionMetric", "typeahead/core/message/SubmitClickedMessage", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/SuggestionShownMessage", "typeahead/core/message/TypeaheadMessage"], function (require, exports, CollectorTransport_1, SelectionToSubmissionMetric_1, SubmitClickedMessage_1, SuggestionSelectedMessage_1, SuggestionShownMessage_1, TypeaheadMessage_1) {
    "use strict";
    exports.__esModule = true;
    var SelectionToSubmissionLogger = (function () {
        function SelectionToSubmissionLogger() {
            var _this = this;
            this.activeESSTests = "";
            // Suggestions displayed
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionShownMessage_1.SuggestionShownMessage.getTopic(), function (topic, message) {
                _this.activeESSTests = message.getActiveESSTests();
            });
            // Suggestion selected
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionSelectedMessage_1.SuggestionSelectedMessage.getTopic(), function (topic, message) {
                _this.domElementId = message.getDomElementId();
                _this.lob = message.getLob();
                _this.suggestionSelectedTimestamp = Date.now();
            });
            // Wizard submitted
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SubmitClickedMessage_1.SubmitClickedMessage.getTopic(), function (topic, message) {
                if (_this.domElementId) {
                    _this.submitClickedTimestamp = Date.now();
                    _this.emitSelectionToSubmissionMetric();
                    // reset logger state
                    _this.domElementId = undefined;
                    _this.lob = undefined;
                    _this.suggestionSelectedTimestamp = 0;
                    _this.submitClickedTimestamp = 0;
                }
            });
        }
        SelectionToSubmissionLogger.prototype.emitSelectionToSubmissionMetric = function () {
            new CollectorTransport_1.CollectorTransport().log(new SelectionToSubmissionMetric_1.SelectionToSubmissionMetric(this.lob, this.domElementId, this.suggestionSelectedTimestamp, this.submitClickedTimestamp, this.activeESSTests));
        };
        return SelectionToSubmissionLogger;
    }());
    exports.SelectionToSubmissionLogger = SelectionToSubmissionLogger;
});



///<amd-module name="typeahead/core/logging/SelectionToSubmissionMetric" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/logging/SelectionToSubmissionMetric", ["require", "exports", "typeahead/core/logging/TypeaheadMetric"], function (require, exports, TypeaheadMetric_1) {
    "use strict";
    exports.__esModule = true;
    var SelectionToSubmissionMetric = (function (_super) {
        __extends(SelectionToSubmissionMetric, _super);
        function SelectionToSubmissionMetric(lob, elementId, suggestionSelectedTimestamp, submitClickedTimestamp, activeESSTests) {
            var _this = _super.call(this, lob, elementId, "selectionToSubmission", activeESSTests) || this;
            _this.latency = submitClickedTimestamp - suggestionSelectedTimestamp;
            return _this;
        }
        return SelectionToSubmissionMetric;
    }(TypeaheadMetric_1.TypeaheadMetric));
    exports.SelectionToSubmissionMetric = SelectionToSubmissionMetric;
});



///<amd-module name="typeahead/core/logging/Severity"/>
define("typeahead/core/logging/Severity", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var Severity;
    (function (Severity) {
        Severity[Severity["MustFix"] = 0] = "MustFix";
        Severity[Severity["Excusable"] = 1] = "Excusable";
        Severity[Severity["Negligible"] = 2] = "Negligible";
    })(Severity = exports.Severity || (exports.Severity = {}));
});



///<amd-module name="typeahead/core/logging/SuggestionEngagementLogger" />
define("typeahead/core/logging/SuggestionEngagementLogger", ["require", "exports", "typeahead/core/logging/CollectorTransport", "typeahead/core/logging/SuggestionEngagementMetric", "typeahead/core/message/ElementFocusedMessage", "typeahead/core/message/InputValueEditedMessage", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/SuggestionShownMessage", "typeahead/core/message/TypeaheadMessage", "typeahead/core/message/UserExitedMessage"], function (require, exports, CollectorTransport_1, SuggestionEngagementMetric_1, ElementFocusedMessage_1, InputValueEditedMessage_1, SuggestionSelectedMessage_1, SuggestionShownMessage_1, TypeaheadMessage_1, UserExitedMessage_1) {
    "use strict";
    exports.__esModule = true;
    var SuggestionEngagementLogger = (function () {
        function SuggestionEngagementLogger() {
            var _this = this;
            this.isSuggestionShown = false;
            this.isSuggestionSelected = false;
            this.userTypedQuery = "";
            this.displayText = "";
            this.activeESSTests = "";
            // Input element focused
            TypeaheadMessage_1.TypeaheadMessage.subscribe(ElementFocusedMessage_1.ElementFocusedMessage.getTopic(), function (topic, message) {
                _this.lob = message.getContext().lob;
                _this.domElementId = message.getDomElementId();
                _this.displayText = message.getElementValue();
            });
            // Suggestions displayed
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionShownMessage_1.SuggestionShownMessage.getTopic(), function (topic, message) {
                _this.isSuggestionShown = true;
                _this.activeESSTests = message.getActiveESSTests();
            });
            // UserEdit or Suggestion deselected
            TypeaheadMessage_1.TypeaheadMessage.subscribe(InputValueEditedMessage_1.InputValueEditedMessage.getTopic(), function (topic, message) {
                _this.lob = message.getLob();
                _this.domElementId = message.getDomElementId();
                _this.isSuggestionSelected = false;
                _this.userTypedQuery = message.getNewInputValue();
                _this.displayText = message.getNewInputValue();
                _this.selectedSuggestion = undefined;
            });
            // Suggestion selected
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionSelectedMessage_1.SuggestionSelectedMessage.getTopic(), function (topic, message) {
                _this.lob = message.getLob();
                _this.selectedSuggestion = message.getSuggestion();
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(UserExitedMessage_1.UserExitedMessage.getTopic(), function (topic, message) {
                if (_this.domElementId) {
                    _this.emitSuggestionEngagementMetric();
                    // Reset logger state
                    _this.domElementId = undefined;
                    _this.lob = undefined;
                    _this.isSuggestionShown = false;
                    _this.isSuggestionSelected = false;
                    _this.userTypedQuery = "";
                    _this.displayText = "";
                    _this.selectedSuggestion = undefined;
                }
            });
        }
        SuggestionEngagementLogger.prototype.emitSuggestionEngagementMetric = function () {
            new CollectorTransport_1.CollectorTransport().log(new SuggestionEngagementMetric_1.SuggestionEngagementMetric(this.lob, this.domElementId, this.userTypedQuery, this.displayText, this.isSuggestionShown, this.selectedSuggestion, this.activeESSTests));
        };
        return SuggestionEngagementLogger;
    }());
    exports.SuggestionEngagementLogger = SuggestionEngagementLogger;
});



///<amd-module name="typeahead/core/logging/SuggestionEngagementMetric" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/logging/SuggestionEngagementMetric", ["require", "exports", "typeahead/core/logging/TypeaheadMetric"], function (require, exports, TypeaheadMetric_1) {
    "use strict";
    exports.__esModule = true;
    var SuggestionEngagementMetric = (function (_super) {
        __extends(SuggestionEngagementMetric, _super);
        function SuggestionEngagementMetric(lob, elementId, userTypedQuery, displayText, suggestionShown, selectedSuggestion, activeESSTests) {
            var _this = _super.call(this, lob, elementId, "SuggestionEngagement", activeESSTests) || this;
            _this.suggestionShown = suggestionShown;
            _this.userTypedQuery = userTypedQuery;
            if (selectedSuggestion) {
                _this.suggestionSelected = true;
                _this.text = selectedSuggestion.getDisplayText();
                _this.selectedSuggestionEssid = selectedSuggestion.getSourceName().orElse("-") + ":"
                    + selectedSuggestion.getSourceId().orElse("-");
                _this.isAddrAutocomplete = selectedSuggestion.isAddrAutoComplete();
            }
            else {
                _this.suggestionSelected = false;
                _this.text = displayText;
                _this.selectedSuggestionEssid = undefined;
            }
            return _this;
        }
        return SuggestionEngagementMetric;
    }(TypeaheadMetric_1.TypeaheadMetric));
    exports.SuggestionEngagementMetric = SuggestionEngagementMetric;
});



/// <amd-module name="typeahead/core/logging/TypeaheadErrorLogger"/>
define("typeahead/core/logging/TypeaheadErrorLogger", ["require", "exports", "typeahead/core/logging/DctkClientLogErrorTransport", "typeahead/core/logging/ErrorLogger"], function (require, exports, DctkClientLogErrorTransport_1, ErrorLogger_1) {
    "use strict";
    exports.__esModule = true;
    var logger = new ErrorLogger_1.ErrorLogger(new DctkClientLogErrorTransport_1.DctkClientLogErrorTransport());
    exports["default"] = {
        log: function (error, severity, origin, additional) {
            if (additional === void 0) { additional = {}; }
            logger.log(error, severity, origin, additional);
        }
    };
});



///<amd-module name="typeahead/core/logging/TypeaheadMetric" />
define("typeahead/core/logging/TypeaheadMetric", ["require", "exports", "typeahead/core/TypeaheadUtils"], function (require, exports, TypeaheadUtils_1) {
    "use strict";
    exports.__esModule = true;
    var TypeaheadMetric = (function () {
        function TypeaheadMetric(lob, elementId, type, activeESSTests) {
            this.contentFlavor = "uTA";
            this.deviceType = TypeaheadUtils_1.TypeaheadUtils.getDeviceType();
            this.guid = TypeaheadUtils_1.TypeaheadUtils.getGuid();
            this.lob = lob;
            this.locale = TypeaheadUtils_1.TypeaheadUtils.getLocale();
            this.pageId = TypeaheadUtils_1.TypeaheadUtils.getPageId();
            this.pointOfSale = TypeaheadUtils_1.TypeaheadUtils.getPointOfSale();
            this.siteId = TypeaheadUtils_1.TypeaheadUtils.getSiteId();
            this.textInputElementId = elementId;
            this.timestamp = Date.now();
            this.type = type;
            this.userAgent = navigator.userAgent;
            this.variants = _.compact([TypeaheadUtils_1.TypeaheadUtils.getClientSideExperimentVariants(), activeESSTests]).join("|");
        }
        return TypeaheadMetric;
    }());
    exports.TypeaheadMetric = TypeaheadMetric;
});



///<amd-module name="typeahead/core/message/ElementFocusedMessage" />
define("typeahead/core/message/ElementFocusedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var ElementFocusedMessage = (function () {
        function ElementFocusedMessage(elementValue, context, domElementId) {
            this.elementValue = elementValue;
            this.domElementId = domElementId;
            this.context = context;
        }
        ElementFocusedMessage.getTopic = function () {
            return "typeahead.element_focused";
        };
        ElementFocusedMessage.prototype.getTopic = function () {
            return ElementFocusedMessage.getTopic();
        };
        ElementFocusedMessage.prototype.getDomElementId = function () {
            return this.domElementId;
        };
        ElementFocusedMessage.prototype.getElementValue = function () {
            return this.elementValue;
        };
        ElementFocusedMessage.prototype.getContext = function () {
            return this.context;
        };
        return ElementFocusedMessage;
    }());
    exports.ElementFocusedMessage = ElementFocusedMessage;
});



define("typeahead/core/message/FormLoadedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var FormLoadedMessage = (function () {
        function FormLoadedMessage(tab) {
            this.tab = tab;
        }
        FormLoadedMessage.getTopic = function () {
            return "typeahead.form_loaded";
        };
        FormLoadedMessage.prototype.getTopic = function () {
            return FormLoadedMessage.getTopic();
        };
        FormLoadedMessage.prototype.getTab = function () {
            return this.tab;
        };
        return FormLoadedMessage;
    }());
    exports.FormLoadedMessage = FormLoadedMessage;
});



///<amd-module name="typeahead/core/message/FormSubmittedMessage" />
define("typeahead/core/message/FormSubmittedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var FormSubmittedMessage = (function () {
        function FormSubmittedMessage(formValid, context) {
            this.formValid = formValid;
            this.context = context;
        }
        FormSubmittedMessage.getTopic = function () {
            return "typeahead.form_submitted";
        };
        FormSubmittedMessage.prototype.getTopic = function () {
            return FormSubmittedMessage.getTopic();
        };
        FormSubmittedMessage.prototype.isFormValid = function () {
            return this.formValid;
        };
        FormSubmittedMessage.prototype.getContext = function () {
            return this.context;
        };
        return FormSubmittedMessage;
    }());
    exports.FormSubmittedMessage = FormSubmittedMessage;
});



///<amd-module name="typeahead/core/message/InputClearedMessage" />
define("typeahead/core/message/InputClearedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var InputClearedMessage = (function () {
        function InputClearedMessage($elem) {
            this.$elem = $elem;
        }
        /* 2017-05-18: This string should match the value published in uitoolkit in uitk_formutils.js */
        InputClearedMessage.getTopic = function () {
            return "Input cleared";
        };
        InputClearedMessage.prototype.getTopic = function () {
            return InputClearedMessage.getTopic();
        };
        return InputClearedMessage;
    }());
    exports.InputClearedMessage = InputClearedMessage;
});



///<amd-module name="typeahead/core/message/InputValueEditedMessage" />
define("typeahead/core/message/InputValueEditedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var InputValueEditedMessage = (function () {
        function InputValueEditedMessage(newInputValue, lob, domElementId) {
            this.newInputValue = newInputValue;
            this.domElementId = domElementId;
            this.lob = lob;
        }
        InputValueEditedMessage.getTopic = function () {
            return "typeahead.input_value_edited";
        };
        InputValueEditedMessage.prototype.getTopic = function () {
            return InputValueEditedMessage.getTopic();
        };
        InputValueEditedMessage.prototype.getNewInputValue = function () {
            return this.newInputValue;
        };
        InputValueEditedMessage.prototype.getDomElementId = function () {
            return this.domElementId;
        };
        InputValueEditedMessage.prototype.getLob = function () {
            return this.lob;
        };
        return InputValueEditedMessage;
    }());
    exports.InputValueEditedMessage = InputValueEditedMessage;
});



///<amd-module name="typeahead/core/message/SubmitClickedMessage" />
define("typeahead/core/message/SubmitClickedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var SubmitClickedMessage = (function () {
        function SubmitClickedMessage(rfrrIdPrefix, event) {
            this.rfrrIdPrefix = rfrrIdPrefix;
            this.event = event;
        }
        SubmitClickedMessage.getTopic = function () {
            return "typeahead.submit_clicked";
        };
        SubmitClickedMessage.prototype.getTopic = function () {
            return SubmitClickedMessage.getTopic();
        };
        SubmitClickedMessage.prototype.getRfrrIdPrefix = function () {
            return this.rfrrIdPrefix;
        };
        SubmitClickedMessage.prototype.getEvent = function () {
            return this.event;
        };
        return SubmitClickedMessage;
    }());
    exports.SubmitClickedMessage = SubmitClickedMessage;
});



///<amd-module name="typeahead/core/message/SuggestionAutoSelectedMessage" />
define("typeahead/core/message/SuggestionAutoSelectedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var SuggestionAutoSelectedMessage = (function () {
        function SuggestionAutoSelectedMessage(suggestion, domElementId) {
            this.suggestion = suggestion;
            this.domElementId = domElementId;
        }
        SuggestionAutoSelectedMessage.getTopic = function () {
            return "typeahead.suggestion_auto_selected";
        };
        SuggestionAutoSelectedMessage.prototype.getTopic = function () {
            return SuggestionAutoSelectedMessage.getTopic();
        };
        SuggestionAutoSelectedMessage.prototype.getSuggestion = function () {
            return this.suggestion;
        };
        SuggestionAutoSelectedMessage.prototype.getDomElementId = function () {
            return this.domElementId;
        };
        return SuggestionAutoSelectedMessage;
    }());
    exports.SuggestionAutoSelectedMessage = SuggestionAutoSelectedMessage;
});



///<amd-module name="typeahead/core/message/SuggestionSelectedMessage" />
define("typeahead/core/message/SuggestionSelectedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var SuggestionSelectedMessage = (function () {
        function SuggestionSelectedMessage(suggestion, e, lob, domElementId) {
            this.suggestion = suggestion;
            this.domElementId = domElementId;
            this.lob = lob;
            this.selectionMethod = (e && e.type) ? (e.type.indexOf("mouse") > -1 ? "mouse" :
                e.type.indexOf("key") > -1 ? "keyboard" : e.type.indexOf("touch") > -1 ? "touch" : "unknown") : "unknown";
        }
        SuggestionSelectedMessage.getTopic = function () {
            return "typeahead.suggestion_selected";
        };
        SuggestionSelectedMessage.prototype.getTopic = function () {
            return SuggestionSelectedMessage.getTopic();
        };
        SuggestionSelectedMessage.prototype.getSuggestion = function () {
            return this.suggestion;
        };
        SuggestionSelectedMessage.prototype.getDomElementId = function () {
            return this.domElementId;
        };
        SuggestionSelectedMessage.prototype.getSelectionMethod = function () {
            return this.selectionMethod;
        };
        SuggestionSelectedMessage.prototype.getLob = function () {
            return this.lob;
        };
        return SuggestionSelectedMessage;
    }());
    exports.SuggestionSelectedMessage = SuggestionSelectedMessage;
});



///<amd-module name="typeahead/core/message/SuggestionShownMessage" />
define("typeahead/core/message/SuggestionShownMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var SuggestionShownMessage = (function () {
        function SuggestionShownMessage(suggestions, elementValue, activeESSTests, lob, renderTime, domElementId) {
            this.suggestions = suggestions;
            this.domElementId = domElementId;
            this.elementValue = elementValue;
            this.lob = lob;
            this.activeESSTests = activeESSTests;
            this.renderTime = renderTime;
        }
        SuggestionShownMessage.getTopic = function () {
            return "typeahead.suggestion_shown";
        };
        SuggestionShownMessage.prototype.getTopic = function () {
            return SuggestionShownMessage.getTopic();
        };
        SuggestionShownMessage.prototype.getDomElementId = function () {
            return this.domElementId;
        };
        SuggestionShownMessage.prototype.getShownSuggestions = function () {
            return this.suggestions;
        };
        SuggestionShownMessage.prototype.getElementValue = function () {
            return this.elementValue;
        };
        SuggestionShownMessage.prototype.getLob = function () {
            return this.lob;
        };
        SuggestionShownMessage.prototype.getActiveESSTests = function () {
            return this.activeESSTests;
        };
        SuggestionShownMessage.prototype.getRenderTime = function () {
            return this.renderTime;
        };
        return SuggestionShownMessage;
    }());
    exports.SuggestionShownMessage = SuggestionShownMessage;
});



/// <amd-module name="typeahead/core/message/TypeaheadMessage" />
define("typeahead/core/message/TypeaheadMessage", ["require", "exports", "uitk"], function (require, exports, uitk) {
    "use strict";
    exports.__esModule = true;
    /// <amd-dependency path="uitk" name="uitk"/>
    /// <reference path="../../../typings/typeahead/uitk.d.ts" />
    var TypeaheadMessage = (function () {
        function TypeaheadMessage() {
        }
        TypeaheadMessage.publish = function (msg) {
            uitk.publish(msg.getTopic(), msg);
        };
        TypeaheadMessage.subscribe = function (topic, handler) {
            return uitk.subscribe(topic, handler);
        };
        TypeaheadMessage.unsubscribe = function (topic, token) {
            return uitk.unsubscribe(topic, token);
        };
        return TypeaheadMessage;
    }());
    exports.TypeaheadMessage = TypeaheadMessage;
});



///<amd-module name="typeahead/core/message/UserExitedMessage" />
define("typeahead/core/message/UserExitedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var UserExitedMessage = (function () {
        function UserExitedMessage() {
        }
        UserExitedMessage.getTopic = function () {
            return "typeahead.user_exited";
        };
        UserExitedMessage.prototype.getTopic = function () {
            return UserExitedMessage.getTopic();
        };
        return UserExitedMessage;
    }());
    exports.UserExitedMessage = UserExitedMessage;
});



/// <amd-module name="typeahead/core/plugins/CompositePageLoadHandler" />
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>
define("typeahead/core/plugins/CompositePageLoadHandler", ["require", "exports", "typeahead/core/context", "typeahead/client/ClientHandlerRegistry", "typeahead/client/FlightSearchResultsPageHandler", "typeahead/client/HotelSearchResultsPageHandler", "typeahead/client/MercuryWizardHandler", "typeahead/client/OpenSearchPageHandler", "typeahead/core/abTest", "typeahead/core/plugins/DefaultPluginAssembly", "typeahead/core/TypeaheadUtils"], function (require, exports, coreContext, ClientHandlerRegistry_1, FlightSearchResultsPageHandler_1, HotelSearchResultsPageHandler_1, MercuryWizardHandler_1, OpenSearchPageHandler_1, abTest, DefaultPluginAssembly_1, TypeaheadUtils_1) {
    "use strict";
    exports.__esModule = true;
    var CompositePageLoadHandler = (function () {
        function CompositePageLoadHandler() {
        }
        CompositePageLoadHandler.getInstance = function () {
            if (!CompositePageLoadHandler.instance) {
                CompositePageLoadHandler.instance = new CompositePageLoadHandler();
            }
            return CompositePageLoadHandler.instance;
        };
        CompositePageLoadHandler.prototype.handlePageLoad = function (pluginAssembly) {
            var deferred = $.Deferred();
            if (!CompositePageLoadHandler.isPageLoadHandled) {
                abTest.evaluateAllExperiments(pluginAssembly);
                var options_1 = {
                    maxresults: 10
                };
                var context_1 = {
                    clientId: TypeaheadUtils_1.TypeaheadUtils.getClientId(),
                    expuserid: TypeaheadUtils_1.TypeaheadUtils.getExpUserId(),
                    guid: TypeaheadUtils_1.TypeaheadUtils.getGuid(),
                    lob: undefined,
                    locale: coreContext.locale,
                    serviceUrl: coreContext.serviceUrl,
                    siteid: coreContext.siteid
                };
                var pageLoadHandlers = pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.pageLoadHandlerIdentifier);
                if (pageLoadHandlers && pageLoadHandlers.length > 0) {
                    var handlePageLoadPromises = pageLoadHandlers.map(function (plugin) {
                        return plugin.handlePageLoad(options_1, context_1);
                    });
                    $.when.apply($, handlePageLoadPromises).done(function () {
                        deferred.resolve(undefined);
                    });
                }
                else {
                    deferred.resolve(undefined);
                }
                this.registerClients();
                CompositePageLoadHandler.isPageLoadHandled = true;
            }
            else {
                deferred.resolve(undefined);
            }
            return deferred.promise();
        };
        CompositePageLoadHandler.prototype.registerClients = function () {
            ClientHandlerRegistry_1.ClientHandlerRegistry.registerClient(new MercuryWizardHandler_1.MercuryWizardHandler());
            ClientHandlerRegistry_1.ClientHandlerRegistry.registerClient(new FlightSearchResultsPageHandler_1.FlightSearchResultsPageHandler());
            ClientHandlerRegistry_1.ClientHandlerRegistry.registerClient(new HotelSearchResultsPageHandler_1.HotelSearchResultsPageHandler());
            ClientHandlerRegistry_1.ClientHandlerRegistry.registerClient(new OpenSearchPageHandler_1.OpenSearchPageHandler());
            ClientHandlerRegistry_1.ClientHandlerRegistry.handlePageLoad();
        };
        CompositePageLoadHandler.isPageLoadHandled = false;
        return CompositePageLoadHandler;
    }());
    exports.CompositePageLoadHandler = CompositePageLoadHandler;
});



/// <amd-module name="typeahead/core/plugins/DefaultPluginAssembly" />
/// <amd-dependency path="jquery" name="$" />
define("typeahead/core/plugins/DefaultPluginAssembly", ["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    /// <reference path="../../../typings/typeahead/plugins.d.ts" />
    /// <reference path="../../../typings/typeahead/browser.d.ts" />
    var DefaultPluginAssembly = (function () {
        function DefaultPluginAssembly() {
            this.plugins = [];
        }
        DefaultPluginAssembly.prototype.registerPlugin = function (plugin) {
            addPluginToList(this.plugins, plugin);
        };
        DefaultPluginAssembly.prototype.get = function (identifier) {
            return this.plugins.filter(function (plugin) {
                return identifier(plugin);
            });
        };
        DefaultPluginAssembly.requestParamModifierIdentifier = function (plugin) {
            return "modifyParameters" in plugin;
        };
        DefaultPluginAssembly.suggestionsModifierIdentifier = function (plugin) {
            return "modifySuggestions" in plugin;
        };
        DefaultPluginAssembly.dropDownHideHandler = function (plugin) {
            return _.isFunction(plugin.handleDropDownHide);
        };
        DefaultPluginAssembly.dropDownShowHandler = function (plugin) {
            return _.isFunction(plugin.handleDropDownShow);
        };
        DefaultPluginAssembly.dropdownContentHandler = function (plugin) {
            return _.isFunction(plugin.handleContentToShow);
        };
        DefaultPluginAssembly.onFocusSuggestionsProviderIdentifier = function (plugin) {
            return _.isFunction(plugin.suggestOnFocus);
        };
        DefaultPluginAssembly.pageLoadHandlerIdentifier = function (plugin) {
            return _.isFunction(plugin.handlePageLoad);
        };
        DefaultPluginAssembly.experimentIdentifier = function (plugin) {
            return _.isFunction(plugin.getExperiments);
        };
        return DefaultPluginAssembly;
    }());
    exports.DefaultPluginAssembly = DefaultPluginAssembly;
    // internal scope, these should not be exposed to the outside world
    function addPluginToList(utaPluginList, utaPlugin) {
        if (utaPluginList.indexOf(utaPlugin) < 0) {
            utaPluginList.push(utaPlugin);
        }
    }
});



/// <amd-module name="typeahead/core/plugins/ExecutionHelper" />
/// <amd-dependency path="jquery" name="$"/>
define("typeahead/core/plugins/ExecutionHelper", ["require", "exports", "jquery", "typeahead/core/abTest"], function (require, exports, $, abTest) {
    "use strict";
    exports.__esModule = true;
    // prop mapping between StripingConfigration's properties and Context's properties
    var supportedProperties = {
        clients: "clientId",
        lobs: "lob",
        locales: "locale",
        siteids: "siteid",
        tabs: "tab"
    };
    function evaluateExperiment(experiment, deferred) {
        if (experiment.name) {
            abTest.getAndLog(experiment.name)
                .done(function (exp) {
                deferred.resolve(typeof experiment.value !== "undefined" ?
                    experiment.value === exp.value : exp.value > 0);
            })
                .fail(function () {
                deferred.resolve(false);
            });
        }
        else {
            deferred.resolve(false);
        }
    }
    exports.evaluateExperiment = evaluateExperiment;
    function getContextProp(configProp) {
        return supportedProperties.hasOwnProperty(configProp) ? supportedProperties[configProp] : null;
    }
    function getApplicableConfiguration(context, stripingConfigurations) {
        var stripingConfiguration;
        for (var i = 0; i < stripingConfigurations.length; i++) {
            stripingConfiguration = stripingConfigurations[i];
            var isConfigApplicable = true;
            for (var configProp in stripingConfiguration) {
                if (configProp !== "experiment" && stripingConfiguration.hasOwnProperty(configProp) &&
                    stripingConfiguration[configProp]) {
                    var contextProp = getContextProp(configProp);
                    if (contextProp && stripingConfiguration[configProp].indexOf(context[contextProp]) < 0) {
                        isConfigApplicable = false;
                        break;
                    }
                }
            }
            if (isConfigApplicable) {
                return stripingConfiguration;
            }
        }
        return undefined;
    }
    function shouldExecute(context, stripingConfigurations) {
        var deferred = $.Deferred();
        if (!stripingConfigurations || !stripingConfigurations.length || !context) {
            return deferred.resolve(true).promise();
        }
        var stripingConfig = getApplicableConfiguration(context, stripingConfigurations);
        if (stripingConfig) {
            if (stripingConfig.experiment) {
                evaluateExperiment(stripingConfig.experiment, deferred);
            }
            else {
                deferred.resolve(true);
            }
        }
        else {
            deferred.resolve(false);
        }
        return deferred.promise();
    }
    exports.shouldExecute = shouldExecute;
});



/// <amd-module name="typeahead/core/plugins/SuggestionsProvider" />
/// <amd-dependency path="jquery" name="$"/>
define("typeahead/core/plugins/SuggestionsProvider", ["require", "exports", "jquery", "typeahead/core/plugins/DefaultPluginAssembly"], function (require, exports, $, DefaultPluginAssembly_1) {
    "use strict";
    exports.__esModule = true;
    var SuggestionsProvider = (function () {
        function SuggestionsProvider(pluginAssembly) {
            this.suggestionsModifiers = [];
            this.suggestionsModifiers = pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.suggestionsModifierIdentifier);
        }
        SuggestionsProvider.prototype.modifySuggestions = function (results, context, options) {
            if (options === void 0) { options = {}; }
            var deferred = $.Deferred();
            if (results && results.length > 0 && this.suggestionsModifiers && this.suggestionsModifiers.length > 0) {
                $.when.apply($, this.suggestionsModifiers.map(function (suggestionsModifier) {
                    return suggestionsModifier.modifySuggestions(results, context, options);
                }))
                    .done(function () {
                    deferred.resolve(results);
                });
            }
            else {
                return deferred.resolve([]);
            }
            return deferred.promise();
        };
        return SuggestionsProvider;
    }());
    exports.SuggestionsProvider = SuggestionsProvider;
});



/// <amd-module name="typeahead/core/presentation/DropDownHideHandlersAssembly" />
define("typeahead/core/presentation/DropDownHideHandlersAssembly", ["require", "exports", "typeahead/core/plugins/DefaultPluginAssembly"], function (require, exports, DefaultPluginAssembly_1) {
    "use strict";
    exports.__esModule = true;
    var DropDownHideHandlersAssembly = (function () {
        function DropDownHideHandlersAssembly(pluginAssembly) {
            this.handlers = pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.dropDownHideHandler);
        }
        DropDownHideHandlersAssembly.prototype.runHandlers = function ($dropDownElement, $inputElement, context) {
            this.handlers.map(function (plugin) {
                return plugin.handleDropDownHide($dropDownElement, $inputElement, context);
            });
        };
        return DropDownHideHandlersAssembly;
    }());
    exports.DropDownHideHandlersAssembly = DropDownHideHandlersAssembly;
});



/// <amd-module name="typeahead/core/presentation/DropDownShowHandlersAssembly" />
define("typeahead/core/presentation/DropDownShowHandlersAssembly", ["require", "exports", "typeahead/core/plugins/DefaultPluginAssembly"], function (require, exports, DefaultPluginAssembly_1) {
    "use strict";
    exports.__esModule = true;
    var DropDownShowHandlersAssembly = (function () {
        function DropDownShowHandlersAssembly(pluginAssembly) {
            this.handlers = pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.dropDownShowHandler);
        }
        DropDownShowHandlersAssembly.prototype.runHandlers = function ($dropDownElement, $inputElement, context) {
            this.handlers.map(function (plugin) {
                return plugin.handleDropDownShow($dropDownElement, $inputElement, context);
            });
        };
        return DropDownShowHandlersAssembly;
    }());
    exports.DropDownShowHandlersAssembly = DropDownShowHandlersAssembly;
});



/// <amd-module name="typeahead/core/presentation/DropdownContentHandlersAssembly" />
define("typeahead/core/presentation/DropdownContentHandlersAssembly", ["require", "exports", "typeahead/core/plugins/DefaultPluginAssembly"], function (require, exports, DefaultPluginAssembly_1) {
    "use strict";
    exports.__esModule = true;
    var DropdownContentHandlersAssembly = (function () {
        function DropdownContentHandlersAssembly(pluginAssembly) {
            this.handlers = pluginAssembly.get(DefaultPluginAssembly_1.DefaultPluginAssembly.dropdownContentHandler);
        }
        DropdownContentHandlersAssembly.prototype.runHandlers = function ($dropDownElement, $inputElement, context) {
            this.handlers.map(function (plugin) {
                return plugin.handleContentToShow($dropDownElement, $inputElement, context);
            });
        };
        return DropdownContentHandlersAssembly;
    }());
    exports.DropdownContentHandlersAssembly = DropdownContentHandlersAssembly;
});



/// <amd-module name="typeahead/features/IDropDownHideHandler" />
define("typeahead/features/IDropDownHideHandler", ["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    /// <amd-dependency path="jquery" name="$"/>
    /// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
});



/// <amd-module name="typeahead/features/IDropDownShowHandler" />
define("typeahead/features/IDropDownShowHandler", ["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    /// <amd-dependency path="jquery" name="$"/>
    /// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
});



/// <amd-module name="typeahead/features/IDropdownContentHandler" />
define("typeahead/features/IDropdownContentHandler", ["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    /// <amd-dependency path="jquery" name="$"/>
    /// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
});



/// <amd-module name="typeahead/core/presentation/IInputElementFocusHandler" />
define("typeahead/core/presentation/IInputElementFocusHandler", ["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    /// <amd-dependency path="jquery" name="$"/>
    /// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
    /// <reference path="../../../typings/typeahead/plugins.d.ts" />
    exports.isInputElementFocusHandler = function (plugin) {
        return _.isObject(plugin) && _.isFunction(plugin.handleInputElementFocus);
    };
});



/// <amd-module name="typeahead/core/util/Functional" />
define("typeahead/core/util/Functional", ["require", "exports", "typeahead/core/logging/TypeaheadErrorLogger", "typeahead/core/logging/ProblemOrigin", "typeahead/core/logging/Severity"], function (require, exports, TypeaheadErrorLogger_1, ProblemOrigin_1, Severity_1) {
    "use strict";
    exports.__esModule = true;
    // Applies the method named methodName of each target in targets to that target along with the specified args and
    // returns a new array with each element being the return value of the function.
    function mapMethodByName(targets, methodName) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (!_.isArray(targets)) {
            TypeaheadErrorLogger_1["default"].log(new Error("mapMethodByName expected targets to be in an array, but got " + JSON.stringify(targets)), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
            return [];
        }
        var returnValues = [];
        for (var _a = 0, targets_1 = targets; _a < targets_1.length; _a++) {
            var target = targets_1[_a];
            var method = target[methodName];
            if (_.isFunction(method)) {
                try {
                    returnValues.push(method.apply(target, args));
                }
                catch (e) {
                    TypeaheadErrorLogger_1["default"].log(e, Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
                }
            }
            else {
                TypeaheadErrorLogger_1["default"].log(new Error(methodName + " is not supported by " + JSON.stringify(target)), Severity_1.Severity.MustFix, ProblemOrigin_1.ProblemOrigin.UniversalTypeahead);
            }
        }
        return returnValues;
    }
    exports.mapMethodByName = mapMethodByName;
});



/// <amd-module name="typeahead/core/util/Optional"/>
define("typeahead/core/util/Optional", ["require", "exports", "underscore"], function (require, exports, _) {
    "use strict";
    exports.__esModule = true;
    var Optional = (function () {
        function Optional(value) {
            this.value = value;
        }
        Optional.of = function (value) {
            if (Optional.isEmpty(value)) {
                throw ("Optional.of() does not accept undefined or null as argument");
            }
            return new Optional(value);
        };
        Optional.ofNullable = function (value) {
            return new Optional(value);
        };
        Optional.empty = function () {
            return new Optional(null);
        };
        Optional.isEmpty = function (value) {
            return _.isUndefined(value) || _.isNull(value);
        };
        Optional.prototype.get = function () {
            if (this.isPresent()) {
                return this.value;
            }
            throw new Error("trying to get the value of an empty Optional");
        };
        Optional.prototype.isPresent = function () {
            return !Optional.isEmpty(this.value);
        };
        Optional.prototype.orElse = function (alternative) {
            if (this.isPresent()) {
                return this.value;
            }
            else {
                return alternative;
            }
        };
        return Optional;
    }());
    exports.Optional = Optional;
});



var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("typeahead/core/geolocation/logging/GeolocationMetric", ["require", "exports", "typeahead/core/logging/TypeaheadMetric"], function (require, exports, TypeaheadMetric_1) {
    "use strict";
    exports.__esModule = true;
    var GeolocationMetric = (function (_super) {
        __extends(GeolocationMetric, _super);
        function GeolocationMetric(lob, elementId, beginTimestamp, endTimestamp, position, positionError, activeESSTests) {
            var _this = _super.call(this, lob, elementId, "GeolocationAsSuggestion", activeESSTests) || this;
            _this.position = position;
            _this.positionError = positionError;
            _this.latency = endTimestamp - beginTimestamp;
            return _this;
        }
        return GeolocationMetric;
    }(TypeaheadMetric_1.TypeaheadMetric));
    exports.GeolocationMetric = GeolocationMetric;
});



define("typeahead/core/geolocation/logging/GeolocationMetricLogger", ["require", "exports", "typeahead/core/geolocation/logging/GeolocationMetric", "typeahead/core/geolocation/message/GeolocationRequestMessage", "typeahead/core/geolocation/message/GeolocationResponseMessage", "typeahead/core/logging/CollectorTransport", "typeahead/core/message/TypeaheadMessage", "typeahead/core/TypeaheadUtils"], function (require, exports, GeolocationMetric_1, GeolocationRequestMessage_1, GeolocationResponseMessage_1, CollectorTransport_1, TypeaheadMessage_1, TypeaheadUtils_1) {
    "use strict";
    exports.__esModule = true;
    var GeolocationMetricLogger = (function () {
        function GeolocationMetricLogger() {
            var _this = this;
            TypeaheadMessage_1.TypeaheadMessage.subscribe(GeolocationRequestMessage_1.GeolocationRequestMessage.getTopic(), function (topic, message) {
                _this.lob = TypeaheadUtils_1.Lob[TypeaheadUtils_1.TypeaheadUtils.getLob()];
                _this.domElementId = message.getDomElementId();
                _this.beginTimestamp = Date.now();
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(GeolocationResponseMessage_1.GeolocationResponseMessage.getTopic(), function (topic, message) {
                _this.position = message.getPosition();
                _this.positionError = message.getPositionError();
                _this.endTimestamp = Date.now();
                _this.emitGeolocationMetric();
            });
        }
        GeolocationMetricLogger.prototype.emitGeolocationMetric = function () {
            new CollectorTransport_1.CollectorTransport().log(new GeolocationMetric_1.GeolocationMetric(TypeaheadUtils_1.Lob[TypeaheadUtils_1.TypeaheadUtils.getLob()], this.domElementId, this.beginTimestamp, this.endTimestamp, this.position, this.positionError, undefined));
        };
        return GeolocationMetricLogger;
    }());
    exports.GeolocationMetricLogger = GeolocationMetricLogger;
});



///<amd-module name="typeahead/core/geolocation/message/GeolocationClearedMessage" />
define("typeahead/core/geolocation/message/GeolocationClearedMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var GeolocationClearedMessage = (function () {
        function GeolocationClearedMessage(geolocationResult) {
            this.geolocationResult = geolocationResult;
        }
        GeolocationClearedMessage.getTopic = function () {
            return "typeahead.geolocation_cleared";
        };
        GeolocationClearedMessage.prototype.getTopic = function () {
            return GeolocationClearedMessage.getTopic();
        };
        GeolocationClearedMessage.prototype.getGeolocationResult = function () {
            return this.geolocationResult;
        };
        return GeolocationClearedMessage;
    }());
    exports.GeolocationClearedMessage = GeolocationClearedMessage;
});



///<amd-module name="typeahead/core/geolocation/message/GeolocationRequestMessage" />
define("typeahead/core/geolocation/message/GeolocationRequestMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var GeolocationRequestMessage = (function () {
        function GeolocationRequestMessage(domElementId) {
            this.domElementId = domElementId;
        }
        GeolocationRequestMessage.getTopic = function () {
            return "typeahead.geolocation_request";
        };
        GeolocationRequestMessage.prototype.getTopic = function () {
            return GeolocationRequestMessage.getTopic();
        };
        GeolocationRequestMessage.prototype.getDomElementId = function () {
            return this.domElementId;
        };
        return GeolocationRequestMessage;
    }());
    exports.GeolocationRequestMessage = GeolocationRequestMessage;
});



///<amd-module name="typeahead/core/geolocation/message/GeolocationResponseMessage" />
define("typeahead/core/geolocation/message/GeolocationResponseMessage", ["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var GeolocationResponseMessage = (function () {
        function GeolocationResponseMessage(position, postionError, geolocationResult, submitButton) {
            if (submitButton === void 0) { submitButton = undefined; }
            this.position = position;
            this.postionError = postionError;
            this.geolocationResult = geolocationResult;
            this.submitButton = submitButton;
        }
        GeolocationResponseMessage.getTopic = function () {
            return "typeahead.geolocation_response";
        };
        GeolocationResponseMessage.prototype.getTopic = function () {
            return GeolocationResponseMessage.getTopic();
        };
        GeolocationResponseMessage.prototype.getPosition = function () {
            return this.position;
        };
        GeolocationResponseMessage.prototype.getPositionError = function () {
            return this.postionError;
        };
        GeolocationResponseMessage.prototype.getGeolocationResult = function () {
            return this.geolocationResult;
        };
        GeolocationResponseMessage.prototype.getSubmitButton = function () {
            return this.submitButton;
        };
        return GeolocationResponseMessage;
    }());
    exports.GeolocationResponseMessage = GeolocationResponseMessage;
});



/// <amd-module name="typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils" />
define("typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils", ["require", "exports", "typeahead/core/plugins/ExecutionHelper"], function (require, exports, ExecutionHelper) {
    "use strict";
    exports.__esModule = true;
    function addFeatureFlag(featureFlag, configuration, params, context, options) {
        var deferred = $.Deferred();
        if (typeof params !== "undefined") {
            ExecutionHelper.shouldExecute(context, configuration)
                .done(function (shouldExecute) {
                params.features = params.features && params.features.length &&
                    params.features.push ? params.features || [] : [];
                if (shouldExecute && params.features.indexOf(featureFlag) < 0) {
                    params.features.push(featureFlag);
                }
            })
                .always(function () {
                deferred.resolve(params);
            });
        }
        else {
            deferred.resolve(params);
        }
        return deferred.promise();
    }
    exports.addFeatureFlag = addFeatureFlag;
});



/// <amd-module name="typeahead/features/AtlasHigherLevelRegionsParamModifier" />
/// <amd-dependency path="jquery" name="$"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
require(["require","exports","jquery","typeahead/core/SuggestServiceParamModifier","universalTypeahead"], function(require,exports,$,SuggestServiceParamModifier_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var AtlasHigherLevelRegionsParamModifier = (function (_super) {
        __extends(AtlasHigherLevelRegionsParamModifier, _super);
        function AtlasHigherLevelRegionsParamModifier() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.configuration = [{
                    lobs: ["HOTELS"]
                }];
            _this.featureName = "IncludeHLR";
            return _this;
        }
        AtlasHigherLevelRegionsParamModifier.prototype.modify = function (params, context, options) {
            this.addRegionType(params, 256);
        };
        return AtlasHigherLevelRegionsParamModifier;
    }(SuggestServiceParamModifier_1.SuggestServiceParamModifier));
universalTypeahead_1.registerPlugin(new AtlasHigherLevelRegionsParamModifier());
});



/// <amd-module name="typeahead/features/CarRentalRequestParamModifier" />
/// <amd-dependency path="jquery" name="$"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
require(["require","exports","jquery","typeahead/core/SuggestServiceParamModifier","universalTypeahead"], function(require,exports,$,SuggestServiceParamModifier_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var featureFlags = ["cars_rental", "carsclickpopularity"];
    var maxResults = 8;
    var sortCriteria = "popularity";
    var CarRentalRequestParamModifier = (function (_super) {
        __extends(CarRentalRequestParamModifier, _super);
        function CarRentalRequestParamModifier() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.configuration = [{
                    lobs: ["CARS"]
                }];
            return _this;
        }
        CarRentalRequestParamModifier.prototype.modify = function (params, context, options) {
            params.maxresults = maxResults;
            params.sortcriteria = sortCriteria;
            params.features = params.features && params.features.length ? params.features : [];
            Array.prototype.push.apply(params.features, featureFlags);
        };
        return CarRentalRequestParamModifier;
    }(SuggestServiceParamModifier_1.SuggestServiceParamModifier));
universalTypeahead_1.registerPlugin(new CarRentalRequestParamModifier());
});



/// <amd-module name="typeahead/features/ContextualTAParamModifier" />
require(["require","exports","typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils","universalTypeahead"], function(require,exports,SuggestServiceQueryParamsUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            lobs: ["HOTELS"]
        }];
    var featureFlag = "contextual_ta";
    var ContextualTAParamModifier = (function () {
        function ContextualTAParamModifier() {
        }
        ContextualTAParamModifier.prototype.modifyParameters = function (params, context, options) {
            return SuggestServiceQueryParamsUtils_1.addFeatureFlag(featureFlag, configuration, params, context, options);
        };
        return ContextualTAParamModifier;
    }());
universalTypeahead_1.registerPlugin(new ContextualTAParamModifier());
});



require(["require","exports","typeahead/core/geolocation/GeolocationDataProvider","typeahead/core/geolocation/logging/GeolocationMetricLogger","typeahead/core/geolocation/MercuryGeolocationViewController","typeahead/core/message/FormLoadedMessage","typeahead/core/message/TypeaheadMessage","typeahead/core/plugins/ExecutionHelper","typeahead/core/StripingConfiguration","typeahead/core/SuggestionsAggregator","typeahead/core/TypeaheadUtils","universalTypeahead"], function(require,exports,GeolocationDataProvider_1,GeolocationMetricLogger_1,MercuryGeolocationViewController_1,FormLoadedMessage_1,TypeaheadMessage_1,ExecutionHelper,StripingConfiguration,SuggestionsAggregator_1,TypeaheadUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            experiment: {
                id: 11852,
                name: "CWTA_MobileFirstCurrentLocation",
                value: 1
            },
            tabs: ["hotel"]
        }];
    var applicableClients = ["Homepage", "HotelsLandingPage"];
    var CurrentLocationSuggester = (function () {
        function CurrentLocationSuggester() {
        }
        CurrentLocationSuggester.prototype.handlePageLoad = function (options, context) {
            var _this = this;
            var deferred = $.Deferred();
            if (applicableClients.indexOf(context.clientId) > -1) {
                TypeaheadMessage_1.TypeaheadMessage.subscribe(FormLoadedMessage_1.FormLoadedMessage.getTopic(), function (topic, message) {
                    context.tab = message.getTab();
                    if (TypeaheadUtils_1.TypeaheadUtils.isWithinMobileBreakpoint()) {
                        ExecutionHelper.shouldExecute(context, configuration).done(function (shouldExecute) {
                            if (shouldExecute) {
                                _this.initialize();
                                _this.mercuryGeolocationViewController.updateView(message.getTab());
                            }
                        });
                    }
                });
            }
            return deferred.resolve(undefined).promise();
        };
        CurrentLocationSuggester.prototype.suggestOnFocus = function (options, context) {
            return this.suggest(options, context);
        };
        CurrentLocationSuggester.prototype.suggest = function (options, context) {
            var _this = this;
            var deferred = $.Deferred();
            var emptySuggesterResponse = { id: this.getId(), results: [] };
            ExecutionHelper.shouldExecute(context, configuration).done(function (shouldExecute) {
                if (shouldExecute) {
                    _this.initialize();
                    _this.geolocationDataProvider.fetchData(options).done(function (response) {
                        deferred.resolve({ id: _this.getId(), results: response.results });
                    }).fail(function () {
                        deferred.resolve(emptySuggesterResponse);
                    });
                }
                else {
                    deferred.resolve(emptySuggesterResponse);
                }
            }).fail(function () {
                deferred.resolve(emptySuggesterResponse);
            });
            return deferred.promise();
        };
        CurrentLocationSuggester.prototype.getId = function () {
            return SuggestionsAggregator_1.SuggesterId.CurrentLocationSuggester;
        };
        CurrentLocationSuggester.prototype.getExperiments = function () {
            return StripingConfiguration.getExperiments(configuration);
        };
        CurrentLocationSuggester.prototype.initialize = function () {
            if (!this.geolocationDataProvider) {
                this.geolocationDataProvider = new GeolocationDataProvider_1.GeolocationDataProvider();
                this.mercuryGeolocationViewController = new MercuryGeolocationViewController_1.MercuryGeolocationViewController(this.geolocationDataProvider);
                this.geolocationMetricLogger = new GeolocationMetricLogger_1.GeolocationMetricLogger();
            }
        };
        return CurrentLocationSuggester;
    }());
universalTypeahead_1.registerPlugin(new CurrentLocationSuggester());
});



/// <amd-module name="typeahead/features/FlightIconEnforcer" />
require(["require","exports","typeahead/core/plugins/ExecutionHelper","universalTypeahead"], function(require,exports,ExecutionHelper,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            lobs: ["PACKAGES"]
        }];
    var FlightIconEnforcer = (function () {
        function FlightIconEnforcer() {
        }
        FlightIconEnforcer.prototype.modifySuggestions = function (suggestions, context, options) {
            var _this = this;
            var deferred = $.Deferred();
            if (suggestions && suggestions.length > 0) {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (shouldExecute) {
                    if (shouldExecute && (_this.isFlightCar() || _this.isPackageOrigin())) {
                        suggestions.forEach(function (sugg) {
                            sugg.icon = FlightIconEnforcer.FLIGHTS_ICON;
                        });
                    }
                }).always(function () {
                    deferred.resolve(suggestions);
                });
            }
            else {
                deferred.resolve(suggestions);
            }
            return deferred.promise();
        };
        FlightIconEnforcer.prototype.isFlightCar = function () {
            return $("input[value=flight-car]:visible").is(":checked") ||
                FlightIconEnforcer.FLIGHT_CAR_TYPES.indexOf($("button.on:visible").data("lob")) > -1; // launch pages
        };
        FlightIconEnforcer.prototype.isPackageOrigin = function () {
            return $("input:focus").data("gcw-field-type") === FlightIconEnforcer.ORIGIN_FIELD_TYPE;
        };
        FlightIconEnforcer.FLIGHTS_ICON = "flights";
        FlightIconEnforcer.ORIGIN_FIELD_TYPE = "origin";
        FlightIconEnforcer.FLIGHT_CAR_TYPES = [
            "packageFlightCar",
            "flightCar",
            "carFlight",
        ];
        return FlightIconEnforcer;
    }());
universalTypeahead_1.registerPlugin(new FlightIconEnforcer());
});



/// <amd-module name="typeahead/features/HierarchicalSuggestion" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","typeahead/core/plugins/ExecutionHelper","typeahead/core/TypeaheadUtils","typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils","universalTypeahead"], function(require,exports,$,ExecutionHelper,TypeaheadUtils_1,SuggestServiceQueryParamsUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            lobs: ["HOTELS", "FLIGHTS", "RAILS", "PACKAGES"]
        }];
    var featureFlag = "ta_hierarchy";
    var HotelHierarchyPlugin = (function () {
        function HotelHierarchyPlugin() {
        }
        HotelHierarchyPlugin.prototype.modifyParameters = function (params, context, options) {
            if (HotelHierarchyPlugin.inapplicableClients.lastIndexOf(context.clientId) < 0 &&
                TypeaheadUtils_1.TypeaheadUtils.getPackageType() !== TypeaheadUtils_1.PackageType.FlightCar) {
                return SuggestServiceQueryParamsUtils_1.addFeatureFlag(featureFlag, configuration, params, context, options);
            }
            else {
                var deferred = $.Deferred();
                return deferred.resolve(params).promise();
            }
        };
        HotelHierarchyPlugin.prototype.modifySuggestions = function (suggestions, context, options) {
            var deferred = $.Deferred();
            if (suggestions && suggestions.length > 0) {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (shouldExecute) {
                    suggestions.forEach(function (sugg) {
                        sugg.showAsHierarchy = false;
                        if (shouldExecute) {
                            var obj = sugg.relation;
                            if (+sugg.index > 0 && sugg.hierarchyInfo) {
                                obj = sugg.hierarchyInfo.relation;
                            }
                            if (obj && (obj[0] === "child" || obj[0] === "nearby")) {
                                // Set the flag to show as hierarchy option
                                sugg.showAsHierarchy = true;
                            }
                        }
                    });
                })
                    .always(function () {
                    deferred.resolve(suggestions);
                });
            }
            else {
                deferred.resolve(suggestions);
            }
            return deferred.promise();
        };
        // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
        // For details of that investigation, see:
        // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
        //
        // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
        // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
        HotelHierarchyPlugin.inapplicableClients = ["Flights.Search"];
        return HotelHierarchyPlugin;
    }());
universalTypeahead_1.registerPlugin(new HotelHierarchyPlugin());
});



/// <amd-module name="typeahead/features/HotelSuggestionUrlModifier" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","typeahead/core/message/SubmitClickedMessage","typeahead/core/message/TypeaheadMessage","typeahead/core/plugins/ExecutionHelper","universalTypeahead"], function(require,exports,$,SubmitClickedMessage_1,TypeaheadMessage_1,ExecutionHelper,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [
        {
            clients: ["Homepage", "HotelsLandingPage", "AWSHomepage"],
            tabs: ["hotel"]
        },
    ];
    var HotelSuggestionUrlModifier = (function () {
        function HotelSuggestionUrlModifier() {
        }
        HotelSuggestionUrlModifier.prototype.handlePageLoad = function (options, context) {
            var _this = this;
            var deferred = $.Deferred();
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SubmitClickedMessage_1.SubmitClickedMessage.getTopic(), function (topic, message) {
                context.tab = _this.getMercuryWzdTab();
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (result) {
                    if (result) {
                        // Grab the tab input field for the relevant tab
                        var tabInputField = $("[data-gcw-storeable-name=gcw-destination]:visible");
                        var selectedHotelIdElemId = "#" + $(tabInputField).attr("data-hotel_id_element");
                        var relevantCityNameElemId = "#" + $(tabInputField).attr("data-city_element");
                        var selectedHotelIdElem = $(selectedHotelIdElemId);
                        var selectedHotelId = $(selectedHotelIdElem).val();
                        var relevantCityNameElem = $(relevantCityNameElemId);
                        var relevantCityName = $(relevantCityNameElem).val();
                        if (selectedHotelId && relevantCityName) {
                            // Add the name attribute to the city input and
                            // remove the name attribute from destination input
                            $(relevantCityNameElem).attr("name", "destination");
                            $(tabInputField).removeAttr("name");
                        }
                        else {
                            // Add the name attribute to the destination input and
                            // remove the name attribute from city input
                            $(tabInputField).attr("name", "destination");
                            $(relevantCityNameElem).removeAttr("name");
                        }
                    }
                })
                    .always(function () {
                    deferred.resolve();
                });
            });
            return deferred.promise();
        };
        HotelSuggestionUrlModifier.prototype.getMercuryWzdTab = function () {
            return $("li.tab:visible").children("button.on").data("lob");
        };
        return HotelSuggestionUrlModifier;
    }());
universalTypeahead_1.registerPlugin(new HotelSuggestionUrlModifier());
});



/// <amd-module name="typeahead/features/IncludeHotelsNearRegion" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="typeahead/core/loc" name="loc"/>
require(["require","exports","jquery","typeahead/core/loc","typeahead/core/plugins/ExecutionHelper","typeahead/core/StripingConfiguration","typeahead/core/TypeaheadUtils","typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils","universalTypeahead"], function(require,exports,$,loc,ExecutionHelper,StripingConfiguration,TypeaheadUtils_1,SuggestServiceQueryParamsUtils_1,universalTypeahead_1){
    /// <reference path="../../typings/typeahead/loc.d.ts" />
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            experiment: {
                id: 13081,
                name: "OneSearchTypeahead"
            },
            lobs: ["HOTELS"]
        }];
    var featureFlag = "onesearchta";
    var hotelNameHotelBits = 128; // (hotelNameHotelBits >>> 0).toString(2) = "10000000"
    var IncludeHotelsNearRegion = (function () {
        function IncludeHotelsNearRegion() {
            this.applicableClientIds = ["Hotels.Search"];
            this.applicableTextInputElementIds = ["inpSearchNear"];
        }
        // Check for input element ID as well (Only for change search)
        IncludeHotelsNearRegion.prototype.modifyParameters = function (params, context, options) {
            var def = $.Deferred();
            /* Verify that the experiment is only for HSRP and for Change search input TA*/
            if (this.applicableClientIds.indexOf(TypeaheadUtils_1.TypeaheadUtils.getClientId()) > -1
                && this.applicableTextInputElementIds.indexOf(options.inputElementId) > -1) {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (result) {
                    if (result) {
                        params.rid = options.searchRegionId;
                        /* tslint:disable-next-line: no-bitwise */
                        params.mask |= hotelNameHotelBits;
                        // make the call to add parameters
                        SuggestServiceQueryParamsUtils_1.addFeatureFlag(featureFlag, configuration, params, context);
                    }
                })
                    .always(function () {
                    def.resolve(params);
                });
            }
            else {
                def.resolve(params);
            }
            return def.promise();
        };
        IncludeHotelsNearRegion.prototype.handleContentToShow = function ($dropDownElement, $inputElement, context) {
            var _this = this;
            var deferred = $.Deferred();
            /* Verify that the experiment is only for HSRP and for Change search input TA*/
            if (this.applicableClientIds.indexOf(TypeaheadUtils_1.TypeaheadUtils.getClientId()) > -1
                && this.applicableTextInputElementIds.indexOf($inputElement.attr("id")) > -1) {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (shouldExecute) {
                    if (shouldExecute) {
                        _this.showHotelNameSearchSupportedInfo($dropDownElement);
                    }
                })
                    .always(function () {
                    deferred.resolve(undefined);
                });
            }
            else {
                deferred.resolve(undefined);
            }
            return deferred.promise();
        };
        IncludeHotelsNearRegion.prototype.getExperiments = function () {
            return StripingConfiguration.getExperiments(configuration);
        };
        IncludeHotelsNearRegion.prototype.showHotelNameSearchSupportedInfo = function ($dropDownElement) {
            var contentLiStyle = "padding-top:0.92307692em;" +
                "padding-right:0.92307692em;" +
                "padding-bottom:0;" +
                "padding-left:0.92307692em;" +
                "margin-top:0.92307692em;" +
                "border-top-width:1px;" +
                "border-top-style:solid;" +
                "border-top-color:#DDD;";
            var contentDivStyle = "display:block;" +
                "padding-top:0;" +
                "padding-right:0.46153846em;" +
                "padding-bottom:0;" +
                "padding-left:0.46153846em;";
            var contentIconSpanStyle = "padding-right:0.76923077em;";
            var contentTextSpanStyle = "font-size:0.9em";
            var labelString = loc.taOnesearchPromptText ?
                loc.taOnesearchPromptText :
                "You can also search by hotel name or attraction";
            // Add new child node
            var infoLabelHTML = $.parseHTML("" +
                "<li role='presentation' class='' " +
                "style=" + contentLiStyle + ">" +
                "<div id='oneSearchTypeaheadPromptInner' style=" + contentDivStyle + ">" +
                "<span class='icon icon-info' aria-hidden='true' style=" + contentIconSpanStyle + "></span>" +
                "<span class='ta-onesearch-prompt-text' style=" + contentTextSpanStyle + ">" + labelString + "</span>" +
                "</div>" +
                "</li>");
            $dropDownElement.find("ul").append(infoLabelHTML);
            // $(infoLabelHTML).after($dropDownElement.find("ul"));
        };
        return IncludeHotelsNearRegion;
    }());
universalTypeahead_1.registerPlugin(new IncludeHotelsNearRegion());
});



/// <amd-module name="typeahead/features/NearbyAirportParamModifier" />
require(["require","exports","typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils","universalTypeahead"], function(require,exports,SuggestServiceQueryParamsUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            lobs: ["FLIGHTS"]
        }];
    // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
    // For details of that investigation, see:
    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
    //
    // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
    // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
    var inapplicableClients = ["Flights.Search"];
    var featureFlag = "nearby_airport";
    var NearbyAirportParamModifier = (function () {
        function NearbyAirportParamModifier() {
        }
        NearbyAirportParamModifier.prototype.modifyParameters = function (params, context, options) {
            if (inapplicableClients.lastIndexOf(context.clientId) < 0) {
                return SuggestServiceQueryParamsUtils_1.addFeatureFlag(featureFlag, configuration, params, context, options);
            }
            else {
                var deferred = $.Deferred();
                return deferred.resolve(params).promise();
            }
        };
        return NearbyAirportParamModifier;
    }());
universalTypeahead_1.registerPlugin(new NearbyAirportParamModifier());
});



/// <amd-module name="typeahead/features/OnePlusRecentHistoryParamModifier" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","typeahead/core/plugins/ExecutionHelper","universalTypeahead"], function(require,exports,$,ExecutionHelper,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            tabs: ["hotel"]
        }];
    var USER_HISTORY = "USERHISTORY";
    var OnePlusRecentHistoryParamModifier = (function () {
        function OnePlusRecentHistoryParamModifier() {
        }
        OnePlusRecentHistoryParamModifier.prototype.modifyParameters = function (params, context, options) {
            var deferred = $.Deferred();
            if (typeof params !== "undefined") {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (shouldExecute) {
                    if (shouldExecute) {
                        params.categories = USER_HISTORY;
                    }
                })
                    .always(function () {
                    deferred.resolve(params);
                });
            }
            else {
                deferred.resolve(params);
            }
            return deferred.promise();
        };
        return OnePlusRecentHistoryParamModifier;
    }());
universalTypeahead_1.registerPlugin(new OnePlusRecentHistoryParamModifier());
});



require(["require","exports","typeahead/client/ClientHandlerRegistry","typeahead/core/logging/TypeaheadErrorLogger","typeahead/core/message/SubmitClickedMessage","typeahead/core/message/SuggestionShownMessage","typeahead/core/message/TypeaheadMessage","typeahead/core/TypeaheadUtils","universalTypeahead"], function(require,exports,ClientHandlerRegistry_1,TypeaheadErrorLogger_1,SubmitClickedMessage_1,SuggestionShownMessage_1,TypeaheadMessage_1,TypeaheadUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var PageloadMetricsLogger = (function () {
        function PageloadMetricsLogger() {
            this.isMetricsLogged = false;
        }
        PageloadMetricsLogger.prototype.handlePageLoad = function (options, context) {
            if (TypeaheadUtils_1.TypeaheadUtils.isStorefrontClient()) {
                this.evaluateMetrics();
            }
            var deferred = $.Deferred();
            return deferred.resolve().promise();
        };
        PageloadMetricsLogger.prototype.evaluateMetrics = function () {
            var _this = this;
            var pageLoadHandlerExecutionTimestamp = Date.now();
            var metrics = {};
            metrics.name = "UtaPageloadMetrics";
            metrics.utaBundle = this.getUtaBundleUrl();
            metrics.numberOfInputInteractions = 0;
            metrics.durationInMillisFromStorefrontScriptStartToUtaScriptStart =
                (!isNaN(window.storefrontScriptLoadingStartedTimestamp) &&
                    !isNaN(window.utaScriptLoadingStartedTimestamp)) ?
                    (window.utaScriptLoadingStartedTimestamp - window.storefrontScriptLoadingStartedTimestamp) : undefined;
            metrics.durationInMillisFromUtaScriptStartToUtaReady =
                (!isNaN(window.utaModuleReadyTimeStamp) && !isNaN(window.utaScriptLoadingStartedTimestamp)) ?
                    (window.utaModuleReadyTimeStamp - window.utaScriptLoadingStartedTimestamp) : undefined;
            metrics.durationInMillisFromUtaReadyToUtaPageLoadHandler =
                (!isNaN(pageLoadHandlerExecutionTimestamp) && !isNaN(window.utaModuleReadyTimeStamp)) ?
                    (pageLoadHandlerExecutionTimestamp - window.utaModuleReadyTimeStamp) : undefined;
            $("body").one("focus", "[data-provide=utypeahead]", function () {
                var focusTimestamp = Date.now();
                metrics.durationInMillisFromStorefrontScriptStartToInputFocus =
                    !isNaN(window.storefrontScriptLoadingStartedTimestamp) ?
                        focusTimestamp - window.storefrontScriptLoadingStartedTimestamp : undefined;
            });
            $("body").on("input.typeahead_metrics", "[data-provide=utypeahead]", function () {
                metrics.numberOfInputInteractions++;
            });
            var tokenSuggestionShown = TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionShownMessage_1.SuggestionShownMessage.getTopic(), function (topic, message) {
                metrics.domElementId = message.getDomElementId();
                metrics.suggestionsRenderTimeInMillis = message.getRenderTime();
                TypeaheadMessage_1.TypeaheadMessage.unsubscribe(topic, tokenSuggestionShown);
                _this.logMetrics(metrics);
            });
            var tokenSubmitClicked = TypeaheadMessage_1.TypeaheadMessage.subscribe(SubmitClickedMessage_1.SubmitClickedMessage.getTopic(), function (topic, message) {
                TypeaheadMessage_1.TypeaheadMessage.unsubscribe(topic, tokenSubmitClicked);
                _this.logMetrics(metrics);
            });
        };
        PageloadMetricsLogger.prototype.logMetrics = function (metrics) {
            if (!this.isMetricsLogged) {
                metrics.tab = ClientHandlerRegistry_1.ClientHandlerRegistry.getTab();
                TypeaheadErrorLogger_1["default"].log(undefined, undefined, undefined, metrics);
                this.isMetricsLogged = true;
                $("body").off("input.typeahead_metrics");
            }
        };
        PageloadMetricsLogger.prototype.getUtaBundleUrl = function () {
            var dummyError = new Error();
            if (dummyError.stack) {
                var match = (/(http.+universal_typeahead_bundle.*.js)/).exec(dummyError.stack);
                return match && match[1] ? match[1] : undefined;
            }
            return undefined;
        };
        return PageloadMetricsLogger;
    }());
universalTypeahead_1.registerPlugin(new PageloadMetricsLogger());
});



/// <amd-module name="typeahead/features/PostalCodeRequestParamModifier" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","typeahead/core/plugins/ExecutionHelper","universalTypeahead"], function(require,exports,$,ExecutionHelper,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            lobs: ["HOTELS", "CARS"]
        }];
    var featureFlag = "postal_code";
    var postalCodeHotelBits = 32; // (postalCodeHotelBits >>> 0).toString(2) = 100000
    var PostalCodeRequestParamModifier = (function () {
        function PostalCodeRequestParamModifier() {
        }
        PostalCodeRequestParamModifier.prototype.modifyParameters = function (params, context, options) {
            var deferred = $.Deferred();
            if (typeof params !== "undefined") {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (shouldExecute) {
                    params.features = params.features && params.features.length ? params.features || [] : [];
                    if (shouldExecute && params.features.indexOf(featureFlag) < 0) {
                        params.features.push(featureFlag);
                    }
                    if (shouldExecute && context.lob === "HOTELS") {
                        /* tslint:disable-next-line: no-bitwise */
                        params.mask |= postalCodeHotelBits;
                    }
                })
                    .always(function () {
                    deferred.resolve(params);
                });
            }
            else {
                deferred.resolve(params);
            }
            return deferred.promise();
        };
        return PostalCodeRequestParamModifier;
    }());
universalTypeahead_1.registerPlugin(new PostalCodeRequestParamModifier());
});



/// <amd-module name="typeahead/features/ScrollInputToTop" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","typeahead/core/message/ElementFocusedMessage","typeahead/core/message/InputValueEditedMessage","typeahead/core/message/TypeaheadMessage","typeahead/core/plugins/ExecutionHelper","typeahead/core/StripingConfiguration","typeahead/core/TypeaheadUtils","universalTypeahead"], function(require,exports,$,ElementFocusedMessage_1,InputValueEditedMessage_1,TypeaheadMessage_1,ExecutionHelper,StripingConfiguration,TypeaheadUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [
        {
            clients: ["Homepage", "AWSHomepage", "FlightsLandingPage"],
            experiment: {
                id: 12703,
                name: "CWTA_AnchorOnTop",
                value: 1
            },
            tabs: ["flight"]
        },
        {
            clients: ["Homepage", "AWSHomepage", "HotelsLandingPage"],
            experiment: {
                id: 14159,
                name: "AnchorOnTopHotels",
                value: 1
            },
            tabs: ["hotel"]
        },
        {
            clients: ["Homepage", "AWSHomepage", "CarsLandingPage"],
            experiment: {
                id: 14160,
                name: "AnchorOnTopCars",
                value: 1
            },
            tabs: ["car"]
        },
        {
            clients: ["Homepage", "AWSHomepage", "PackageLandingPage", "FlightsLandingPage", "HotelsLandingPage",
                "CarsLandingPage"],
            experiment: {
                id: 14161,
                name: "AnchorOnTopPackages",
                value: 1
            },
            tabs: ["package", "packageFlightHotel", "packageFlightHotelCar", "packageFlightCar", "packageHotelCar",
                "flightHotel", "flightHotelCar", "flightCar", "hotelCar", "carHotel", "carHotelFlight", "carFlight"]
        },
    ];
    var ScrollInputToTop = (function () {
        function ScrollInputToTop() {
            var _this = this;
            this.isScrollTopOn = false;
            TypeaheadMessage_1.TypeaheadMessage.subscribe(ElementFocusedMessage_1.ElementFocusedMessage.getTopic(), function (topic, message) {
                _this.isScrollTopOn = false;
                if (TypeaheadUtils_1.TypeaheadUtils.isWithinMobileBreakpoint()) {
                    ExecutionHelper.shouldExecute(message.getContext(), configuration).done(function (shouldExecute) {
                        if (shouldExecute) {
                            _this.scrollTop($("#" + message.getDomElementId()));
                            _this.isScrollTopOn = true;
                        }
                    });
                }
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(InputValueEditedMessage_1.InputValueEditedMessage.getTopic(), function (topic, message) {
                if (_this.isScrollTopOn) {
                    _this.scrollTop($("#" + message.getDomElementId()));
                }
            });
        }
        ScrollInputToTop.prototype.getExperiments = function () {
            return StripingConfiguration.getExperiments(configuration);
        };
        ScrollInputToTop.prototype.scrollTop = function ($input) {
            var page = $("body");
            var stopScrollEvents = "wheel touchmove";
            var zoom = document.documentElement.clientWidth / window.innerWidth;
            if (zoom > 1) {
                // known web issue: inconsistent offsets while zoomed
                return;
            }
            // Default
            var destination = $input.offset().top - 13;
            var anchorElement = $input.siblings(".label");
            if (anchorElement.length > 0) {
                // As per Mingle #2796 - "Show field label with 13px padding from top"
                destination = anchorElement.offset().top - 7; // 6px to accommodate label text top padding
            }
            var currentOffset = page.scrollTop();
            // if it's close enough, don't bother scrolling
            if (Math.abs(currentOffset - destination) < 6.5) {
                return;
            }
            // stop animation if user tries to move page manually
            page.on(stopScrollEvents, function () {
                page.off(stopScrollEvents);
                page.stop();
            });
            page.animate({
                scrollTop: destination
            }, 300);
        };
        return ScrollInputToTop;
    }());
universalTypeahead_1.registerPlugin(new ScrollInputToTop());
});



/// <amd-module name="typeahead/features/SelectInputElement" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","universalTypeahead"], function(require,exports,$,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = {};
    // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
    // For details of that investigation, see:
    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
    //
    // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
    // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
    var inapplicableClients = ["Flights.Search"];
    var SelectInputElementOnFocus = (function () {
        function SelectInputElementOnFocus() {
        }
        SelectInputElementOnFocus.prototype.handleInputElementFocus = function ($inputElement, context) {
            if (inapplicableClients.lastIndexOf(context.clientId) < 0 && $($inputElement).val()) {
                var selectAllText_1 = function () {
                    var htmlInputEl = $($inputElement)[0];
                    if (htmlInputEl) {
                        htmlInputEl.setSelectionRange(0, 9999);
                    }
                };
                setTimeout(function () {
                    $($inputElement).one("mouseup", function () {
                        selectAllText_1();
                    });
                    selectAllText_1();
                }, 0);
            }
            return $.Deferred().resolve().promise();
        };
        return SelectInputElementOnFocus;
    }());
universalTypeahead_1.registerPlugin(new SelectInputElementOnFocus());
});



require(["require","exports","typeahead/core/EmptyQueryDataProvider","typeahead/core/plugins/ExecutionHelper","typeahead/core/StripingConfiguration","typeahead/core/Suggestion","typeahead/core/SuggestionsAggregator","universalTypeahead"], function(require,exports,EmptyQueryDataProvider_1,ExecutionHelper,StripingConfiguration,Suggestion_1,SuggestionsAggregator_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [
        {
            clients: ["Homepage", "CarsLandingPage"],
            experiment: {
                id: 14235,
                name: "SuggestRegionInCars",
                value: 1
            },
            tabs: ["car"]
        },
        {
            clients: ["Homepage"],
            experiment: {
                id: 14236,
                name: "SuggestRegionInLX",
                value: 1
            },
            tabs: ["activity"]
        },
        {
            clients: ["LXLandingPage"],
            experiment: {
                id: 14236,
                name: "SuggestRegionInLX",
                value: 1
            }
        },
    ];
    var ShowFlightBookingSuggestion = (function () {
        function ShowFlightBookingSuggestion() {
        }
        ShowFlightBookingSuggestion.prototype.getId = function () {
            return SuggestionsAggregator_1.SuggesterId.FlightBookingSuggester;
        };
        ShowFlightBookingSuggestion.prototype.handlePageLoad = function (options, context) {
            var _this = this;
            var deferred = $.Deferred();
            var opts = $.extend(true, {}, { options: options, context: context });
            new EmptyQueryDataProvider_1.EmptyQueryDataProvider().fetchData(opts).then(function (response) {
                _this.results = _this.filterFlightBookingResults(response.results);
                deferred.resolve();
            });
            return deferred.promise();
        };
        ShowFlightBookingSuggestion.prototype.suggestOnFocus = function (options, context) {
            return this.suggest(options, context);
        };
        ShowFlightBookingSuggestion.prototype.suggest = function (options, context) {
            var _this = this;
            var deferred = $.Deferred();
            ExecutionHelper.shouldExecute(context, configuration)
                .done(function (shouldExecute) {
                if (shouldExecute) {
                    deferred.resolve({
                        id: _this.getId(),
                        results: _this.getApplicableFlightBookingResult(_this.getLob(context))
                    });
                }
            }).always(function () {
                deferred.resolve({ id: _this.getId(), results: [] });
            });
            return deferred.promise();
        };
        ShowFlightBookingSuggestion.prototype.getExperiments = function () {
            return StripingConfiguration.getExperiments(configuration);
        };
        ShowFlightBookingSuggestion.prototype.getApplicableFlightBookingResult = function (lob) {
            var lobFilter = function (result) {
                return result.targetHtmlElements && result.targetHtmlElements.indexOf(lob) > -1;
            };
            return this.results.filter(lobFilter);
        };
        ShowFlightBookingSuggestion.prototype.filterFlightBookingResults = function (results) {
            var flightBookingFilter = function (result) {
                return result.category === Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.FLIGHTSBOOKING];
            };
            if (results && results.length) {
                return results.filter(flightBookingFilter);
            }
            else {
                return [];
            }
        };
        ShowFlightBookingSuggestion.prototype.getLob = function (context) {
            return context.tab ? context.tab : (context.clientId === "LXLandingPage") ? "activity" : "";
        };
        return ShowFlightBookingSuggestion;
    }());
universalTypeahead_1.registerPlugin(new ShowFlightBookingSuggestion());
});



/// <amd-module name="typeahead/features/ShowRecentHistorySuggestion" />
/// <amd-dependency path="jquery" name="$"/>
require(["require","exports","jquery","typeahead/core/EmptyQueryDataProvider","typeahead/core/plugins/ExecutionHelper","typeahead/core/StripingConfiguration","typeahead/core/Suggestion","typeahead/core/SuggestionsAggregator","universalTypeahead"], function(require,exports,$,EmptyQueryDataProvider_1,ExecutionHelper,StripingConfiguration,Suggestion_1,SuggestionsAggregator_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [
        {
            tabs: ["hotel"]
        },
        {
            clients: ["Hotels.Search"]
        },
        {
            clients: ["Homepage"],
            experiment: {
                id: 14180,
                name: "RecentHistoryLX",
                value: 1
            },
            tabs: ["activity"]
        },
        {
            clients: ["LXLandingPage"],
            experiment: {
                id: 14180,
                name: "RecentHistoryLX",
                value: 1
            }
        },
    ];
    var excludedPages = [
        {
            clientId: "Homepage",
            locale: "ja_JP",
            siteid: "28"
        },
        {
            clientId: "HotelsLandingPage",
            locale: "ja_JP",
            siteid: "28"
        },
    ];
    var ShowRecentHistorySuggestion = (function () {
        function ShowRecentHistorySuggestion() {
        }
        ShowRecentHistorySuggestion.prototype.handlePageLoad = function (options, context) {
            var _this = this;
            var opts = $.extend(true, {}, { options: options, context: context });
            var deferred = $.Deferred();
            new EmptyQueryDataProvider_1.EmptyQueryDataProvider().fetchData(opts).then(function (response) {
                _this.results = _this.filterRecentHistoryResults(response.results);
                deferred.resolve();
            });
            return deferred.promise();
        };
        ShowRecentHistorySuggestion.prototype.suggest = function (options, context) {
            var _this = this;
            var deferred = $.Deferred();
            ExecutionHelper.shouldExecute(context, configuration)
                .done(function (shouldExecute) {
                if (shouldExecute && !_this.isExcluded(context)) {
                    deferred.resolve({ id: _this.getId(), results: _this.results });
                }
            })
                .always(function () {
                deferred.resolve({ id: _this.getId(), results: [] });
            });
            return deferred.promise();
        };
        ShowRecentHistorySuggestion.prototype.suggestOnFocus = function (options, context) {
            return this.suggest(options, context);
        };
        ShowRecentHistorySuggestion.prototype.getId = function () {
            return SuggestionsAggregator_1.SuggesterId.RecentHistorySuggester;
        };
        ShowRecentHistorySuggestion.prototype.getExperiments = function () {
            return StripingConfiguration.getExperiments(configuration);
        };
        ShowRecentHistorySuggestion.prototype.isExcluded = function (context) {
            for (var _i = 0, excludedPages_1 = excludedPages; _i < excludedPages_1.length; _i++) {
                var page = excludedPages_1[_i];
                if (page.clientId === context.clientId
                    && page.locale === context.locale
                    && page.siteid === context.siteid + "") {
                    return true;
                }
            }
            return false;
        };
        ShowRecentHistorySuggestion.prototype.filterRecentHistoryResults = function (results) {
            var recentHistoryFilter = function (result) {
                return result.category === Suggestion_1.SuggestionCategory[Suggestion_1.SuggestionCategory.USERHISTORY];
            };
            if (results && results.length) {
                return results.filter(recentHistoryFilter);
            }
            else {
                return [];
            }
        };
        return ShowRecentHistorySuggestion;
    }());
universalTypeahead_1.registerPlugin(new ShowRecentHistorySuggestion());
});



/// <amd-module name="typeahead/features/SuggestionIconSuppressor" />
/// <amd-dependency path="jquery" name="$"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
require(["require","exports","jquery","typeahead/core/SuggestionModifier","universalTypeahead"], function(require,exports,$,SuggestionModifier_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var SuggestionIconSuppressor = (function (_super) {
        __extends(SuggestionIconSuppressor, _super);
        function SuggestionIconSuppressor() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.configuration = [{
                    lobs: ["FLIGHTS"]
                }];
            _this.featureName = "SuppressIcon";
            return _this;
            // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
            // For details of that investigation, see:
            // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
            //
            // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
            // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
        }
        SuggestionIconSuppressor.prototype.modify = function (suggestions, context) {
            suggestions.forEach(function (sugg) {
                sugg.icon = "none";
            });
        };
        SuggestionIconSuppressor.prototype.precondition = function (suggestions, context) {
            return _super.prototype.precondition.call(this, suggestions, context) &&
                SuggestionIconSuppressor.inapplicableClients.lastIndexOf(context.clientId) < 0;
        };
        SuggestionIconSuppressor.inapplicableClients = ["Flights.Search"];
        return SuggestionIconSuppressor;
    }(SuggestionModifier_1.SuggestionModifier));
universalTypeahead_1.registerPlugin(new SuggestionIconSuppressor());
});



/// <amd-module name="typeahead/features/UitkDropDownGeometryReplicatorForFlightSearchResults" />
require(["require","exports","jquery","typeahead/core/plugins/ExecutionHelper","universalTypeahead"], function(require,exports,$,ExecutionHelper,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{}];
    var UitkDropDownGeometryReplicatorForFlightSearchResults = (function () {
        function UitkDropDownGeometryReplicatorForFlightSearchResults() {
            this.showHandlers = {};
        }
        UitkDropDownGeometryReplicatorForFlightSearchResults.optimizeDropDownGeometry = function ($dropDownElement, $inputElement) {
            var availableMediaWidthPx = 4 + document.body.clientWidth - UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz * 2;
            var maxDropDownWidthPx = 4 +
                Math.min(UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadWidthPx, availableMediaWidthPx);
            var minDropDownWidthPx = 4 +
                Math.min(UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadMinWidthPx, availableMediaWidthPx);
            var newWidth = Math.min(maxDropDownWidthPx, availableMediaWidthPx);
            var leftOffset = $inputElement.offset().left - 2;
            if (leftOffset + newWidth > availableMediaWidthPx) {
                leftOffset = UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz +
                    availableMediaWidthPx - newWidth - 2;
                // 2px: The border of the autocomplete-dropdown is 2px narrower than that of the input
            }
            leftOffset = leftOffset - $inputElement.get(0).getBoundingClientRect().left;
            $dropDownElement.css({
                "left": leftOffset + "px",
                "max-width": maxDropDownWidthPx + "px",
                "min-width": minDropDownWidthPx + "px",
                "width": newWidth + "px"
            });
        };
        UitkDropDownGeometryReplicatorForFlightSearchResults.prototype.handleDropDownHide = function ($dropDownElement, $inputElement, context) {
            var inputElementId = $inputElement.attr("id");
            var showHandler = inputElementId ? this.showHandlers[inputElementId] : undefined;
            if (showHandler) {
                $(window).off(UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes, null, showHandler);
                delete this.showHandlers[inputElementId];
            }
            var deferred = $.Deferred();
            return deferred.resolve().promise();
        };
        UitkDropDownGeometryReplicatorForFlightSearchResults.prototype.handleDropDownShow = function ($dropDownElement, $inputElement, context) {
            var _this = this;
            var def = $.Deferred();
            if (UitkDropDownGeometryReplicatorForFlightSearchResults.applicableClients.indexOf(context.clientId) >= 0) {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (result) {
                    if (result) {
                        _this.doHandleDropDownShow($dropDownElement, $inputElement);
                    }
                })
                    .always(function () {
                    def.resolve(undefined);
                });
            }
            else {
                def.resolve(undefined);
            }
            return def.promise();
        };
        UitkDropDownGeometryReplicatorForFlightSearchResults.prototype.doHandleDropDownShow = function ($dropDownElement, $inputElement) {
            var optimizeDropDownGeometry = function (event) {
                UitkDropDownGeometryReplicatorForFlightSearchResults.optimizeDropDownGeometry($dropDownElement, $inputElement);
            };
            optimizeDropDownGeometry(null);
            $(window).on(UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes, null, null, optimizeDropDownGeometry);
            var inputElementId = $inputElement.attr("id");
            if (inputElementId) {
                this.showHandlers[$inputElement.attr("id")] = optimizeDropDownGeometry;
            }
        };
        UitkDropDownGeometryReplicatorForFlightSearchResults.applicableClients = ["Flights.Search"];
        // @baseSpacingHorz as defined in uitoolkit; see uitoolkit/.../mixins.less (http://go/iuo39gal)
        UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz = 12;
        UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadWidthPx = 390;
        UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadMinWidthPx = 282;
        UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes = "orientationchange resize";
        return UitkDropDownGeometryReplicatorForFlightSearchResults;
    }());
universalTypeahead_1.registerPlugin(new UitkDropDownGeometryReplicatorForFlightSearchResults());
});



/// <amd-module name="typeahead/features/UitkDropDownGeometryReplicatorForMercury" />
require(["require","exports","jquery","typeahead/core/plugins/ExecutionHelper","universalTypeahead"], function(require,exports,$,ExecutionHelper,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{}];
    var UitkDropDownGeometryReplicatorForMercury = (function () {
        function UitkDropDownGeometryReplicatorForMercury() {
            this.showHandlers = {};
        }
        UitkDropDownGeometryReplicatorForMercury.optimizeDropDownGeometry = function ($dropDownElement, $inputElement) {
            var availableMediaWidthPx = 4 + document.body.clientWidth - UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz * 2;
            var minDropDownWidthPx = 4 + Math.min(UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadMinWidthPx, availableMediaWidthPx);
            var maxDropDownWidthPx = 4 + Math.min(UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadWidthPx, availableMediaWidthPx);
            var newWidth = Math.min(maxDropDownWidthPx, availableMediaWidthPx);
            var leftOffset = $inputElement.offset().left - 2;
            if (leftOffset + newWidth > availableMediaWidthPx) {
                leftOffset = UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz
                    + availableMediaWidthPx - newWidth - 2;
                // 2px: The border of the autocomplete-dropdown is 2px narrower than that of the input
            }
            leftOffset = leftOffset - $inputElement.get(0).getBoundingClientRect().left;
            UitkDropDownGeometryReplicatorForMercury.applyDropDownGeometry($dropDownElement, leftOffset, maxDropDownWidthPx, minDropDownWidthPx, newWidth);
        };
        UitkDropDownGeometryReplicatorForMercury.applyDropDownGeometry = function ($dropDownElement, leftOffset, maxDropDownWidthPx, minDropDownWidthPx, newWidth) {
            $dropDownElement.css({
                "left": leftOffset + "px",
                "max-width": maxDropDownWidthPx + "px",
                "min-width": minDropDownWidthPx + "px",
                "width": newWidth + "px"
            });
        };
        UitkDropDownGeometryReplicatorForMercury.prototype.handleDropDownShow = function ($dropDownElement, $inputElement, context) {
            var _this = this;
            var def = $.Deferred();
            if (UitkDropDownGeometryReplicatorForMercury.applicableClients.indexOf(context.clientId) >= 0) {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done(function (result) {
                    if (result) {
                        _this.doHandleDropDownShow($dropDownElement, $inputElement);
                    }
                    def.resolve(undefined);
                })
                    .fail(function () {
                    def.resolve(undefined);
                });
            }
            else {
                def.resolve(undefined);
            }
            return def.promise();
        };
        UitkDropDownGeometryReplicatorForMercury.prototype.doHandleDropDownShow = function ($dropDownElement, $inputElement) {
            var optimizeDropDownGeometry = function (event) {
                UitkDropDownGeometryReplicatorForMercury.optimizeDropDownGeometry($dropDownElement, $inputElement);
            };
            optimizeDropDownGeometry(null);
            $(window).on(UitkDropDownGeometryReplicatorForMercury.resizeEventTypes, null, null, optimizeDropDownGeometry);
            var inputElementId = $inputElement.attr("id");
            if (inputElementId) {
                this.showHandlers[$inputElement.attr("id")] = optimizeDropDownGeometry;
            }
        };
        UitkDropDownGeometryReplicatorForMercury.applicableClients = [
            "Homepage",
            "AWSHomepage",
            "LXLandingPage",
            "CarsLandingPage",
            "FlightsLandingPage",
            "HotelsLandingPage",
            "PackageLandingPage",
            "RailsLandingPage"
        ];
        // @baseSpacingHorz as defined in uitoolkit; see uitoolkit/.../mixins.less (http://go/iuo39gal)
        UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz = 12;
        UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadWidthPx = 600;
        UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadMinWidthPx = 282;
        UitkDropDownGeometryReplicatorForMercury.resizeEventTypes = "orientationchange resize";
        return UitkDropDownGeometryReplicatorForMercury;
    }());
universalTypeahead_1.registerPlugin(new UitkDropDownGeometryReplicatorForMercury());
});



/// <amd-module name="typeahead/features/UnspecifiedAreaRequestParamModifier" />
require(["require","exports","typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils","universalTypeahead"], function(require,exports,SuggestServiceQueryParamsUtils_1,universalTypeahead_1){
    "use strict";
    exports.__esModule = true;
    var configuration = [{
            lobs: ["NONE"]
        }];
    var featureFlag = "unspecified_area";
    var UnspecifiedAreaRequestParamModifier = (function () {
        function UnspecifiedAreaRequestParamModifier() {
        }
        UnspecifiedAreaRequestParamModifier.prototype.modifyParameters = function (params, context, options) {
            return SuggestServiceQueryParamsUtils_1.addFeatureFlag(featureFlag, configuration, params, context, options);
        };
        return UnspecifiedAreaRequestParamModifier;
    }());
universalTypeahead_1.registerPlugin(new UnspecifiedAreaRequestParamModifier());
});



define("typeahead/client/ClientHandlerRegistry", ["require", "exports", "typeahead/core/context", "typeahead/core/message/FormSubmittedMessage", "typeahead/core/message/SubmitClickedMessage", "typeahead/core/message/TypeaheadMessage", "typeahead/core/message/UserExitedMessage", "typeahead/core/TypeaheadUtils"], function (require, exports, coreContext, FormSubmittedMessage_1, SubmitClickedMessage_1, TypeaheadMessage_1, UserExitedMessage_1, TypeaheadUtils_1) {
    "use strict";
    exports.__esModule = true;
    var ClientHandlerRegistry = (function () {
        function ClientHandlerRegistry() {
        }
        ClientHandlerRegistry.handlePageLoad = function () {
            var clientId = TypeaheadUtils_1.TypeaheadUtils.getClientId();
            ClientHandlerRegistry.client = ClientHandlerRegistry.getClientHandler(clientId);
            ClientHandlerRegistry.client.subscribeFormLoadedEvent();
            ClientHandlerRegistry.client.subscribeFormSubmitEvent();
        };
        ClientHandlerRegistry.getTab = function () {
            return ClientHandlerRegistry.client ? ClientHandlerRegistry.client.getTab() : undefined;
        };
        ClientHandlerRegistry.registerClient = function (client) {
            if (ClientHandlerRegistry.allClients.indexOf(client) < 0) {
                ClientHandlerRegistry.allClients.push(client);
            }
        };
        ClientHandlerRegistry.publishSubmitClickedMessage = function (rfrrIdPrefix, event) {
            TypeaheadMessage_1.TypeaheadMessage.publish(new SubmitClickedMessage_1.SubmitClickedMessage(rfrrIdPrefix, event));
            TypeaheadMessage_1.TypeaheadMessage.publish(new UserExitedMessage_1.UserExitedMessage());
        };
        ClientHandlerRegistry.publishFormSubmittedMessage = function (isFormValid) {
            TypeaheadMessage_1.TypeaheadMessage.publish(new FormSubmittedMessage_1.FormSubmittedMessage(isFormValid, coreContext));
        };
        ClientHandlerRegistry.getClientHandler = function (clientId) {
            var clientHandler = undefined;
            if (clientId) {
                for (var i = 0; i < ClientHandlerRegistry.allClients.length; i++) {
                    if (ClientHandlerRegistry.allClients[i].isApplicable(clientId)) {
                        clientHandler = ClientHandlerRegistry.allClients[i];
                        break;
                    }
                }
            }
            return clientHandler;
        };
        ClientHandlerRegistry.allClients = [];
        return ClientHandlerRegistry;
    }());
    exports.ClientHandlerRegistry = ClientHandlerRegistry;
});



///<amd-module name="typeahead/client/FlightSearchResultsPageHandler" />
define("typeahead/client/FlightSearchResultsPageHandler", ["require", "exports", "typeahead/client/ClientHandlerRegistry"], function (require, exports, ClientHandlerRegistry_1) {
    "use strict";
    exports.__esModule = true;
    var FlightSearchResultsPageHandler = (function () {
        function FlightSearchResultsPageHandler() {
        }
        FlightSearchResultsPageHandler.prototype.isApplicable = function (clientId) {
            return FlightSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
        };
        FlightSearchResultsPageHandler.prototype.subscribeFormSubmitEvent = function () {
            var that = this;
            $("body").on("click", "#flight-wizard-search-button", function () {
                var isFormValid = function () {
                    var validationElement = $("#validation-alert");
                    return !validationElement.length;
                };
                ClientHandlerRegistry_1.ClientHandlerRegistry.publishSubmitClickedMessage(FlightSearchResultsPageHandler.rfrrIdPrefix);
                if (isFormValid()) {
                    ClientHandlerRegistry_1.ClientHandlerRegistry.publishFormSubmittedMessage(true);
                }
            });
        };
        FlightSearchResultsPageHandler.prototype.subscribeFormLoadedEvent = function () {
            // TODO
        };
        FlightSearchResultsPageHandler.prototype.getTab = function () {
            return undefined;
        };
        FlightSearchResultsPageHandler.rfrrIdPrefix = "FLT.SR|UpdateSearch";
        FlightSearchResultsPageHandler.APPLICABLE_CLIENT_ID = "Flights.Search";
        return FlightSearchResultsPageHandler;
    }());
    exports.FlightSearchResultsPageHandler = FlightSearchResultsPageHandler;
});



///<amd-module name="typeahead/client/HotelSearchResultsPageHandler" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>
define("typeahead/client/HotelSearchResultsPageHandler", ["require", "exports", "typeahead/core/loc", "typeahead/client/ClientHandlerRegistry", "typeahead/core/message/FormLoadedMessage", "typeahead/core/message/TypeaheadMessage"], function (require, exports, loc, ClientHandlerRegistry_1, FormLoadedMessage_1, TypeaheadMessage_1) {
    "use strict";
    exports.__esModule = true;
    var HotelSearchResultsPageHandler = (function () {
        function HotelSearchResultsPageHandler() {
        }
        HotelSearchResultsPageHandler.prototype.isApplicable = function (clientId) {
            return HotelSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
        };
        HotelSearchResultsPageHandler.prototype.subscribeFormSubmitEvent = function () {
            var _this = this;
            var that = this;
            $("form").on("click", "button[type=submit]", function (event) {
                if ($(event.target).parents("form:has(input[data-provide=utypeahead])").length > 0) {
                    var rfrrIdPrefix = $(event.target).data("track"); // rfrrIdPrefix=HOT.SR.UpdateSearch
                    rfrrIdPrefix = rfrrIdPrefix.match(/(\w+).(\w+)/g)[0] + "|" + rfrrIdPrefix.match(/(\w+).(\w+)/g)[1];
                    // rfrrIdPrefix=HOT.SR|UpdateSearch
                    $(event.target).removeAttr("data-track");
                    ClientHandlerRegistry_1.ClientHandlerRegistry.publishSubmitClickedMessage(rfrrIdPrefix);
                }
            });
            uitk.subscribe(HotelSearchResultsPageHandler.HSR_SUBMIT_SHOW_ERRORS_MESSAGE, function (topic, submitObject) {
                ClientHandlerRegistry_1.ClientHandlerRegistry.publishFormSubmittedMessage(submitObject.isValid);
            });
            uitk.subscribe(HotelSearchResultsPageHandler.HSR_SUBMIT_GET_QUERY_MESSAGE, function (topic, submitObject) {
                _this.setLatLongForCurrentLocation(submitObject);
            });
        };
        HotelSearchResultsPageHandler.prototype.subscribeFormLoadedEvent = function () {
            uitk.subscribe(HotelSearchResultsPageHandler.SEARCH_WIZARD_OPENED_MESSAGE, function (message, $target) {
                if (HotelSearchResultsPageHandler.SEARCH_WIZARD_TOGGLE_BUTTON_ID === $target.attr("id")) {
                    TypeaheadMessage_1.TypeaheadMessage.publish(new FormLoadedMessage_1.FormLoadedMessage(undefined));
                }
            });
        };
        HotelSearchResultsPageHandler.prototype.getTab = function () {
            return undefined;
        };
        HotelSearchResultsPageHandler.prototype.setLatLongForCurrentLocation = function (submitObject) {
            var latLong = this.getLatLongFromUrl();
            if (this.isDestinationCurrentLocation() && latLong) {
                $("#latLong").val(latLong);
                if (submitObject.query && submitObject.query.indexOf("latLong") === -1) {
                    submitObject.query += "&latLong=" + latLong;
                }
            }
        };
        HotelSearchResultsPageHandler.prototype.getLatLongFromUrl = function () {
            var sanitize = function (latLong) {
                return (latLong && latLong.match(/^[+-]?\d+\.\d+,[+-]?\d+\.\d+$/)) ? latLong : undefined;
            };
            return sanitize(this.getRequestParameterValue("latLong"));
        };
        HotelSearchResultsPageHandler.prototype.isDestinationCurrentLocation = function () {
            var compareAndSanitize = function (destination) {
                if (destination) {
                    destination = destination.replace(/\+/g, " ");
                    return (loc.geolocationDisplayText === $("#inpSearchNear").val() &&
                        loc.geolocationDisplayText === destination);
                }
                return false;
            };
            return compareAndSanitize(this.getRequestParameterValue("destination"));
        };
        HotelSearchResultsPageHandler.prototype.getRequestParameterValue = function (parameter) {
            var result = new RegExp(parameter + "=([^&]*)&?").exec(decodeURIComponent(window.location.href));
            if (result && result.length && result[1]) {
                return result[1];
            }
            return undefined;
        };
        HotelSearchResultsPageHandler.APPLICABLE_CLIENT_ID = "Hotels.Search";
        HotelSearchResultsPageHandler.SEARCH_WIZARD_OPENED_MESSAGE = "toggle.opened";
        HotelSearchResultsPageHandler.SEARCH_WIZARD_TOGGLE_BUTTON_ID = "changeSearchWizard";
        /* HSRP publishes certain messages in an order during submit. "hsr.submit.showErrors" is published after client
            validation. The subscriber of this message can read the isValid property from the 'submitObject' which is also
            part of the message and perform certain operations based on the value of this flag.
        */
        HotelSearchResultsPageHandler.HSR_SUBMIT_SHOW_ERRORS_MESSAGE = "hsr.submit.showErrors";
        /* "hsr.submit.getQuery" is published during submit by HSRP after "hsr.submit.showErrors" if isValid flag in
         'submitObject' is true. The subscriber of this message in HSRP reads all the form elements and creates the request
         query. This query is set into the 'query' property in the submitObject.
         */
        HotelSearchResultsPageHandler.HSR_SUBMIT_GET_QUERY_MESSAGE = "hsr.submit.getQuery";
        return HotelSearchResultsPageHandler;
    }());
    exports.HotelSearchResultsPageHandler = HotelSearchResultsPageHandler;
});



define("typeahead/client/MercuryWizardHandler", ["require", "exports", "jquery", "typeahead/client/ClientHandlerRegistry", "typeahead/core/message/FormLoadedMessage", "typeahead/core/message/TypeaheadMessage"], function (require, exports, $, ClientHandlerRegistry_1, FormLoadedMessage_1, TypeaheadMessage_1) {
    "use strict";
    exports.__esModule = true;
    var MercuryWizardHandler = (function () {
        function MercuryWizardHandler() {
        }
        MercuryWizardHandler.prototype.isApplicable = function (clientId) {
            return MercuryWizardHandler.APPLICABLE_CLIENT_IDS.indexOf(clientId) > -1;
        };
        MercuryWizardHandler.prototype.subscribeFormSubmitEvent = function () {
            var that = this;
            $("form").on("click", "button[type=submit]", function (event) {
                if ($(event.target).parents("form:has(input[data-provide=utypeahead])").length > 0) {
                    ClientHandlerRegistry_1.ClientHandlerRegistry.publishSubmitClickedMessage(null, event);
                }
            });
            $("form:has(input[data-provide=utypeahead])").on("submit.typeahead", function () {
                var isFormValid = function () {
                    var validationElement = $("form:has(input[data-provide=utypeahead]):visible .validation-alert");
                    return validationElement.is(":hidden") || validationElement.hasClass("visuallyhidden");
                };
                setTimeout(function () {
                    ClientHandlerRegistry_1.ClientHandlerRegistry.publishFormSubmittedMessage(isFormValid());
                }, 0);
            });
        };
        MercuryWizardHandler.prototype.subscribeFormLoadedEvent = function () {
            var _this = this;
            var publishFormLoadedMessage = function () {
                TypeaheadMessage_1.TypeaheadMessage.publish(new FormLoadedMessage_1.FormLoadedMessage(_this.getTab()));
            };
            publishFormLoadedMessage(); // On Page Load
            uitk.subscribe("mercury-form-history-loaded", function () {
                publishFormLoadedMessage(); // On tab change
            });
        };
        MercuryWizardHandler.prototype.getTab = function () {
            return $("li.tab:visible").children("button.on").data("lob");
        };
        MercuryWizardHandler.APPLICABLE_CLIENT_IDS = [
            "Homepage",
            "AWSHomepage",
            "LXLandingPage",
            "CarsLandingPage",
            "FlightsLandingPage",
            "HotelsLandingPage",
            "PackageLandingPage",
            "RailsLandingPage",
        ];
        return MercuryWizardHandler;
    }());
    exports.MercuryWizardHandler = MercuryWizardHandler;
});



define("typeahead/client/OpenSearchPageHandler", ["require", "exports", "typeahead/client/ClientHandlerRegistry", "typeahead/core/message/SuggestionSelectedMessage", "typeahead/core/message/TypeaheadMessage"], function (require, exports, ClientHandlerRegistry_1, SuggestionSelectedMessage_1, TypeaheadMessage_1) {
    "use strict";
    exports.__esModule = true;
    var OpenSearchPageHandler = (function () {
        function OpenSearchPageHandler() {
        }
        OpenSearchPageHandler.prototype.isApplicable = function (clientId) {
            return OpenSearchPageHandler.APPLICABLE_CLIENT_ID === clientId;
        };
        OpenSearchPageHandler.prototype.subscribeFormSubmitEvent = function () {
            var _this = this;
            $("div.open-search-page").on("click", "button#search-button", function () {
                if ($("#uta-search-query").val()) {
                    _this.publishSubmitMessages();
                }
            });
            TypeaheadMessage_1.TypeaheadMessage.subscribe(SuggestionSelectedMessage_1.SuggestionSelectedMessage.getTopic(), function (topic, message) {
                setTimeout(function () {
                    _this.publishSubmitMessages();
                }, 0); // Do this after all other selection handlers have executed
            });
        };
        OpenSearchPageHandler.prototype.subscribeFormLoadedEvent = function () {
            // TODO
        };
        OpenSearchPageHandler.prototype.getTab = function () {
            return undefined;
        };
        OpenSearchPageHandler.prototype.publishSubmitMessages = function () {
            ClientHandlerRegistry_1.ClientHandlerRegistry.publishSubmitClickedMessage(OpenSearchPageHandler.rfrrIdPrefix);
            ClientHandlerRegistry_1.ClientHandlerRegistry.publishFormSubmittedMessage(true);
        };
        OpenSearchPageHandler.rfrrIdPrefix = "Open.Search|UpdateSearch";
        OpenSearchPageHandler.APPLICABLE_CLIENT_ID = "OpenSearchPage";
        return OpenSearchPageHandler;
    }());
    exports.OpenSearchPageHandler = OpenSearchPageHandler;
});


